(function ($) {
  var $ = (jQuery = $),
    cc = { sections: [] };
  (theme.cartNoteMonitor = {
    load: function ($notes) {
      $notes.on(
        "change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor",
        function () {
          theme.cartNoteMonitor.postUpdate($(this).val());
        }
      );
    },
    unload: function ($notes) {
      $notes.off(".themeCartNoteMonitor");
    },
    updateThrottleTimeoutId: -1,
    updateThrottleInterval: 500,
    postUpdate: function (val) {
      clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId),
        (theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(
          function () {
            $.post(
              theme.routes.cart_url + "/update.js",
              { note: val },
              function (data) {},
              "json"
            );
          },
          theme.cartNoteMonitor.updateThrottleInterval
        ));
    },
  }),
    (theme.Shopify = {
      formatMoney: function (t, r) {
        function e(t2, r2) {
          return t2 === void 0 ? r2 : t2;
        }
        function a(t2, r2, a2, o2) {
          if (
            ((r2 = e(r2, 2)),
            (a2 = e(a2, ",")),
            (o2 = e(o2, ".")),
            isNaN(t2) || t2 == null)
          )
            return 0;
          t2 = (t2 / 100).toFixed(r2);
          var n2 = t2.split(".");
          return (
            n2[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a2) +
            (n2[1] ? o2 + n2[1] : "")
          );
        }
        typeof t == "string" && (t = t.replace(".", ""));
        var o = "",
          n = /\{\{\s*(\w+)\s*\}\}/,
          i = r || this.money_format;
        switch (i.match(n)[1]) {
          case "amount":
            o = a(t, 2);
            break;
          case "amount_no_decimals":
            o = a(t, 0);
            break;
          case "amount_with_comma_separator":
            o = a(t, 2, ".", ",");
            break;
          case "amount_with_space_separator":
            o = a(t, 2, " ", ",");
            break;
          case "amount_with_period_and_space_separator":
            o = a(t, 2, " ", ".");
            break;
          case "amount_no_decimals_with_comma_separator":
            o = a(t, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            o = a(t, 0, " ", "");
            break;
          case "amount_with_apostrophe_separator":
            o = a(t, 2, "'", ".");
            break;
          case "amount_with_decimal_separator":
            o = a(t, 2, ".", ".");
        }
        return i.replace(n, o);
      },
      formatImage: function (originalImageUrl, format) {
        return originalImageUrl
          ? originalImageUrl.replace(
              /^(.*)\.([^\.]*)$/g,
              "$1_" + format + ".$2"
            )
          : "";
      },
      Image: {
        imageSize: function (t) {
          var e = t.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
          );
          return e !== null ? e[1] : null;
        },
        getSizedImageUrl: function (t, e) {
          if (e == null) return t;
          if (e == "master") return this.removeProtocol(t);
          var o = t.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (o != null) {
            var i = t.split(o[0]),
              r = o[0];
            return this.removeProtocol(i[0] + "_" + e + r);
          }
          return null;
        },
        removeProtocol: function (t) {
          return t.replace(/http(s)?:/, "");
        },
      },
    }),
    (theme.Disclosure = (function () {
      var selectors = {
          disclosureList: "[data-disclosure-list]",
          disclosureToggle: "[data-disclosure-toggle]",
          disclosureInput: "[data-disclosure-input]",
          disclosureOptions: "[data-disclosure-option]",
        },
        classes = { listVisible: "disclosure-list--visible" };
      function Disclosure($disclosure) {
        (this.$container = $disclosure),
          (this.cache = {}),
          this._cacheSelectors(),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut();
      }
      return (
        (Disclosure.prototype = $.extend({}, Disclosure.prototype, {
          _cacheSelectors: function () {
            this.cache = {
              $disclosureList: this.$container.find(selectors.disclosureList),
              $disclosureToggle: this.$container.find(
                selectors.disclosureToggle
              ),
              $disclosureInput: this.$container.find(selectors.disclosureInput),
              $disclosureOptions: this.$container.find(
                selectors.disclosureOptions
              ),
            };
          },
          _connectToggle: function () {
            this.cache.$disclosureToggle.on(
              "click",
              function (evt) {
                var ariaExpanded =
                  $(evt.currentTarget).attr("aria-expanded") === "true";
                $(evt.currentTarget).attr("aria-expanded", !ariaExpanded),
                  this.cache.$disclosureList.toggleClass(classes.listVisible);
              }.bind(this)
            );
          },
          _connectOptions: function () {
            this.cache.$disclosureOptions.on(
              "click",
              function (evt) {
                evt.preventDefault(),
                  this._submitForm($(evt.currentTarget).data("value"));
              }.bind(this)
            );
          },
          _onFocusOut: function () {
            this.cache.$disclosureToggle.on(
              "focusout",
              function (evt) {
                var disclosureLostFocus =
                  this.$container.has(evt.relatedTarget).length === 0;
                disclosureLostFocus && this._hideList();
              }.bind(this)
            ),
              this.cache.$disclosureList.on(
                "focusout",
                function (evt) {
                  var childInFocus =
                      $(evt.currentTarget).has(evt.relatedTarget).length > 0,
                    isVisible = this.cache.$disclosureList.hasClass(
                      classes.listVisible
                    );
                  isVisible && !childInFocus && this._hideList();
                }.bind(this)
              ),
              this.$container.on(
                "keyup",
                function (evt) {
                  evt.which === 27 &&
                    (this._hideList(), this.cache.$disclosureToggle.focus());
                }.bind(this)
              ),
              (this.bodyOnClick = function (evt) {
                var isOption = this.$container.has(evt.target).length > 0,
                  isVisible = this.cache.$disclosureList.hasClass(
                    classes.listVisible
                  );
                isVisible && !isOption && this._hideList();
              }.bind(this)),
              $("body").on("click", this.bodyOnClick);
          },
          _submitForm: function (value) {
            this.cache.$disclosureInput.val(value),
              this.$container.parents("form").submit();
          },
          _hideList: function () {
            this.cache.$disclosureList.removeClass(classes.listVisible),
              this.cache.$disclosureToggle.attr("aria-expanded", !1);
          },
          unload: function () {
            $("body").off("click", this.bodyOnClick),
              this.cache.$disclosureOptions.off(),
              this.cache.$disclosureToggle.off(),
              this.cache.$disclosureList.off(),
              this.$container.off();
          },
        })),
        Disclosure
      );
    })()),
    (function () {
      function throttle(callback, threshold) {
        var debounceTimeoutId = -1,
          tick = !1;
        return function () {
          clearTimeout(debounceTimeoutId),
            (debounceTimeoutId = setTimeout(callback, threshold)),
            tick ||
              (callback.call(),
              (tick = !0),
              setTimeout(function () {
                tick = !1;
              }, threshold));
        };
      }
      var scrollEvent = document.createEvent("Event");
      scrollEvent.initEvent("throttled-scroll", !0, !0),
        window.addEventListener(
          "scroll",
          throttle(function () {
            window.dispatchEvent(scrollEvent);
          }, 200)
        );
    })(),
    (theme.debounce = function (func) {
      var wait =
          arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 700,
        immediate = arguments.length > 2 ? arguments[2] : void 0,
        timeout;
      return function () {
        var context = this,
          args = arguments,
          later = function () {
            (timeout = null), immediate || func.apply(context, args);
          },
          callNow = immediate && !timeout;
        clearTimeout(timeout),
          (timeout = setTimeout(later, wait)),
          callNow && func.apply(context, args);
      };
    }),
    (theme.signup = function (container2, opts) {
      if (container2) {
        var $container = $(container2),
          finalOpts = opts || {
            inputCls: ".snippets-signup-emailinput",
            submitCls: ".snippets-signup-emailsubmit",
            msgCls: ".snippets-signup-message",
          };
        $container.find(finalOpts.submitCls).on("click", function () {
          var statusCalss = "requesting",
            $this = $(this),
            $message = $container.find(finalOpts.msgCls),
            $input = $container.find(finalOpts.inputCls),
            siteTag = $container.find("input[name='siteTag']").val(),
            errorText = $container.find("input[name='errorText']").val(),
            emptyText = $container.find("input[name='emptyText']").val(),
            successText = $container.find("input[name='successText']").val(),
            failText = $container.find("input[name='failText']").val(),
            reg =
              /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/gi,
            timer = null,
            resetMsg = function (resetInput) {
              timer = setTimeout(function () {
                $message.text("").removeClass("msg_error msg_success"),
                  resetInput && $input.val("");
              }, 5e3);
            },
            setErrorMsg = function (msg) {
              clearTimeout(timer),
                $message.text(msg).addClass("msg_error"),
                resetMsg();
            },
            setSuccessMsg = function (msg) {
              clearTimeout(timer),
                $message.text(msg).addClass("msg_success"),
                resetMsg(!0);
            },
            email = $input.val();
          if (!email) setErrorMsg(emptyText);
          else if (!reg.test(email)) setErrorMsg(errorText);
          else {
            if ($this.hasClass(statusCalss)) return;
            $this.addClass(statusCalss),
              $.ajax({
                type: "POST",
                url: "https://accounts-api-new.xgimi.com/api/v1/members/addMember",
                data: { email, tags: siteTag },
                complete: function () {
                  $this.removeClass(statusCalss);
                },
                error: function () {
                  setErrorMsg(failText);
                },
                success: function (data) {
                  setSuccessMsg(successText);
                },
              });
          }
        });
      }
    }),
    (theme.Sections = new (function () {
      var _ = this;
      (_._instances = []),
        (_._deferredSectionTargets = []),
        (_._sections = []),
        (_._deferredLoadViewportExcess = 300),
        (_._deferredWatcherRunning = !1),
        (_.init = function () {
          $(document)
            .on("shopify:section:load", function (e) {
              var target = _._themeSectionTargetFromShopifySectionTarget(
                e.target
              );
              target && _.sectionLoad(target);
            })
            .on("shopify:section:unload", function (e) {
              var target = _._themeSectionTargetFromShopifySectionTarget(
                e.target
              );
              target && _.sectionUnload(target);
            })
            .on("shopify:section:reorder", function (e) {
              var target = _._themeSectionTargetFromShopifySectionTarget(
                e.target
              );
              target && _.sectionReorder(target);
            }),
            $(window).on(
              "throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader",
              _._processDeferredSections
            ),
            (_._deferredWatcherRunning = !0);
        }),
        (_.register = function (type, section, options) {
          _._sections.push({
            type,
            section,
            afterSectionLoadCallback: options ? options.afterLoad : null,
            afterSectionUnloadCallback: options ? options.afterUnload : null,
          }),
            $('[data-section-type="' + type + '"]').each(function () {
              Shopify.designMode ||
              (options && options.deferredLoad === !1) ||
              !_._deferredWatcherRunning
                ? _.sectionLoad(this)
                : _.sectionDeferredLoad(this, options);
            });
        }),
        (_.sectionDeferredLoad = function (target, options) {
          _._deferredSectionTargets.push({
            target,
            deferredLoadViewportExcess:
              options && options.deferredLoadViewportExcess
                ? options.deferredLoadViewportExcess
                : _._deferredLoadViewportExcess,
          }),
            _._processDeferredSections(!0);
        }),
        (_._processDeferredSections = function (firstRunCheck) {
          if (_._deferredSectionTargets.length)
            for (
              var viewportTop = $(window).scrollTop(),
                viewportBottom = viewportTop + $(window).height(),
                loopStart =
                  firstRunCheck === !0
                    ? _._deferredSectionTargets.length - 1
                    : 0,
                i = loopStart;
              i < _._deferredSectionTargets.length;
              i++
            ) {
              var target = _._deferredSectionTargets[i].target,
                viewportExcess =
                  _._deferredSectionTargets[i].deferredLoadViewportExcess,
                sectionTop = $(target).offset().top - viewportExcess,
                doLoad =
                  sectionTop > viewportTop && sectionTop < viewportBottom;
              if (!doLoad) {
                var sectionBottom =
                  sectionTop + $(target).outerHeight() + viewportExcess * 2;
                doLoad =
                  sectionBottom > viewportTop && sectionBottom < viewportBottom;
              }
              (doLoad ||
                (sectionTop < viewportTop && sectionBottom > viewportBottom)) &&
                (_.sectionLoad(target),
                _._deferredSectionTargets.splice(i, 1),
                i--);
            }
          firstRunCheck !== !0 &&
            _._deferredSectionTargets.length === 0 &&
            ((_._deferredWatcherRunning = !1),
            $(window).off(".themeSectionDeferredLoader"));
        }),
        (_.sectionLoad = function (target) {
          var target = target,
            sectionObj = _._sectionForTarget(target),
            section = !1;
          if (
            (sectionObj.section
              ? (section = sectionObj.section)
              : (section = sectionObj),
            section !== !1)
          ) {
            var instance = {
              target,
              section,
              $shopifySectionContainer: $(target).closest(".shopify-section"),
              thisContext: {
                functions: section.functions,
                registeredEventListeners: [],
              },
            };
            if (
              ((instance.thisContext.registerEventListener =
                _._registerEventListener.bind(instance.thisContext)),
              _._instances.push(instance),
              $(target).data("components"))
            ) {
              var components = $(target).data("components").split(",");
              components.forEach((component) => {
                $(document).trigger("cc:component:load", [component, target]);
              });
            }
            _._callSectionWith(
              section,
              "onSectionLoad",
              target,
              instance.thisContext
            ),
              _._callSectionWith(
                section,
                "afterSectionLoadCallback",
                target,
                instance.thisContext
              ),
              section.onSectionSelect &&
                instance.$shopifySectionContainer.on(
                  "shopify:section:select",
                  function (e) {
                    _._callSectionWith(
                      section,
                      "onSectionSelect",
                      e.target,
                      instance.thisContext
                    );
                  }
                ),
              section.onSectionDeselect &&
                instance.$shopifySectionContainer.on(
                  "shopify:section:deselect",
                  function (e) {
                    _._callSectionWith(
                      section,
                      "onSectionDeselect",
                      e.target,
                      instance.thisContext
                    );
                  }
                ),
              section.onBlockSelect &&
                $(target).on("shopify:block:select", function (e) {
                  _._callSectionWith(
                    section,
                    "onBlockSelect",
                    e.target,
                    instance.thisContext
                  );
                }),
              section.onBlockDeselect &&
                $(target).on("shopify:block:deselect", function (e) {
                  _._callSectionWith(
                    section,
                    "onBlockDeselect",
                    e.target,
                    instance.thisContext
                  );
                });
          }
        }),
        (_.sectionUnload = function (target) {
          for (
            var sectionObj = _._sectionForTarget(target),
              instanceIndex = -1,
              i = 0;
            i < _._instances.length;
            i++
          )
            _._instances[i].target == target && (instanceIndex = i);
          if (instanceIndex > -1) {
            var instance = _._instances[instanceIndex];
            if (
              ($(target).off("shopify:block:select shopify:block:deselect"),
              instance.$shopifySectionContainer.off(
                "shopify:section:select shopify:section:deselect"
              ),
              _._callSectionWith(
                instance.section,
                "onSectionUnload",
                target,
                instance.thisContext
              ),
              _._unloadRegisteredEventListeners(
                instance.thisContext.registeredEventListeners
              ),
              _._callSectionWith(
                sectionObj,
                "afterSectionUnloadCallback",
                target,
                instance.thisContext
              ),
              _._instances.splice(instanceIndex),
              $(target).data("components"))
            ) {
              var components = $(target).data("components").split(",");
              components.forEach((component) => {
                $(document).trigger("cc:component:unload", [component, target]);
              });
            }
          } else
            for (var i = 0; i < _._deferredSectionTargets.length; i++)
              if (_._deferredSectionTargets[i].target == target) {
                _._deferredSectionTargets[i].splice(i, 1);
                break;
              }
        }),
        (_.sectionReorder = function (target) {
          for (var instanceIndex = -1, i = 0; i < _._instances.length; i++)
            _._instances[i].target == target && (instanceIndex = i);
          if (instanceIndex > -1) {
            var instance = _._instances[instanceIndex];
            _._callSectionWith(
              instance.section,
              "onSectionReorder",
              target,
              instance.thisContext
            );
          }
        }),
        (_._registerEventListener = function (element, eventType, callback) {
          element.addEventListener(eventType, callback),
            this.registeredEventListeners.push({
              element,
              eventType,
              callback,
            });
        }),
        (_._unloadRegisteredEventListeners = function (
          registeredEventListeners
        ) {
          registeredEventListeners.forEach((rel) => {
            rel.element.removeEventListener(rel.eventType, rel.callback);
          });
        }),
        (_._callSectionWith = function (
          section,
          method,
          container2,
          thisContext
        ) {
          if (typeof section[method] == "function")
            try {
              thisContext
                ? section[method].bind(thisContext)(container2)
                : section[method](container2);
            } catch (ex) {
              var sectionType = container2.dataset.sectionType;
              console.warn(
                "Theme warning: '"
                  .concat(method, "' failed for section '")
                  .concat(sectionType, "'")
              ),
                console.debug(container2, ex);
            }
        }),
        (_._themeSectionTargetFromShopifySectionTarget = function (target) {
          var $target = $("[data-section-type]:first", target);
          return $target.length > 0 ? $target[0] : !1;
        }),
        (_._sectionForTarget = function (target) {
          for (
            var type = $(target).attr("data-section-type"), i = 0;
            i < _._sections.length;
            i++
          )
            if (_._sections[i].type == type) return _._sections[i];
          return !1;
        }),
        (_._sectionAlreadyRegistered = function (type) {
          for (var i = 0; i < _._sections.length; i++)
            if (_._sections[i].type == type) return !0;
          return !1;
        });
    })()),
    (theme.scriptsLoaded = {}),
    (theme.loadScriptOnce = function (src, callback, beforeRun, sync) {
      if (typeof theme.scriptsLoaded[src] > "u") {
        theme.scriptsLoaded[src] = [];
        var tag = document.createElement("script");
        (tag.src = src),
          (sync || beforeRun) && (tag.async = !1),
          beforeRun && beforeRun(),
          typeof callback == "function" &&
            (theme.scriptsLoaded[src].push(callback),
            tag.readyState
              ? (tag.onreadystatechange = function () {
                  if (
                    tag.readyState == "loaded" ||
                    tag.readyState == "complete"
                  ) {
                    tag.onreadystatechange = null;
                    for (var i = 0; i < theme.scriptsLoaded[this].length; i++)
                      theme.scriptsLoaded[this][i]();
                    theme.scriptsLoaded[this] = !0;
                  }
                }.bind(src))
              : (tag.onload = function () {
                  for (var i = 0; i < theme.scriptsLoaded[this].length; i++)
                    theme.scriptsLoaded[this][i]();
                  theme.scriptsLoaded[this] = !0;
                }.bind(src)));
        var firstScriptTag = document.getElementsByTagName("script")[0];
        return firstScriptTag.parentNode.insertBefore(tag, firstScriptTag), !0;
      } else if (
        typeof theme.scriptsLoaded[src] == "object" &&
        typeof callback == "function"
      )
        theme.scriptsLoaded[src].push(callback);
      else return typeof callback == "function" && callback(), !1;
    }),
    (theme.loadStyleOnce = function (src) {
      var srcWithoutProtocol = src.replace(/^https?:/, "");
      if (
        !document.querySelector(
          'link[href="' + encodeURI(srcWithoutProtocol) + '"]'
        )
      ) {
        var tag = document.createElement("link");
        (tag.href = srcWithoutProtocol),
          (tag.rel = "stylesheet"),
          (tag.type = "text/css");
        var firstTag = document.getElementsByTagName("link")[0];
        firstTag.parentNode.insertBefore(tag, firstTag);
      }
    }),
    (theme.showQuickPopup = function (message, origin2) {
      var $origin = $(origin2),
        $popup = $('<div class="simple-popup"/>'),
        offs = $origin.offset(),
        originLeft = $origin[0].getBoundingClientRect().left;
      $popup.html(message).css({ left: offs.left, top: offs.top }).hide(),
        $("body").append($popup);
      var marginLeft = -($popup.outerWidth() - $origin.outerWidth()) / 2;
      originLeft + marginLeft < 0 &&
        (marginLeft -= originLeft + marginLeft - 2);
      var offRight = offs.left + marginLeft + $popup.outerWidth() + 5;
      offRight > window.innerWidth &&
        (marginLeft -= offRight - window.innerWidth),
        $popup.css({ marginTop: -$popup.outerHeight() - 10, marginLeft }),
        $popup
          .fadeIn(200)
          .delay(3500)
          .fadeOut(400, function () {
            $(this).remove();
          });
    });
  class ccComponent {
    constructor(name) {
      var cssSelector =
          arguments.length > 1 && arguments[1] !== void 0
            ? arguments[1]
            : ".cc-".concat(name),
        _this = this;
      (this.instances = []),
        $(document).on(
          "cc:component:load",
          function (event, component, target) {
            component === name &&
              $(target)
                .find("".concat(cssSelector, ":not(.cc-initialized)"))
                .each(function () {
                  _this.init(this);
                });
          }
        ),
        $(document).on(
          "cc:component:unload",
          function (event, component, target) {
            component === name &&
              $(target)
                .find(cssSelector)
                .each(function () {
                  _this.destroy(this);
                });
          }
        ),
        $(cssSelector).each(function () {
          _this.init(this);
        });
    }
    init(container2) {
      $(container2).addClass("cc-initialized");
    }
    destroy(container2) {
      $(container2).removeClass("cc-initialized");
    }
    registerInstance(container2, instance) {
      this.instances.push({ container: container2, instance });
    }
    destroyInstance(container2) {
      this.instances = this.instances.filter((item) => {
        if (item.container === container2)
          return (
            typeof item.instance.destroy == "function" &&
              item.instance.destroy(),
            item.container !== container2
          );
      });
    }
  }
  (theme.createTemplateVariableEncoder = function () {
    return {
      utilityElement: document.createElement("div"),
      values: {},
      add: function (key, value, type) {
        switch (type) {
          case "attribute":
            (this.utilityElement.innerHTML = ""),
              this.utilityElement.setAttribute("util", value),
              (this.values[key] =
                this.utilityElement.outerHTML.match(/util="([^"]*)"/)[1]);
            break;
          case "html":
            (this.utilityElement.innerText = value),
              (this.values[key] = this.utilityElement.innerHTML);
            break;
          case "raw":
            this.values[key] = value;
            break;
          default:
            throw "Type '".concat(type, "' not handled");
        }
      },
    };
  }),
    (theme.suffixIds = function (container2, suffix) {
      var refAttrs = ["aria-describedby", "aria-controls"];
      (suffix = "-" + suffix),
        container2.querySelectorAll("[id]").forEach((el) => {
          var oldId = el.id,
            newId = oldId + suffix;
          (el.id = newId),
            refAttrs.forEach((attr) => {
              container2
                .querySelectorAll("[".concat(attr, '="').concat(oldId, '"]'))
                .forEach((refEl) => {
                  refEl.setAttribute(attr, newId);
                });
            });
        });
    }),
    (theme.renderUnitPrice = function (
      unit_price,
      unit_price_measurement,
      money_format
    ) {
      if (unit_price && unit_price_measurement) {
        var unitPriceHtml = '<div class="unit-price">';
        (unitPriceHtml += '<span class="unit-price__price theme-money">'.concat(
          theme.Shopify.formatMoney(unit_price, money_format),
          "</span>"
        )),
          (unitPriceHtml += '<span class="unit-price__separator">'.concat(
            theme.strings.products_product_unit_price_separator,
            "</span>"
          ));
        var unit = unit_price_measurement.reference_unit;
        return (
          unit_price_measurement.reference_value != 1 &&
            (unit = unit_price_measurement.reference_value + unit),
          (unitPriceHtml += '<span class="unit-price__unit">'.concat(
            unit,
            "</span>"
          )),
          (unitPriceHtml += "</div>"),
          unitPriceHtml
        );
      } else return "";
    });
  class ccPopup {
    constructor($container, namespace) {
      (this.$container = $container),
        (this.namespace = namespace),
        (this.cssClasses = {
          visible: "cc-popup--visible",
          bodyNoScroll: "cc-popup-no-scroll",
          bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right",
        });
    }
    open(callback) {
      if (this.$container.data("freeze-scroll")) {
        clearTimeout(theme.ccPopupRemoveScrollFreezeTimeoutId),
          $("body").addClass(this.cssClasses.bodyNoScroll);
        var scrollDiv = document.createElement("div");
        (scrollDiv.className = "popup-scrollbar-measure"),
          document.body.appendChild(scrollDiv);
        var scrollbarWidth =
          scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv),
          scrollbarWidth > 0 &&
            $("body")
              .css("padding-right", scrollbarWidth + "px")
              .addClass(this.cssClasses.bodyNoScrollPadRight);
      }
      this.$container.addClass(this.cssClasses.visible),
        (this.previouslyActiveElement = document.activeElement),
        setTimeout(() => {
          this.$container.find(".cc-popup-close")[0].focus();
        }, 500),
        $(window).on("keydown" + this.namespace, (event) => {
          event.keyCode === 27 && this.close();
        }),
        callback && callback();
    }
    close(callback) {
      this.$container.removeClass(this.cssClasses.visible),
        this.previouslyActiveElement && $(this.previouslyActiveElement).focus(),
        $(window).off("keydown" + this.namespace);
      var $visibleFreezePopups = $("." + this.cssClasses.visible).filter(() =>
        this.$container.data("freeze-scroll")
      );
      if ($visibleFreezePopups.length === 0) {
        var transitionDuration = 500,
          $innerModal = this.$container.find(".cc-popup-modal");
        $innerModal.length &&
          ((transitionDuration = parseFloat(
            getComputedStyle($innerModal[0]).transitionDuration
          )),
          transitionDuration &&
            transitionDuration > 0 &&
            (transitionDuration *= 1e3)),
          (theme.ccPopupRemoveScrollFreezeTimeoutId = setTimeout(() => {
            $("body")
              .removeClass(this.cssClasses.bodyNoScroll)
              .removeClass(this.cssClasses.bodyNoScrollPadRight)
              .css("padding-right", "0");
          }, transitionDuration));
      }
      callback && callback();
    }
  }
  (() => {
    (theme.initAnimateOnScroll = function () {
      if (
        document.body.classList.contains("cc-animate-enabled") &&
        window.innerWidth >= 768
      ) {
        var animationTimeout =
          typeof document.body.dataset.ccAnimateTimeout < "u"
            ? document.body.dataset.ccAnimateTimeout
            : 200;
        if ("IntersectionObserver" in window) {
          var intersectionObserver = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                entry.isIntersecting &&
                  !entry.target.classList.contains("cc-animate-complete") &&
                  (setTimeout(() => {
                    entry.target.classList.add("-in", "cc-animate-complete");
                  }, animationTimeout),
                  setTimeout(() => {
                    entry.target.classList.remove("data-cc-animate"),
                      (entry.target.style.transitionDuration = null),
                      (entry.target.style.transitionDelay = null);
                  }, 5e3),
                  observer.unobserve(entry.target));
              });
            }
          );
          document
            .querySelectorAll("[data-cc-animate]:not(.cc-animate-init)")
            .forEach((elem) => {
              elem.dataset.ccAnimateDelay &&
                (elem.style.transitionDelay = elem.dataset.ccAnimateDelay),
                elem.dataset.ccAnimateDuration &&
                  (elem.style.transitionDuration =
                    elem.dataset.ccAnimateDuration),
                elem.dataset.ccAnimate &&
                  elem.classList.add(elem.dataset.ccAnimate),
                elem.classList.add("cc-animate-init"),
                intersectionObserver.observe(elem);
            });
        } else
          for (
            var elems = document.querySelectorAll(
                "[data-cc-animate]:not(.cc-animate-init)"
              ),
              i = 0;
            i < elems.length;
            i++
          )
            elems[i].classList.add("-in", "cc-animate-complete");
      }
    }),
      theme.initAnimateOnScroll(),
      document.addEventListener("shopify:section:load", () => {
        setTimeout(theme.initAnimateOnScroll, 100);
      });
    try {
      window
        .matchMedia("(min-width: 768px)")
        .addEventListener("change", (event) => {
          event.matches && setTimeout(theme.initAnimateOnScroll, 100);
        });
    } catch {}
  })();
  class AccordionInstance {
    constructor(container2) {
      (this.accordion = container2),
        (this.itemClass = ".cc-accordion-item"),
        (this.titleClass = ".cc-accordion-item__title"),
        (this.panelClass = ".cc-accordion-item__panel"),
        (this.allowMultiOpen =
          this.accordion.dataset.allowMultiOpen === "true"),
        this.allowMultiOpen ||
          (this.activeItem = this.accordion.querySelector(
            "".concat(this.itemClass, "[open]")
          )),
        this.bindEvents();
    }
    static addPanelHeight(panel) {
      panel.style.height = "".concat(panel.scrollHeight, "px");
    }
    static removePanelHeight(panel) {
      panel.getAttribute("style"), panel.removeAttribute("style");
    }
    open(item, panel) {
      if (
        ((panel.style.height = "0"),
        (item.open = !0),
        AccordionInstance.addPanelHeight(panel),
        setTimeout(() => {
          item.classList.add("is-open");
        }, 10),
        !this.allowMultiOpen)
      ) {
        if (this.activeItem && this.activeItem !== item) {
          var activePanel = this.activeItem.querySelector(this.panelClass);
          this.close(this.activeItem, activePanel);
        }
        this.activeItem = item;
      }
    }
    close(item, panel) {
      AccordionInstance.addPanelHeight(panel),
        item.classList.remove("is-open"),
        item.classList.add("is-closing"),
        this.activeItem === item && (this.activeItem = null),
        setTimeout(() => {
          panel.style.height = "0";
        }, 10);
    }
    handleClick(e) {
      var toggle = e.target.closest(this.titleClass);
      if (toggle) {
        e.preventDefault();
        var item = toggle.parentNode,
          panel = toggle.nextElementSibling;
        item.open ? this.close(item, panel) : this.open(item, panel);
      }
    }
    handleTransition(e) {
      if (e.target.matches(this.panelClass)) {
        var panel = e.target,
          item = panel.parentNode;
        item.classList.contains("is-closing") &&
          (item.classList.remove("is-closing"), (item.open = !1)),
          AccordionInstance.removePanelHeight(panel);
      }
    }
    bindEvents() {
      (this.clickHandler = this.handleClick.bind(this)),
        (this.transitionHandler = this.handleTransition.bind(this)),
        this.accordion.addEventListener("click", this.clickHandler),
        this.accordion.addEventListener(
          "transitionend",
          this.transitionHandler
        );
    }
    destroy() {
      this.accordion.removeEventListener("click", this.clickHandler),
        this.accordion.removeEventListener(
          "transitionend",
          this.transitionHandler
        );
    }
  }
  class Accordion extends ccComponent {
    constructor() {
      var name =
          arguments.length > 0 && arguments[0] !== void 0
            ? arguments[0]
            : "accordion",
        cssSelector =
          arguments.length > 1 && arguments[1] !== void 0
            ? arguments[1]
            : ".cc-".concat(name);
      super(name, cssSelector);
    }
    init(container2) {
      super.init(container2),
        this.registerInstance(container2, new AccordionInstance(container2));
    }
    destroy(container2) {
      this.destroyInstance(container2), super.destroy(container2);
    }
  }
  new Accordion();
  class CustomSelectInstance {
    constructor(el) {
      (this.el = el),
        (this.button = el.querySelector(".cc-select__btn")),
        (this.listbox = el.querySelector(".cc-select__listbox")),
        (this.options = el.querySelectorAll(".cc-select__option")),
        (this.selectedOption = el.querySelector('[aria-selected="true"]')),
        (this.nativeSelect = document.getElementById(
          "".concat(el.id, "-native")
        )),
        (this.swatches =
          "swatch" in this.options[this.options.length - 1].dataset),
        (this.focusedClass = "is-focused"),
        (this.searchString = ""),
        (this.listboxOpen = !1),
        this.selectedOption ||
          (this.selectedOption = this.listbox.firstElementChild),
        this.bindEvents(),
        this.setButtonWidth();
    }
    bindEvents() {
      this.el.addEventListener("keydown", this.handleKeydown.bind(this)),
        this.el.addEventListener(
          "selectOption",
          this.handleSelectOption.bind(this)
        ),
        this.button.addEventListener(
          "mousedown",
          this.handleMousedown.bind(this)
        );
    }
    addListboxOpenEvents() {
      (this.mouseoverHandler = this.handleMouseover.bind(this)),
        (this.mouseleaveHandler = this.handleMouseleave.bind(this)),
        (this.clickHandler = this.handleClick.bind(this)),
        (this.blurHandler = this.handleBlur.bind(this)),
        this.listbox.addEventListener("mouseover", this.mouseoverHandler),
        this.listbox.addEventListener("mouseleave", this.mouseleaveHandler),
        this.listbox.addEventListener("click", this.clickHandler),
        this.listbox.addEventListener("blur", this.blurHandler);
    }
    removeListboxOpenEvents() {
      this.listbox.removeEventListener("mouseover", this.mouseoverHandler),
        this.listbox.removeEventListener("mouseleave", this.mouseleaveHandler),
        this.listbox.removeEventListener("click", this.clickHandler),
        this.listbox.removeEventListener("blur", this.blurHandler);
    }
    handleKeydown(e) {
      this.listboxOpen
        ? this.handleKeyboardNav(e)
        : (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === " ") &&
          (e.preventDefault(), this.showListbox());
    }
    handleMousedown(e) {
      !this.listboxOpen && e.button === 0 && this.showListbox();
    }
    handleMouseover(e) {
      e.target.matches("li") && this.focusOption(e.target);
    }
    handleMouseleave() {
      this.focusOption(this.selectedOption);
    }
    handleClick(e) {
      e.target.matches(".js-option") && this.selectOption(e.target);
    }
    handleBlur() {
      this.listboxOpen && this.hideListbox();
    }
    handleKeyboardNav(e) {
      var optionToFocus;
      switch ((e.key === "Tab" && e.preventDefault(), e.key)) {
        case "ArrowUp":
        case "ArrowDown":
          e.preventDefault(),
            e.key === "ArrowUp"
              ? (optionToFocus = this.focusedOption.previousElementSibling)
              : (optionToFocus = this.focusedOption.nextElementSibling),
            optionToFocus &&
              !optionToFocus.classList.contains("is-disabled") &&
              this.focusOption(optionToFocus);
          break;
        case "Enter":
        case " ":
          e.preventDefault(), this.selectOption(this.focusedOption);
          break;
        case "Escape":
          e.preventDefault(), this.hideListbox();
          break;
        default:
          (optionToFocus = this.findOption(e.key)),
            optionToFocus && this.focusOption(optionToFocus);
          break;
      }
    }
    setButtonWidth() {
      var getUnpaddedWidth = (el) => {
          var elStyle = getComputedStyle(el);
          return (
            parseFloat(elStyle.paddingLeft) + parseFloat(elStyle.paddingRight)
          );
        },
        buttonPadding = getUnpaddedWidth(this.button),
        optionPadding = getUnpaddedWidth(this.selectedOption),
        buttonBorder = this.button.offsetWidth - this.button.clientWidth,
        optionWidth = Math.ceil(
          this.selectedOption.getBoundingClientRect().width
        );
      this.button.style.width = "".concat(
        optionWidth - optionPadding + buttonPadding + buttonBorder,
        "px"
      );
    }
    showListbox() {
      (this.listbox.hidden = !1),
        (this.listboxOpen = !0),
        this.el.classList.add("is-open"),
        this.button.setAttribute("aria-expanded", "true"),
        this.listbox.setAttribute("aria-hidden", "false"),
        setTimeout(() => {
          this.focusOption(this.selectedOption),
            this.listbox.focus(),
            this.addListboxOpenEvents();
        }, 10);
    }
    hideListbox() {
      this.listboxOpen &&
        ((this.listbox.hidden = !0),
        (this.listboxOpen = !1),
        this.el.classList.remove("is-open"),
        this.button.setAttribute("aria-expanded", "false"),
        this.listbox.setAttribute("aria-hidden", "true"),
        this.focusedOption &&
          (this.focusedOption.classList.remove(this.focusedClass),
          (this.focusedOption = null)),
        this.button.focus(),
        this.removeListboxOpenEvents());
    }
    findOption(key) {
      (this.searchString += key),
        this.searchTimer && clearTimeout(this.searchTimer),
        (this.searchTimer = setTimeout(() => {
          this.searchString = "";
        }, 500));
      var matchingOption = [...this.options].find((option) => {
        var label = option.innerText.toLowerCase();
        return (
          label.includes(this.searchString) &&
          !option.classList.contains("is-disabled")
        );
      });
      return matchingOption;
    }
    focusOption(option) {
      if (
        (this.focusedOption &&
          this.focusedOption.classList.remove(this.focusedClass),
        (this.focusedOption = option),
        this.focusedOption.classList.add(this.focusedClass),
        this.listbox.scrollHeight > this.listbox.clientHeight)
      ) {
        var scrollBottom = this.listbox.clientHeight + this.listbox.scrollTop,
          optionBottom = option.offsetTop + option.offsetHeight;
        optionBottom > scrollBottom
          ? (this.listbox.scrollTop = optionBottom - this.listbox.clientHeight)
          : option.offsetTop < this.listbox.scrollTop &&
            (this.listbox.scrollTop = option.offsetTop);
      }
    }
    handleSelectOption(e) {
      var matchingOption = [...this.options].find(
        (option) => option.dataset.value === e.detail.value
      );
      matchingOption && this.selectOption(matchingOption);
    }
    selectOption(option) {
      if (option !== this.selectedOption)
        if (
          (option.setAttribute("aria-selected", "true"),
          this.selectedOption.setAttribute("aria-selected", "false"),
          this.swatches &&
            (option.dataset.swatch
              ? (this.button.dataset.swatch = option.dataset.swatch)
              : this.button.removeAttribute("data-swatch")),
          (this.button.firstChild.textContent =
            option.firstElementChild.textContent),
          this.listbox.setAttribute("aria-activedescendant", option.id),
          (this.selectedOption = document.getElementById(option.id)),
          this.nativeSelect)
        )
          (this.nativeSelect.value = option.dataset.value),
            this.nativeSelect.dispatchEvent(
              new Event("change", { bubbles: !0 })
            );
        else {
          var detail = { selectedValue: option.dataset.value };
          this.el.dispatchEvent(
            new CustomEvent("change", { bubbles: !0, detail })
          );
        }
      this.hideListbox();
    }
  }
  class CustomSelect extends ccComponent {
    constructor() {
      var name =
          arguments.length > 0 && arguments[0] !== void 0
            ? arguments[0]
            : "custom-select",
        cssSelector =
          arguments.length > 1 && arguments[1] !== void 0
            ? arguments[1]
            : ".cc-select";
      super(name, cssSelector);
    }
    init(container2) {
      super.init(container2),
        this.registerInstance(container2, new CustomSelectInstance(container2));
    }
    destroy(container2) {
      this.destroyInstance(container2), super.destroy(container2);
    }
  }
  new CustomSelect();
  class ModalInstance {
    constructor(container2) {
      (this.container = container2),
        (this.size = container2.dataset.ccModalSize || "medium"),
        (this.contentElement = document.querySelector(
          container2.dataset.ccModalContentelement
        )),
        this.container.addEventListener("click", this.handleClick.bind(this)),
        container2.dataset.ccModalLaunch === "true" &&
          setTimeout(this.open.bind(this), 10);
    }
    handleClick(e) {
      e.preventDefault(), this.open(), (this.opener = e.target);
    }
    open() {
      var tve = theme.createTemplateVariableEncoder();
      tve.add("size", this.size, "attribute"),
        tve.add("content", this.contentElement.innerHTML, "raw"),
        tve.add(
          "button_close_label",
          theme.strings.general_accessibility_labels_close,
          "attribute"
        ),
        tve.add("button_close_icon", theme.icons.close, "raw");
      var html = `
      <div class="cc-modal-window cc-modal-window--pre-reveal cc-modal-window--size-`
          .concat(
            tve.values.size,
            `">
        <div class="cc-modal-window__background"></div>
        <div class="cc-modal-window__foreground" role="dialog" aria-modal="true">
          <div class="cc-modal-window__content-container">
            <button class="cc-modal-window__close" aria-label="`
          )
          .concat(tve.values.button_close_label, '">')
          .concat(
            tve.values.button_close_icon,
            `</button>
            <div class="cc-modal-window__content">`
          )
          .concat(
            tve.values.content,
            `</div>
          </div>
        </div>
      </div>
    `
          ),
        modalElementFragment = document
          .createRange()
          .createContextualFragment(html);
      document.body.appendChild(modalElementFragment),
        document.body.classList.add("cc-modal-visible"),
        (this.modalElement = document.body.lastElementChild),
        this.modalElement
          .querySelector(".cc-modal-window__background")
          .addEventListener("click", this.close.bind(this)),
        this.modalElement
          .querySelector(".cc-modal-window__close")
          .addEventListener("click", this.close.bind(this)),
        setTimeout(() => {
          this.modalElement.classList.remove("cc-modal-window--pre-reveal"),
            this.modalElement.querySelector(".cc-modal-window__close").focus();
        }, 10);
    }
    close() {
      this.modalElement.classList.add("cc-modal-window--closing"),
        document.querySelector(
          ".cc-modal-window:not(.cc-modal-window--closing)"
        ) || document.body.classList.remove("cc-modal-visible"),
        this.opener &&
          setTimeout(() => {
            this.opener.focus();
          }, 10),
        setTimeout(
          function () {
            this.remove();
          }.bind(this.modalElement),
          5e3
        );
    }
  }
  class Modal extends ccComponent {
    constructor() {
      var name =
          arguments.length > 0 && arguments[0] !== void 0
            ? arguments[0]
            : "modal",
        cssSelector =
          arguments.length > 1 && arguments[1] !== void 0
            ? arguments[1]
            : ".cc-".concat(name);
      super(name, cssSelector);
    }
    init(container2) {
      super.init(container2),
        this.registerInstance(container2, new ModalInstance(container2));
    }
    destroy(container2) {
      this.destroyInstance(container2), super.destroy(container2);
    }
  }
  new Modal();
  class PriceRangeInstance {
    constructor(container2) {
      (this.container = container2),
        (this.selectors = {
          inputMin: ".cc-price-range__input--min",
          inputMax: ".cc-price-range__input--max",
          control: ".cc-price-range__control",
          controlMin: ".cc-price-range__control--min",
          controlMax: ".cc-price-range__control--max",
          bar: ".cc-price-range__bar",
          activeBar: ".cc-price-range__bar-active",
        }),
        (this.controls = {
          min: {
            barControl: container2.querySelector(this.selectors.controlMin),
            input: container2.querySelector(this.selectors.inputMin),
          },
          max: {
            barControl: container2.querySelector(this.selectors.controlMax),
            input: container2.querySelector(this.selectors.inputMax),
          },
        }),
        (this.controls.min.value = parseInt(
          this.controls.min.input.value === ""
            ? this.controls.min.input.placeholder
            : this.controls.min.input.value
        )),
        (this.controls.max.value = parseInt(
          this.controls.max.input.value === ""
            ? this.controls.max.input.placeholder
            : this.controls.max.input.value
        )),
        (this.valueMin = this.controls.min.input.min),
        (this.valueMax = this.controls.min.input.max),
        (this.valueRange = this.valueMax - this.valueMin),
        [this.controls.min, this.controls.max].forEach((item) => {
          item.barControl.setAttribute("aria-valuemin", this.valueMin),
            item.barControl.setAttribute("aria-valuemax", this.valueMax),
            item.barControl.setAttribute("tabindex", 0);
        }),
        this.controls.min.barControl.setAttribute(
          "aria-valuenow",
          this.controls.min.value
        ),
        this.controls.max.barControl.setAttribute(
          "aria-valuenow",
          this.controls.max.value
        ),
        (this.bar = container2.querySelector(this.selectors.bar)),
        (this.activeBar = container2.querySelector(this.selectors.activeBar)),
        (this.inDrag = !1),
        (this.rtl = document.querySelector("html[dir=rtl]")),
        this.bindEvents(),
        this.render();
    }
    getPxToValueRatio() {
      var r = this.bar.clientWidth / (this.valueMax - this.valueMin);
      return this.rtl ? -r : r;
    }
    getPcToValueRatio() {
      return 100 / (this.valueMax - this.valueMin);
    }
    setActiveControlValue(value) {
      isNaN(parseInt(value)) ||
        (this.activeControl === this.controls.min
          ? (value === "" && (value = this.valueMin),
            (value = Math.max(this.valueMin, value)),
            (value = Math.min(value, this.controls.max.value)))
          : (value === "" && (value = this.valueMax),
            (value = Math.min(this.valueMax, value)),
            (value = Math.max(value, this.controls.min.value))),
        (this.activeControl.value = Math.round(value)),
        this.activeControl.input.value != this.activeControl.value &&
          (this.activeControl.value == this.activeControl.input.placeholder
            ? (this.activeControl.input.value = "")
            : (this.activeControl.input.value = this.activeControl.value),
          this.activeControl.input.dispatchEvent(
            new CustomEvent("change", {
              bubbles: !0,
              cancelable: !1,
              detail: { sender: "theme:component:price_range" },
            })
          )),
        this.activeControl.barControl.setAttribute(
          "aria-valuenow",
          this.activeControl.value
        ));
    }
    render() {
      this.drawControl(this.controls.min),
        this.drawControl(this.controls.max),
        this.drawActiveBar();
    }
    drawControl(control) {
      var x = (control.value - this.valueMin) * this.getPcToValueRatio() + "%";
      this.rtl
        ? (control.barControl.style.right = x)
        : (control.barControl.style.left = x);
    }
    drawActiveBar() {
      var s =
          (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() +
          "%",
        e =
          (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() +
          "%";
      this.rtl
        ? ((this.activeBar.style.left = e), (this.activeBar.style.right = s))
        : ((this.activeBar.style.left = s), (this.activeBar.style.right = e));
    }
    handleControlTouchStart(e) {
      e.preventDefault(),
        this.startDrag(e.target, e.touches[0].clientX),
        (this.boundControlTouchMoveEvent =
          this.handleControlTouchMove.bind(this)),
        (this.boundControlTouchEndEvent =
          this.handleControlTouchEnd.bind(this)),
        window.addEventListener("touchmove", this.boundControlTouchMoveEvent),
        window.addEventListener("touchend", this.boundControlTouchEndEvent);
    }
    handleControlTouchMove(e) {
      this.moveDrag(e.touches[0].clientX);
    }
    handleControlTouchEnd(e) {
      e.preventDefault(),
        window.removeEventListener(
          "touchmove",
          this.boundControlTouchMoveEvent
        ),
        window.removeEventListener("touchend", this.boundControlTouchEndEvent),
        this.stopDrag();
    }
    handleControlMouseDown(e) {
      e.preventDefault(),
        this.startDrag(e.target, e.clientX),
        (this.boundControlMouseMoveEvent =
          this.handleControlMouseMove.bind(this)),
        (this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this)),
        window.addEventListener("mousemove", this.boundControlMouseMoveEvent),
        window.addEventListener("mouseup", this.boundControlMouseUpEvent);
    }
    handleControlMouseMove(e) {
      this.moveDrag(e.clientX);
    }
    handleControlMouseUp(e) {
      e.preventDefault(),
        window.removeEventListener(
          "mousemove",
          this.boundControlMouseMoveEvent
        ),
        window.removeEventListener("mouseup", this.boundControlMouseUpEvent),
        this.stopDrag();
    }
    startDrag(target, startX) {
      this.controls.min.barControl === target
        ? (this.activeControl = this.controls.min)
        : (this.activeControl = this.controls.max),
        (this.dragStartX = startX),
        (this.dragStartValue = this.activeControl.value),
        (this.inDrag = !0);
    }
    moveDrag(moveX) {
      if (this.inDrag) {
        var value =
          this.dragStartValue +
          (moveX - this.dragStartX) / this.getPxToValueRatio();
        this.setActiveControlValue(value), this.render();
      }
    }
    stopDrag() {
      this.inDrag = !1;
    }
    handleControlKeyDown(e) {
      e.key === "ArrowRight"
        ? this.incrementControlFromKeypress(e.target, 10)
        : e.key === "ArrowLeft" &&
          this.incrementControlFromKeypress(e.target, -10);
    }
    incrementControlFromKeypress(control, pxAmount) {
      this.controls.min.barControl === control
        ? (this.activeControl = this.controls.min)
        : (this.activeControl = this.controls.max),
        this.setActiveControlValue(
          this.activeControl.value + pxAmount / this.getPxToValueRatio()
        ),
        this.render();
    }
    handleInputChange(e) {
      (e.target.value = e.target.value.replace(/\D/g, "")),
        (!e.detail || e.detail.sender != "theme:component:price_range") &&
          (this.controls.min.input === e.target
            ? (this.activeControl = this.controls.min)
            : (this.activeControl = this.controls.max),
          this.setActiveControlValue(e.target.value),
          this.render());
    }
    handleInputKeyup(e) {
      setTimeout(
        function () {
          this.value = this.value.replace(/\D/g, "");
        }.bind(e.target),
        10
      );
    }
    bindEvents() {
      [this.controls.min, this.controls.max].forEach((item) => {
        item.barControl.addEventListener(
          "touchstart",
          this.handleControlTouchStart.bind(this)
        ),
          item.barControl.addEventListener(
            "mousedown",
            this.handleControlMouseDown.bind(this)
          ),
          item.barControl.addEventListener(
            "keydown",
            this.handleControlKeyDown.bind(this)
          ),
          item.input.addEventListener(
            "change",
            this.handleInputChange.bind(this)
          ),
          item.input.addEventListener(
            "keyup",
            this.handleInputKeyup.bind(this)
          );
      });
    }
    destroy() {}
  }
  class PriceRange extends ccComponent {
    constructor() {
      var name =
          arguments.length > 0 && arguments[0] !== void 0
            ? arguments[0]
            : "price-range",
        cssSelector =
          arguments.length > 1 && arguments[1] !== void 0
            ? arguments[1]
            : ".cc-".concat(name);
      super(name, cssSelector);
    }
    init(container2) {
      super.init(container2),
        this.registerInstance(container2, new PriceRangeInstance(container2));
    }
    destroy(container2) {
      this.destroyInstance(container2), super.destroy(container2);
    }
  }
  new PriceRange(),
    (theme.VideoManager = new (function () {
      var _ = this;
      (_.videos = { incrementor: 0, videoData: {} }),
        (_._loadYoutubeVideos = function (container2) {
          $(
            '.video-container[data-video-type="youtube"]:not(.video--init)',
            container2
          ).each(function () {
            $(this).addClass("video--init"), _.videos.incrementor++;
            var containerId = "theme-yt-video-" + _.videos.incrementor;
            $(this).data("video-container-id", containerId);
            var autoplay = $(this).data("video-autoplay"),
              loop = $(this).data("video-loop"),
              videoId = $(this).data("video-id"),
              isBackgroundVideo = $(this).hasClass(
                "video-container--background"
              ),
              ytURLSearchParams = new URLSearchParams(
                "iv_load_policy=3&modestbranding=1&rel=0&showinfo=0&enablejsapi=1&playslinline=1"
              );
            ytURLSearchParams.append(origin, location.origin),
              ytURLSearchParams.append("playlist", videoId),
              ytURLSearchParams.append("loop", loop ? 1 : 0),
              ytURLSearchParams.append("autoplay", 0);
            var src =
                "https://www.youtube.com/embed/" +
                videoId +
                "?" +
                ytURLSearchParams.toString(),
              $videoElement = $(
                '<iframe class="video-container__video-element" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">'
              )
                .attr({
                  id: containerId,
                  width: 640,
                  height: 360,
                  tabindex: isBackgroundVideo ? "-1" : null,
                })
                .appendTo($(".video-container__video", this));
            (_.videos.videoData[containerId] = {
              id: containerId,
              container: this,
              mute: () =>
                $videoElement[0].contentWindow.postMessage(
                  '{"event":"command","func":"mute","args":""}',
                  "*"
                ),
              play: () =>
                $videoElement[0].contentWindow.postMessage(
                  '{"event":"command","func":"playVideo","args":""}',
                  "*"
                ),
              pause: () =>
                $videoElement[0].contentWindow.postMessage(
                  '{"event":"command","func":"pauseVideo","args":""}',
                  "*"
                ),
              videoElement: $videoElement[0],
            }),
              autoplay &&
                $videoElement.on("load", () =>
                  setTimeout(() => {
                    _.videos.videoData[containerId].mute(),
                      _.videos.videoData[containerId].play(),
                      $(this).addClass("video-container--playing");
                  }, 100)
                ),
              isBackgroundVideo &&
                ($videoElement.attr("tabindex", "-1"),
                _._initBackgroundVideo(_.videos.videoData[containerId])),
              $videoElement.attr("src", src),
              fetch(
                "https://www.youtube.com/oembed?format=json&url=" +
                  encodeURIComponent($(this).data("video-url"))
              )
                .then((response) => {
                  if (!response.ok)
                    throw new Error(
                      "HTTP error! Status: ".concat(response.status)
                    );
                  return response.json();
                })
                .then((response) => {
                  response.width &&
                    response.height &&
                    ($videoElement.attr({
                      width: response.width,
                      height: response.height,
                    }),
                    _.videos.videoData[containerId].assessBackgroundVideo &&
                      _.videos.videoData[containerId].assessBackgroundVideo());
                });
          });
        }),
        (_._loadVimeoVideos = function (container2) {
          $(
            '.video-container[data-video-type="vimeo"]:not(.video--init)',
            container2
          ).each(function () {
            $(this).addClass("video--init"), _.videos.incrementor++;
            var containerId = "theme-vi-video-" + _.videos.incrementor;
            $(this).data("video-container-id", containerId);
            var autoplay = $(this).data("video-autoplay"),
              loop = $(this).data("video-loop"),
              videoId = $(this).data("video-id"),
              isBackgroundVideo = $(this).hasClass(
                "video-container--background"
              ),
              viURLSearchParams = new URLSearchParams();
            autoplay &&
              (viURLSearchParams.append("autoplay", 1),
              viURLSearchParams.append("muted", 1),
              $(this).addClass("video-container--playing")),
              loop && viURLSearchParams.append("loop", 1);
            var src =
                "https://player.vimeo.com/video/" +
                videoId +
                "?" +
                viURLSearchParams.toString(),
              $videoElement = $(
                '<iframe class="video-container__video-element" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">'
              )
                .attr({
                  id: containerId,
                  width: 640,
                  height: 360,
                  tabindex: isBackgroundVideo ? "-1" : null,
                })
                .appendTo($(".video-container__video", this));
            (_.videos.videoData[containerId] = {
              id: containerId,
              container: this,
              play: () =>
                $videoElement[0].contentWindow.postMessage(
                  '{"method":"play"}',
                  "*"
                ),
              pause: () =>
                $videoElement[0].contentWindow.postMessage(
                  '{"method":"pause"}',
                  "*"
                ),
              videoElement: $videoElement[0],
            }),
              isBackgroundVideo &&
                ($videoElement.attr("tabindex", "-1"),
                _._initBackgroundVideo(_.videos.videoData[containerId])),
              $videoElement.attr("src", src),
              fetch(
                "https://vimeo.com/api/oembed.json?url=" +
                  encodeURIComponent($(this).data("video-url"))
              )
                .then((response) => {
                  if (!response.ok)
                    throw new Error(
                      "HTTP error! Status: ".concat(response.status)
                    );
                  return response.json();
                })
                .then((response) => {
                  response.width &&
                    response.height &&
                    ($videoElement.attr({
                      width: response.width,
                      height: response.height,
                    }),
                    _.videos.videoData[containerId].assessBackgroundVideo &&
                      _.videos.videoData[containerId].assessBackgroundVideo());
                });
          });
        }),
        (_._loadMp4Videos = function (container2) {
          $(
            '.video-container[data-video-type="mp4"]:not(.video--init)',
            container2
          )
            .addClass("video--init")
            .each(function () {
              _.videos.incrementor++;
              var containerId = "theme-mp-video-" + _.videos.incrementor,
                $container = $(this);
              $(this).data("video-container-id", containerId);
              var $videoElement = $(
                  '<div class="video-container__video-element">'
                )
                  .attr("id", containerId)
                  .appendTo($(".video-container__video", this)),
                autoplay = $(this).data("video-autoplay"),
                $video = $("<video playsinline>");
              $(this).data("video-loop") && $video.attr("loop", "loop"),
                $video.on("click mouseenter", () =>
                  $video.attr("controls", "controls")
                ),
                autoplay &&
                  ($video.attr({ autoplay: "autoplay", muted: "muted" }),
                  ($video[0].muted = !0),
                  $video.one("loadeddata", function () {
                    this.play(),
                      $container.addClass("video-container--playing");
                  })),
                $video
                  .attr("src", $(this).data("video-url"))
                  .appendTo($videoElement);
              var videoData = (_.videos.videoData[containerId] = {
                element: $video[0],
                play: () => $video[0].play(),
                pause: () => $video[0].pause(),
              });
              $(this).hasClass("video-container--background") &&
                ($video.attr("tabindex", "-1"),
                autoplay &&
                  container2.addEventListener("click", videoData.play, {
                    once: !0,
                  }));
            });
        }),
        (_._initBackgroundVideo = function (videoData) {
          videoData.container.classList.contains(
            "video-container--background"
          ) &&
            ((videoData.assessBackgroundVideo = function () {
              var cw = this.offsetWidth,
                ch = this.offsetHeight,
                cr = cw / ch,
                frame = this.querySelector("iframe"),
                vr = parseFloat(frame.width) / parseFloat(frame.height),
                pan = this.querySelector(".video-container__video"),
                vCrop = 75;
              if (cr > vr) {
                var vh = cw / vr + vCrop * 2;
                (pan.style.marginTop = (ch - vh) / 2 - vCrop + "px"),
                  (pan.style.marginInlineStart = ""),
                  (pan.style.height = vh + vCrop * 2 + "px"),
                  (pan.style.width = "");
              } else {
                var ph = ch + vCrop * 2,
                  pw = ph * vr;
                (pan.style.marginTop = -vCrop + "px"),
                  (pan.style.marginInlineStart = (cw - pw) / 2 + "px"),
                  (pan.style.height = ph + "px"),
                  (pan.style.width = pw + "px");
              }
            }.bind(videoData.container)),
            videoData.assessBackgroundVideo(),
            $(window).on(
              "debouncedresize." + videoData.id,
              videoData.assessBackgroundVideo
            ),
            videoData.container.addEventListener("click", videoData.play, {
              once: !0,
            }));
        }),
        (_._unloadVideos = function (container2) {
          for (var dataKey in _.videos.videoData) {
            var data = _.videos.videoData[dataKey];
            if ($(container2).find(data.container).length) {
              delete _.videos.videoData[dataKey];
              return;
            }
          }
        }),
        (this.onSectionLoad = function (container2) {
          $(".video-container[data-video-url]:not([data-video-type])").each(
            function () {
              var url = $(this).data("video-url");
              url.indexOf(".mp4") > -1 &&
                $(this).attr("data-video-type", "mp4"),
                url.indexOf("vimeo.com") > -1 &&
                  ($(this).attr("data-video-type", "vimeo"),
                  $(this).attr(
                    "data-video-id",
                    url.split("?")[0].split("/").pop()
                  )),
                (url.indexOf("youtu.be") > -1 ||
                  url.indexOf("youtube.com") > -1) &&
                  ($(this).attr("data-video-type", "youtube"),
                  url.indexOf("v=") > -1
                    ? $(this).attr(
                        "data-video-id",
                        url.split("v=").pop().split("&")[0]
                      )
                    : $(this).attr(
                        "data-video-id",
                        url.split("?")[0].split("/").pop()
                      ));
            }
          ),
            _._loadYoutubeVideos(container2),
            _._loadVimeoVideos(container2),
            _._loadMp4Videos(container2),
            $(".video-container__play", container2).on("click", function (evt) {
              evt.preventDefault();
              var $container = $(this).closest(".video-container");
              $container.addClass("video-container--playing"),
                $container.trigger("cc:video:play");
              var id = $container.data("video-container-id");
              _.videos.videoData[id].play();
            }),
            $(".video-container__stop", container2).on("click", function (evt) {
              evt.preventDefault();
              var $container = $(this).closest(".video-container");
              $container.removeClass("video-container--playing"),
                $container.trigger("cc:video:stop");
              var id = $container.data("video-container-id");
              _.videos.videoData[id].pause();
            });
        }),
        (this.onSectionUnload = function (container2) {
          $(".video-container__play, .video-container__stop", container2).off(
            "click"
          ),
            $(window).off(
              "." + $(".video-container").data("video-container-id")
            ),
            $(window).off("debouncedresize.video-manager-resize"),
            _._unloadVideos(container2),
            $(container2).trigger("cc:video:stop");
        });
    })()),
    cc.sections.push({ name: "video", section: theme.VideoManager }),
    (theme.MapSection = new (function () {
      var _ = this;
      (_.config = {
        zoom: 14,
        styles: {
          default: [],
          silver: [
            { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f5f5" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#ffffff" }],
            },
            {
              featureType: "road.arterial",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#dadada" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#c9c9c9" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
          ],
          retro: [
            { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#523735" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry.stroke",
              stylers: [{ color: "#c9b2a6" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "geometry.stroke",
              stylers: [{ color: "#dcd2be" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#ae9e90" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#93817c" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#a5b076" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#447530" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#fdfcf8" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#f8c967" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#e9bc62" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#e98d58" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry.stroke",
              stylers: [{ color: "#db8555" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#806b63" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8f7d77" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#ebe3cd" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [{ color: "#b9d3c2" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#92998d" }],
            },
          ],
          dark: [
            { elementType: "geometry", stylers: [{ color: "#212121" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#212121" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "administrative.country",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "administrative.land_parcel",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#181818" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1b1b1b" }],
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: [{ color: "#2c2c2c" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8a8a8a" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#373737" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#3c3c3c" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#4e4e4e" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#000000" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3d3d3d" }],
            },
          ],
          night: [
            { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#746855" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#242f3e" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#263c3f" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6b9a76" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#38414e" }],
            },
            {
              featureType: "road",
              elementType: "geometry.stroke",
              stylers: [{ color: "#212a37" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9ca5b3" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#746855" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#1f2835" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#f3d19c" }],
            },
            {
              featureType: "transit",
              elementType: "geometry",
              stylers: [{ color: "#2f3948" }],
            },
            {
              featureType: "transit.station",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#17263c" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#515c6d" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#17263c" }],
            },
          ],
          aubergine: [
            { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#8ec3b9" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1a3646" }],
            },
            {
              featureType: "administrative.country",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#64779e" }],
            },
            {
              featureType: "administrative.province",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "landscape.man_made",
              elementType: "geometry.stroke",
              stylers: [{ color: "#334e87" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6f9ba5" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3C7680" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#304a7d" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#2c6675" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#255763" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#b0d5ce" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry.fill",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#3a4762" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#0e1626" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#4e6d70" }],
            },
          ],
        },
      }),
        (_.apiStatus = null),
        (this.geolocate = function ($map) {
          var deferred = $.Deferred(),
            geocoder = new google.maps.Geocoder(),
            address = $map.data("address-setting");
          return (
            geocoder.geocode({ address }, function (results, status2) {
              status2 !== google.maps.GeocoderStatus.OK &&
                deferred.reject(status2),
                deferred.resolve(results);
            }),
            deferred
          );
        }),
        (this.createMap = function (container2) {
          var $map = $(".map-section__map-container", container2);
          return _.geolocate($map)
            .then(
              function (results) {
                var mapOptions = {
                  zoom: _.config.zoom,
                  styles: _.config.styles[$(container2).data("map-style")],
                  center: results[0].geometry.location,
                  scrollwheel: !1,
                  disableDoubleClickZoom: !0,
                  disableDefaultUI: !0,
                  zoomControl: !$map.data("hide-zoom"),
                };
                (_.map = new google.maps.Map($map[0], mapOptions)),
                  (_.center = _.map.getCenter());
                var marker = new google.maps.Marker({
                  map: _.map,
                  position: _.center,
                  clickable: !1,
                });
                google.maps.event.addDomListener(window, "resize", function () {
                  google.maps.event.trigger(_.map, "resize"),
                    _.map.setCenter(_.center);
                });
              }.bind(this)
            )
            .fail(function () {
              var errorMessage;
              switch (status) {
                case "ZERO_RESULTS":
                  errorMessage = theme.strings.addressNoResults;
                  break;
                case "OVER_QUERY_LIMIT":
                  errorMessage = theme.strings.addressQueryLimit;
                  break;
                default:
                  errorMessage = theme.strings.addressError;
                  break;
              }
              if (Shopify.designMode) {
                var $mapContainer = $map.parents(".map-section");
                $mapContainer.addClass("page-width map-section--load-error"),
                  $mapContainer
                    .find(".map-section__wrapper")
                    .html(
                      '<div class="errors text-center">' +
                        errorMessage +
                        "</div>"
                    );
              }
            });
        }),
        (this.onSectionLoad = function (target) {
          var $container = $(target);
          window.gm_authFailure = function () {
            Shopify.designMode &&
              ($container.addClass("page-width map-section--load-error"),
              $container
                .find(".map-section__wrapper")
                .html(
                  '<div class="errors text-center">' +
                    theme.strings.authError +
                    "</div>"
                ));
          };
          var key = $container.data("api-key");
          typeof key != "string" ||
            key === "" ||
            theme.loadScriptOnce(
              "https://maps.googleapis.com/maps/api/js?key=" + key,
              function () {
                _.createMap($container);
              }
            );
        }),
        (this.onSectionUnload = function (target) {
          typeof window.google < "u" &&
            typeof google.maps < "u" &&
            google.maps.event.clearListeners(_.map, "resize");
        });
    })()),
    cc.sections.push({ name: "map", section: theme.MapSection }),
    (theme.FaqHeader = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.container = container2),
          (this.classNames = {
            questionContainerInactive: "faq-search-item-inactive",
            sectionWithIndexStatus: "section-faq-header--with-index",
          }),
          (this.searchInput =
            this.container.querySelector(".faq-search__input")),
          this.searchInput &&
            (this.registerEventListener(
              this.searchInput,
              "change",
              this.functions.performSearch.bind(this)
            ),
            this.registerEventListener(
              this.searchInput,
              "keyup",
              this.functions.performSearch.bind(this)
            ),
            this.registerEventListener(
              this.searchInput,
              "paste",
              this.functions.performSearch.bind(this)
            )),
          (this.functions.debouncedBuildIndex = theme.debounce(
            this.functions.buildIndex.bind(this),
            50
          )),
          this.registerEventListener(
            document,
            "theme:faq-header-update",
            this.functions.debouncedBuildIndex
          ),
          this.functions.debouncedBuildIndex(),
          this.container.querySelector(".faq-index") &&
            (this.registerEventListener(
              this.container,
              "click",
              this.functions.handleIndexClick.bind(this)
            ),
            this.container
              .closest(".section-faq-header")
              .classList.add(this.classNames.sectionWithIndexStatus),
            this.functions.resizeIndex.call(this),
            this.registerEventListener(
              window,
              "resize",
              theme.debounce(this.functions.resizeIndex.bind(this), 250)
            ));
      }),
        (this.onSectionReorder = function (container2) {
          this.functions.debouncedBuildIndex();
        }),
        (this.functions = {
          buildIndex: function () {
            var faqHeaderSection = this.container.closest(
                ".section-faq-header"
              ),
              indexContainer = this.container.querySelector(
                ".faq-index__item-container"
              );
            indexContainer &&
              indexContainer
                .querySelectorAll(".faq-index-item")
                .forEach((element) => {
                  element.parentNode.removeChild(element);
                }),
              (this.linkedCollapsibleTabs = []),
              (this.linkedQuestionContainers = []),
              (this.linkedContent = []);
            for (
              var currentElement = faqHeaderSection;
              currentElement.nextElementSibling &&
              currentElement.nextElementSibling.classList.contains(
                "section-collapsible-tabs"
              );

            )
              if (
                ((currentElement = currentElement.nextElementSibling),
                this.linkedCollapsibleTabs.push(currentElement),
                currentElement
                  .querySelectorAll(".collapsible-tabs__tab")
                  .forEach((element) =>
                    this.linkedQuestionContainers.push(element)
                  ),
                currentElement
                  .querySelectorAll(".collapsible-tabs__content")
                  .forEach((element) => this.linkedContent.push(element)),
                indexContainer)
              ) {
                var currentElementHeading = currentElement.querySelector(
                  ".collapsible-tabs__heading"
                );
                if (currentElementHeading) {
                  var tve = theme.createTemplateVariableEncoder();
                  tve.add("title_id", currentElementHeading.id, "attribute"),
                    tve.add("title", currentElementHeading.innerHTML, "raw");
                  var html = `
              <div class="faq-index-item">
                <a class="faq-index-item__link" href="#`
                      .concat(tve.values.title_id, '">')
                      .concat(
                        tve.values.title,
                        `</a>
              </div>`
                      ),
                    htmlFragment = document
                      .createRange()
                      .createContextualFragment(html);
                  indexContainer.appendChild(htmlFragment);
                }
              }
            indexContainer && this.functions.resizeIndex.call(this);
          },
          resizeIndex: function () {
            for (
              var stickyContainer = this.container.querySelector(
                  ".faq-index__sticky-container"
                ),
                faqHeaderSection = this.container.closest(
                  ".section-faq-header"
                ),
                currentElement = faqHeaderSection;
              currentElement.nextElementSibling &&
              currentElement.nextElementSibling.classList.contains(
                "section-collapsible-tabs"
              );

            )
              currentElement = currentElement.nextElementSibling;
            var stickyContainerRect = stickyContainer.getBoundingClientRect(),
              currentElementRect = currentElement.getBoundingClientRect();
            stickyContainer.style.height =
              currentElementRect.bottom - stickyContainerRect.top + "px";
          },
          performSearch: function () {
            setTimeout(() => {
              var splitValue = this.searchInput.value.split(" "),
                terms = [];
              splitValue.forEach((t) => {
                t.length > 0 && terms.push(t.toLowerCase());
              }),
                this.linkedQuestionContainers.forEach((element) => {
                  if (terms.length) {
                    var termFound = !1,
                      matchContent = element.textContent.toLowerCase();
                    terms.forEach((term) => {
                      matchContent.indexOf(term) >= 0 && (termFound = !0);
                    }),
                      termFound
                        ? element.classList.remove(
                            this.classNames.questionContainerInactive
                          )
                        : element.classList.add(
                            this.classNames.questionContainerInactive
                          );
                  } else
                    element.classList.remove(
                      this.classNames.questionContainerInactive
                    );
                }),
                this.linkedContent.forEach((element) => {
                  terms.length
                    ? element.classList.add(
                        this.classNames.questionContainerInactive
                      )
                    : element.classList.remove(
                        this.classNames.questionContainerInactive
                      );
                });
            }, 10);
          },
          handleIndexClick: function (evt) {
            if (evt.target.classList.contains("faq-index-item__link")) {
              evt.preventDefault();
              var id = evt.target.href.split("#")[1],
                scrollTarget = document.getElementById(id),
                scrollTargetY =
                  scrollTarget.getBoundingClientRect().top +
                  window.pageYOffset -
                  50,
                stickyHeight = getComputedStyle(
                  document.documentElement
                ).getPropertyValue("--theme-sticky-header-height");
              stickyHeight && (scrollTargetY -= parseInt(stickyHeight)),
                window.scrollTo({ top: scrollTargetY, behavior: "smooth" });
            }
          },
        });
    })()),
    cc.sections.push({
      name: "faq-header",
      section: theme.FaqHeader,
      deferredLoad: !1,
    }),
    (theme.CollapsibleTabs = new (function () {
      (this.onSectionLoad = function (container2) {
        this.functions.notifyFaqHeaderOfChange();
      }),
        (this.onSectionReorder = function (container2) {
          this.functions.notifyFaqHeaderOfChange();
        }),
        (this.onSectionUnload = function (container2) {
          this.functions.notifyFaqHeaderOfChange();
        }),
        (this.functions = {
          notifyFaqHeaderOfChange: function () {
            document.dispatchEvent(
              new CustomEvent("theme:faq-header-update", {
                bubbles: !0,
                cancelable: !1,
              })
            );
          },
        });
    })()),
    cc.sections.push({
      name: "collapsible-tabs",
      section: theme.CollapsibleTabs,
      deferredLoad: !1,
    }),
    (theme.StoreAvailability = function (container2) {
      var loadingClass = "store-availability-loading",
        initClass = "store-availability-initialized",
        storageKey = "cc-location";
      (this.onSectionLoad = function (container3) {
        (this.namespace = theme.namespaceFromSection(container3)),
          (this.$container = $(container3)),
          (this.productId = this.$container.data(
            "store-availability-container"
          )),
          (this.sectionUrl = this.$container.data("section-url")),
          this.$modal,
          this.$container.addClass(initClass),
          (this.transitionDurationMS =
            parseFloat(getComputedStyle(container3).transitionDuration) * 1e3),
          (this.removeFixedHeightTimeout = -1),
          $(window).on(
            "cc-variant-updated".concat(this.namespace).concat(this.productId),
            (e, args) => {
              args.product.id === this.productId &&
                this.functions.updateContent.bind(this)(
                  args.variant ? args.variant.id : null,
                  args.product.title,
                  this.$container.data("has-only-default-variant"),
                  args.variant && typeof args.variant.available < "u"
                );
            }
          ),
          this.$container.data("single-variant-id") &&
            this.functions.updateContent.bind(this)(
              this.$container.data("single-variant-id"),
              this.$container.data("single-variant-product-title"),
              this.$container.data("has-only-default-variant"),
              this.$container.data("single-variant-product-available")
            );
      }),
        (this.onSectionUnload = function () {
          $(window).off(
            "cc-variant-updated".concat(this.namespace).concat(this.productId)
          ),
            this.$container.off("click"),
            this.$modal && this.$modal.off("click");
        }),
        (this.functions = {
          getUserLocation: function () {
            return new Promise((resolve, reject) => {
              var storedCoords;
              sessionStorage[storageKey] &&
                (storedCoords = JSON.parse(sessionStorage[storageKey])),
                storedCoords
                  ? resolve(storedCoords)
                  : navigator.geolocation
                  ? navigator.geolocation.getCurrentPosition(
                      function (position) {
                        var coords = {
                          latitude: position.coords.latitude,
                          longitude: position.coords.longitude,
                        };
                        fetch("/localization.json", {
                          method: "PUT",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify(coords),
                        }),
                          (sessionStorage[storageKey] = JSON.stringify(coords)),
                          resolve(coords);
                      },
                      function () {
                        resolve(!1);
                      },
                      { maximumAge: 36e5, timeout: 5e3 }
                    )
                  : resolve(!1);
            });
          },
          getAvailableStores: function (variantId, cb) {
            return $.get(this.sectionUrl.replace("VARIANT_ID", variantId), cb);
          },
          calculateDistance: function (coords1, coords2, unitSystem) {
            var dtor = Math.PI / 180,
              radius = unitSystem === "metric" ? 6378.14 : 3959,
              rlat1 = coords1.latitude * dtor,
              rlong1 = coords1.longitude * dtor,
              rlat2 = coords2.latitude * dtor,
              rlong2 = coords2.longitude * dtor,
              dlon = rlong1 - rlong2,
              dlat = rlat1 - rlat2,
              a =
                Math.pow(Math.sin(dlat / 2), 2) +
                Math.cos(rlat1) *
                  Math.cos(rlat2) *
                  Math.pow(Math.sin(dlon / 2), 2),
              c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return radius * c;
          },
          updateLocationDistances: function (coords) {
            var unitSystem = this.$modal
                .find("[data-unit-system]")
                .data("unit-system"),
              self = this;
            this.$modal.find('[data-distance="false"]').each(function () {
              var thisCoords = {
                latitude: parseFloat($(this).data("latitude")),
                longitude: parseFloat($(this).data("longitude")),
              };
              if (thisCoords.latitude && thisCoords.longitude) {
                var distance = self.functions
                  .calculateDistance(coords, thisCoords, unitSystem)
                  .toFixed(1);
                $(this).html(distance),
                  setTimeout(() => {
                    $(this)
                      .closest(".store-availability-list__location__distance")
                      .addClass("-in");
                  }, 0);
              }
              $(this).attr("data-distance", "true");
            });
          },
          updateContent: function (
            variantId,
            productTitle,
            isSingleDefaultVariant,
            isVariantAvailable
          ) {
            this.$container.off(
              "click",
              "[data-store-availability-modal-open]"
            ),
              this.$container.off(
                "click" + this.namespace,
                ".cc-popup-close, .cc-popup-background"
              ),
              $(".store-availabilities-modal").remove(),
              isVariantAvailable
                ? (this.$container.addClass(loadingClass),
                  this.transitionDurationMS > 0 &&
                    this.$container.css(
                      "height",
                      this.$container.outerHeight() + "px"
                    ))
                : (this.$container.addClass(loadingClass),
                  this.transitionDurationMS > 0 &&
                    this.$container.css("height", "0px")),
              isVariantAvailable &&
                this.functions.getAvailableStores.call(
                  this,
                  variantId,
                  (response) => {
                    if (
                      response.trim().length > 0 &&
                      !response.includes("NO_PICKUP")
                    ) {
                      this.$container.html(response),
                        this.$container.html(
                          this.$container.children().first().html()
                        ),
                        this.$container
                          .find("[data-store-availability-modal-product-title]")
                          .html(productTitle),
                        isSingleDefaultVariant &&
                          this.$container
                            .find(".store-availabilities-modal__variant-title")
                            .remove(),
                        this.$container.find(".cc-popup").appendTo("body"),
                        (this.$modal = $("body").find(
                          ".store-availabilities-modal"
                        ));
                      var popup = new ccPopup(this.$modal, this.namespace);
                      if (
                        (this.$container.on(
                          "click",
                          "[data-store-availability-modal-open]",
                          () => (
                            popup.open(),
                            this.functions.getUserLocation().then((coords) => {
                              coords &&
                                this.$modal.find('[data-distance="false"]')
                                  .length &&
                                this.functions.getAvailableStores.call(
                                  this,
                                  variantId,
                                  (response2) => {
                                    this.$modal
                                      .find(".store-availabilities-list")
                                      .html(
                                        $(response2)
                                          .find(".store-availabilities-list")
                                          .html()
                                      ),
                                      this.functions.updateLocationDistances.bind(
                                        this
                                      )(coords);
                                  }
                                );
                            }),
                            !1
                          )
                        ),
                        this.$modal.on(
                          "click" + this.namespace,
                          ".cc-popup-close, .cc-popup-background",
                          () => {
                            popup.close();
                          }
                        ),
                        this.$container.removeClass(loadingClass),
                        this.transitionDurationMS > 0)
                      ) {
                        var newHeight = this.$container
                          .find(".store-availability-container")
                          .outerHeight();
                        this.$container.css(
                          "height",
                          newHeight > 0 ? newHeight + "px" : ""
                        ),
                          clearTimeout(this.removeFixedHeightTimeout),
                          (this.removeFixedHeightTimeout = setTimeout(() => {
                            this.$container.css("height", "");
                          }, this.transitionDurationMS));
                      }
                    }
                  }
                );
          },
        }),
        this.onSectionLoad(container2);
    }),
    cc.sections.push({
      name: "store-availability",
      section: theme.StoreAvailability,
    }),
    (theme.Popup = new (function () {
      var dismissedStorageKey = "cc-theme-popup-dismissed";
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$container = $(container2)),
          (this.popup = new ccPopup(this.$container, this.namespace));
        var dismissForDays = this.$container.data("dismiss-for-days"),
          delaySeconds = this.$container.data("delay-seconds"),
          showPopup = !0,
          testMode = this.$container.data("test-mode"),
          lastDismissed = window.localStorage.getItem(dismissedStorageKey);
        if (lastDismissed) {
          var dismissedDaysAgo = (new Date().getTime() - lastDismissed) / 864e5;
          dismissedDaysAgo < dismissForDays && (showPopup = !1);
        }
        this.$container.find(".cc-popup-form__response").length &&
          ((showPopup = !0),
          (delaySeconds = 1),
          this.$container.find(".cc-popup-form__response--success").length &&
            this.functions.popupSetAsDismissed.call(this)),
          document.querySelector(".shopify-challenge__container") &&
            (showPopup = !1),
          (showPopup || testMode) &&
            setTimeout(() => {
              this.popup.open();
            }, delaySeconds * 1e3),
          this.$container.on(
            "click" + this.namespace,
            ".cc-popup-close, .cc-popup-background",
            () => {
              this.popup.close(() => {
                this.functions.popupSetAsDismissed.call(this);
              });
            }
          ),
          theme.signup($(container2).find(".snippets-signup"));
      }),
        (this.onSectionSelect = function () {
          this.popup.open();
        }),
        (this.functions = {
          popupSetAsDismissed: function () {
            window.localStorage.setItem(
              dismissedStorageKey,
              new Date().getTime()
            );
          },
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace);
        });
    })()),
    cc.sections.push({ name: "newsletter-popup", section: theme.Popup }),
    (theme.icons = {
      left:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_left +
        '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
      right:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_right +
        '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
      close:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><title>' +
        theme.strings.icon_labels_close +
        '</title><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
      chevronLeft:
        '<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8.31055L8.29231 15.6029" stroke="#3974E5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 8.31055H18.5385" stroke="#3974E5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.29238 1L3.91699 5.37538" stroke="#3974E5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      chevronRight:
        '<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 8.31055L11.7077 15.6029" stroke="#3974E5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 8.31055H1.46154" stroke="#3974E5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.7076 1L16.083 5.37538" stroke="#3974E5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      chevronDown:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_down +
        '</title><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
      tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>',
      label:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tag"><title>Label</title><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7" y2="7"></line></svg>',
    });
  try {
    theme.Shopify.features = JSON.parse(
      document.documentElement.querySelector("#shopify-features").textContent
    );
  } catch (e) {
    theme.Shopify.features = {};
  }
  (theme.namespaceFromSection = function (container2) {
    return [
      ".",
      $(container2).data("section-type"),
      $(container2).data("section-id"),
    ].join("");
  }),
    (theme.measureTextInsideElement = function (text, element) {
      theme.measureTextInsideElementCanvas =
        theme.measureTextInsideElementCanvas ||
        document.createElement("canvas");
      var context = theme.measureTextInsideElementCanvas.getContext("2d"),
        font = getComputedStyle(element).font;
      return (context.font = font), context.measureText(text);
    }),
    (theme.avoidUnecessaryOrphans = function (element) {
      if (theme.settings.avoid_orphans) {
        var innerTextSplit = element.innerText.split(" ");
        if (
          innerTextSplit.length >= 4 &&
          innerTextSplit[innerTextSplit.length - 1].length +
            innerTextSplit[innerTextSplit.length - 2].length <
            20
        ) {
          var html = element.innerHTML;
          if (html.indexOf('<span class="orphan-join">') < 0) {
            html = html.replace(/<[^>]*?>/g, (match) =>
              match.replace(/ /g, "\u03A9\u03A9")
            );
            var splitHtml = html.split(" "),
              lastItem = splitHtml.pop();
            if (
              theme.measureTextInsideElement(
                splitHtml[splitHtml.length - 1].replace(/<[^>]*?>/g, "") +
                  " " +
                  lastItem.replace(/<[^>]*?>/g, ""),
                element
              ).width > element.clientWidth
            )
              return;
            (html =
              splitHtml.join(" ") +
              '<span class="orphan-join"> </span>' +
              lastItem),
              (html = html.replace(/ΩΩ/g, " ")),
              (element.innerHTML = html);
          }
        }
      }
    }),
    (theme.stickyHeaderHeight = function () {
      var v = getComputedStyle(document.documentElement).getPropertyValue(
        "--theme-sticky-header-height"
      );
      return (v && parseInt(v)) || 0;
    }),
    (theme.getScrollParent = function (node) {
      var isElement = node instanceof HTMLElement,
        overflowY = isElement && window.getComputedStyle(node).overflowY,
        isScrollable = overflowY !== "visible" && overflowY !== "hidden";
      if (node) {
        if (isScrollable && node.scrollHeight > node.clientHeight) return node;
      } else return null;
      return (
        theme.getScrollParent(node.parentNode) ||
        document.scrollingElement ||
        window
      );
    }),
    (theme.scrollToRevealElement = function (el) {
      var scrollContainer = theme.getScrollParent(el),
        scrollTop =
          scrollContainer === window
            ? window.scrollY
            : scrollContainer.scrollTop,
        scrollVisibleHeight =
          scrollContainer === window
            ? window.innerHeight
            : scrollContainer.clientHeight,
        elTop = theme.getOffsetTopFromDoc(el),
        elBot = elTop + el.offsetHeight,
        inViewTop = scrollTop + theme.stickyHeaderHeight(),
        inViewBot = scrollTop + scrollVisibleHeight - 50;
      (elTop < inViewTop || elBot > inViewBot) &&
        scrollContainer.scrollTo({
          top: elTop - 100 - theme.stickyHeaderHeight(),
          left: 0,
          behavior: "smooth",
        });
    }),
    (theme.getEmptyOptionSelectors = function ($formContainer) {
      var emptySections = [];
      return (
        $formContainer
          .find('[data-selector-type="dropdown"].option-selector')
          .each(function () {
            $(this)
              .find('[aria-selected="true"]')
              .filter(function () {
                return this.dataset && this.dataset.value;
              }).length || emptySections.push(this);
          }),
        $formContainer
          .find('[data-selector-type="listed"].option-selector')
          .each(function () {
            $(this).find("input:checked").length || emptySections.push(this);
          }),
        emptySections
      );
    }),
    (theme.validateProductForm = function ($formContainer) {
      if (
        ($formContainer
          .find(".option-selector--empty")
          .removeClass("option-selector--empty")
          .find(".label__prefix")
          .remove(),
        $formContainer.find(".original-selector").val())
      )
        return !!theme.OptionManager.getCurrentVariantData($formContainer)
          .available;
      var emptySections = theme.getEmptyOptionSelectors($formContainer);
      return (
        emptySections.length &&
          (emptySections.forEach((el) => {
            el.classList.add("option-selector--empty");
            var labelPrefix = document.createElement("span");
            (labelPrefix.innerText =
              theme.strings.products_product_pick_a + " "),
              (labelPrefix.className = "label__prefix"),
              el.querySelector(".label").prepend(labelPrefix);
          }),
          theme.scrollToRevealElement(emptySections[0]),
          $formContainer.addClass("product-form--validation-started")),
        !1
      );
    }),
    (theme.pauseAllMedia = function (params) {
      (!params || params.videos) &&
        (document.querySelectorAll(".js-youtube").forEach((video) => {
          video.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "*"
          );
        }),
        document.querySelectorAll(".js-vimeo").forEach((video) => {
          video.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((video) => video.pause())),
        (!params || params.models) &&
          document.querySelectorAll("product-model").forEach((model) => {
            model.modelViewerUI && model.modelViewerUI.pause();
          });
    }),
    (theme.manualLazyload = (el) => {
      el.tagName === "IMG"
        ? el.dataset.msrcset
          ? ((el.dataset.srcset = el.dataset.msrcset),
            delete el.dataset.msrcset,
            (el.dataset.src = el.dataset.msrc),
            delete el.dataset.msrc,
            theme.lazy.loadSrcSets())
          : el.dataset.msrc &&
            ((el.dataset.src = el.dataset.msrc), delete el.dataset.msrc)
        : el
            .querySelectorAll("img[data-msrc]")
            .forEach((el2) => theme.manualLazyload(el2));
    }),
    ($.fn.delegateSimplePassiveEvent = function (
      eventName,
      selector,
      callback
    ) {
      return $(this).each(function () {
        var delEl = this;
        this.addEventListener(
          eventName,
          (evt) => {
            var el = evt.target.closest(selector);
            el && delEl.contains(el) && callback.call(el, evt, el);
          },
          { passive: !0 }
        );
      });
    }),
    (theme.addDelegateEventListener = function (
      element,
      eventName,
      selector,
      callback
    ) {
      var addEventListenerParams =
          arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null,
        cb = (evt) => {
          var el = evt.target.closest(selector);
          el && element.contains(el) && callback.call(el, evt, el);
        };
      element.addEventListener(eventName, cb, addEventListenerParams);
    }),
    (theme.elementIndex = (el) => {
      if (!el) return -1;
      for (var i = 0; (el = el.previousElementSibling); ) i++;
      return i;
    }),
    (theme.Shopify.image_url = (url, width) =>
      url.replace(/&width=[0-9]*/, "") + "&width=" + width),
    (theme.backgroundImageWidths = [
      180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2260, 2450,
      2700, 3e3, 3350, 3750, 4100,
    ]),
    (theme.buildBackgroundImage = (bgEl) => {
      var src = bgEl.dataset.url,
        width = parseInt(bgEl.dataset.width),
        srcset = ""
          .concat(theme.Shopify.image_url(src, width), " ")
          .concat(width, "w"),
        img = document.createElement("img");
      (img.className = "background-image__image load-trans"),
        (img.loading = "lazy"),
        (img.onload = function (evt) {
          this.classList.add("loaded");
        }),
        (img.width = width),
        (img.height = bgEl.dataset.height),
        (img.alt = bgEl.dataset.alt),
        (img.dataset.src = src);
      for (var i = 0; i < theme.backgroundImageWidths.length; i++)
        theme.backgroundImageWidths[i] < img.width &&
          (srcset += ", "
            .concat(
              theme.Shopify.image_url(src, theme.backgroundImageWidths[i]),
              " "
            )
            .concat(theme.backgroundImageWidths[i], "w"));
      (img.dataset.srcset = srcset), bgEl.appendChild(img);
    }),
    (theme.hideAndRemove = (el) => {
      el.querySelectorAll("input").forEach((el2) => (el2.disabled = !0));
      var wrapper = document.createElement("div");
      (wrapper.className = "merge-remove-wrapper"),
        el.parentNode.insertBefore(wrapper, el),
        wrapper.appendChild(el),
        el.classList.add("merge-remove-item"),
        (wrapper.style.height = wrapper.clientHeight + "px");
      var cs = getComputedStyle(el),
        fadeDuration = parseFloat(cs.getPropertyValue("--fade-duration")) * 1e3,
        slideDuration =
          parseFloat(cs.getPropertyValue("--slide-duration")) * 1e3;
      setTimeout(() => {
        wrapper.classList.add("merge-remove-wrapper--fade"),
          setTimeout(() => {
            wrapper.classList.add("merge-remove-wrapper--slide"),
              setTimeout(() => wrapper.remove(), slideDuration);
          }, fadeDuration);
      }, 10);
    }),
    (theme.insertAndReveal = (el, target, iaeCmd, delay) => {
      var initialDelay = delay || 10;
      el.classList.add("merge-add-wrapper"),
        target.insertAdjacentElement(iaeCmd, el),
        (el.style.height = el.firstElementChild.clientHeight + "px");
      var cs = getComputedStyle(el),
        fadeDuration = parseFloat(cs.getPropertyValue("--fade-duration")) * 1e3,
        slideDuration =
          parseFloat(cs.getPropertyValue("--slide-duration")) * 1e3;
      setTimeout(() => {
        el.classList.add("merge-add-wrapper--slide"),
          setTimeout(() => {
            el.classList.add("merge-add-wrapper--fade"),
              setTimeout(() => {
                (el.style.height = ""),
                  el.classList.remove(
                    "merge-add-wrapper",
                    "merge-add-wrapper--slide",
                    "merge-add-wrapper--fade"
                  );
              }, fadeDuration);
          }, slideDuration);
      }, initialDelay);
    }),
    (theme.mergeNodes = (newContent, targetContainer) => {
      try {
        newContent.querySelectorAll("[data-merge]").forEach((newEl) => {
          var targetEl = targetContainer.querySelector(
            '[data-merge="'.concat(newEl.dataset.merge, '"]')
          );
          (!newEl.dataset.mergeCache ||
            !targetEl.dataset.mergeCache ||
            newEl.dataset.mergeCache !== targetEl.dataset.mergeCache) &&
            ((targetEl.innerHTML = newEl.innerHTML),
            (targetEl.dataset.mergeCache = newEl.dataset.mergeCache));
        }),
          newContent
            .querySelectorAll("[data-merge-attributes]")
            .forEach((newEl) => {
              var targetEl = targetContainer.querySelector(
                '[data-merge-attributes="'.concat(
                  newEl.dataset.mergeAttributes,
                  '"]'
                )
              );
              for (var attr of newEl.attributes)
                targetEl.setAttribute(attr.localName, attr.value);
            }),
          newContent
            .querySelectorAll("[data-merge-list]")
            .forEach((newList) => {
              var targetList = targetContainer.querySelector(
                  '[data-merge-list="'.concat(newList.dataset.mergeList, '"]')
                ),
                targetListItems = Array.from(
                  targetList.querySelectorAll("[data-merge-list-item]")
                ),
                newListItems = Array.from(
                  newList.querySelectorAll("[data-merge-list-item]")
                );
              targetListItems.forEach((targetListItem) => {
                var matchedItem = newListItems.find(
                  (item) =>
                    item.dataset.mergeListItem ==
                    targetListItem.dataset.mergeListItem
                );
                matchedItem || theme.hideAndRemove(targetListItem);
              }),
                (targetListItems = Array.from(
                  targetList.querySelectorAll(
                    "[data-merge-list-item]:not(.merge-remove-item)"
                  )
                ));
              for (
                var _loop = function (i2) {
                    var newListItem = newListItems[i2],
                      matchedItem = targetListItems.find(
                        (item) =>
                          item.dataset.mergeListItem ==
                          newListItem.dataset.mergeListItem
                      );
                    matchedItem
                      ? (!newListItem.dataset.mergeCache ||
                          !matchedItem.dataset.mergeCache ||
                          newListItem.dataset.mergeCache !==
                            matchedItem.dataset.mergeCache) &&
                        ((matchedItem.innerHTML = newListItem.innerHTML),
                        newListItem.dataset.mergeCache &&
                          (matchedItem.dataset.mergeCache =
                            newListItem.dataset.mergeCache))
                      : (i2 === 0
                          ? theme.insertAndReveal(
                              newListItem,
                              targetList,
                              "afterbegin",
                              500
                            )
                          : i2 >= targetListItems.length
                          ? theme.insertAndReveal(
                              newListItem,
                              targetList,
                              "beforeend",
                              500
                            )
                          : theme.insertAndReveal(
                              newListItem,
                              targetListItems[i2],
                              "beforebegin",
                              500
                            ),
                        targetListItems.splice(i2, 0, newListItem));
                  },
                  i = 0;
                i < newListItems.length;
                i++
              )
                _loop(i);
            });
      } catch {
        location.reload();
      }
    }),
    (theme.suffixIds = (container2, prefix) => {
      for (
        var suffixCandidates = [
            "id",
            "for",
            "form",
            "aria-describedby",
            "aria-controls",
            "data-cc-modal-contentelement",
          ],
          _loop2 = function (i2) {
            container2
              .querySelectorAll("[".concat(suffixCandidates[i2], "]"))
              .forEach((el) =>
                el.setAttribute(
                  suffixCandidates[i2],
                  el.getAttribute(suffixCandidates[i2]) + prefix
                )
              );
          },
          i = 0;
        i < suffixCandidates.length;
        i++
      )
        _loop2(i);
    }),
    (theme.applyAjaxToProductForm = function ($formContainer) {
    $formContainer.find("form.product-purchase-form").each(function () {
      var $form = $(this);
      $form.on("submit", function (evt) {
        // Validate
        if (!theme.validateProductForm($formContainer)) {
          return false;
        }

        // Ajax-add
        if (
          theme.settings.cart_type === "drawer" &&
          $formContainer.is('[data-ajax-add-to-cart="true"]')
        ) {
          evt.preventDefault();

          var shopifyAjaxAddURL = theme.routes.cart_add_url;

          //Disable add button
          $form
            .find('button[type="submit"]')
            .addClass("btn--in-progress")
            .attr("disabled", "disabled");

          //Add to cart - 收集主产品和选中的配件
          var items = [];

          // 添加主产品
          var formData = new FormData($form[0]);
          var mainItem = {
            id: formData.get("id"),
            quantity: formData.get("quantity") || 1,
          };
          items.push(mainItem);

          // 添加选中的配件产品
          $(".product-parts-checkbox:checked").each(function () {
            var $checkbox = $(this);
            items.push({
              id: $checkbox.data("variant-id"),
              quantity: $checkbox.data("quantity") || 1,
            });
          });

          // 添加选中的赠品
          $(".product-gift-checkbox:checked").each(function () {
            var $checkbox = $(this);
            items.push({
              id: $checkbox.data("variant-id"),
              quantity: $checkbox.data("quantity") || 1,
            });
          });

          console.log("添加到购物车的商品:", items);

          // 使用 Shopify Cart API 批量添加
          $.post(
            shopifyAjaxAddURL,
            {
              items: items,
              sections: "cart-drawer",
            },
            theme.addedToCartHandler.bind($form),
            "json"
          ).fail(function (data) {
            //Enable add button
            $form
              .find('button[type="submit"]')
              .removeClass("btn--in-progress")
              .removeAttr("disabled");

            //Not added, show message
            if (
              typeof data !== "undefined" &&
              typeof data.status !== "undefined"
            ) {
              var jsonRes = $.parseJSON(data.responseText);
              theme.showQuickPopup(
                jsonRes.description,
                $form.find('button[type="submit"]:first')
              );
            } else {
              //Some unknown error? Disable ajax and add the old-fashioned way.
              $formContainer.attr("ajax-add-to-cart", "false");
              $form.submit();
            }
          });
        }
      });
    });
  }),
    (theme.addedToCartHandler = function (response) {
      document.dispatchEvent(
        new CustomEvent("theme:cartchanged", { bubbles: !0, cancelable: !1 })
      ),
        document.dispatchEvent(
          new CustomEvent("theme:open-cart-drawer", {
            bubbles: !0,
            cancelable: !1,
          })
        ),
        $(this)
          .find('button[type="submit"]')
          .removeClass("btn--in-progress")
          .removeAttr("disabled");
    }),
    (theme.removeAjaxFromProductForm = function ($formContainer) {
      $formContainer.find("form.product-purchase-form").off("submit");
    });
  var CartForm = class extends HTMLElement {
    connectedCallback() {
      theme.cartNoteMonitor.load($('[name="note"]', this)),
        (this.enableAjaxUpdate = this.dataset.ajaxUpdate),
        this.enableAjaxUpdate &&
          ((this.sectionId = this.dataset.sectionId),
          (this.boundRefresh = this.refresh.bind(this)),
          document.addEventListener("theme:cartchanged", this.boundRefresh),
          theme.addDelegateEventListener(
            this,
            "click",
            ".cart-item__remove",
            (evt) => {
              evt.preventDefault(),
                this.adjustItemQuantity(evt.target.closest(".cart-item"), {
                  to: 0,
                });
            }
          ),
          theme.addDelegateEventListener(
            this,
            "click",
            ".quantity-down",
            (evt) => {
              evt.preventDefault(),
                this.adjustItemQuantity(evt.target.closest(".cart-item"), {
                  decrease: !0,
                });
            }
          ),
          theme.addDelegateEventListener(
            this,
            "click",
            ".quantity-up",
            (evt) => {
              evt.preventDefault(),
                this.adjustItemQuantity(evt.target.closest(".cart-item"), {
                  increase: !0,
                });
            }
          ),
          theme.addDelegateEventListener(
            this,
            "change",
            ".cart-item__quantity-input",
            (evt) => {
              this.adjustItemQuantity(evt.target.closest(".cart-item"), {
                currentValue: !0,
              });
            }
          ));
    }
    disconnectedCallback() {
      theme.cartNoteMonitor.unload($('[name="note"]', this)),
        this.enableAjaxUpdate &&
          document.removeEventListener("theme:cartchanged", this.boundRefresh);
    }
    refresh() {
      this.classList.add("cart-form--refreshing"),
        fetch(
          ""
            .concat(window.Shopify.routes.root, "?section_id=")
            .concat(this.sectionId)
        )
          .then((response) => {
            if (!response.ok)
              throw new Error("HTTP error! Status: ".concat(response.status));
            return response.text();
          })
          .then((response) => {
            var frag = document.createDocumentFragment(),
              newContent = document.createElement("div");
            frag.appendChild(newContent),
              (newContent.innerHTML = response),
              newContent
                .querySelectorAll("[data-cc-animate]")
                .forEach((el) => el.removeAttribute("data-cc-animate")),
              theme.mergeNodes(newContent, this),
              this.classList.remove("cart-form--refreshing"),
              this.querySelectorAll(".merge-item-refreshing").forEach((el) =>
                el.classList.remove("merge-item-refreshing")
              );
          });
    }
    adjustItemQuantity(item, change) {
      var quantityInput = item.querySelector(".cart-item__quantity-input"),
        newQuantity = parseInt(quantityInput.value);
      typeof change.to < "u"
        ? ((newQuantity = change.to), (quantityInput.value = newQuantity))
        : change.increase
        ? ((newQuantity += quantityInput.step || 1),
          (quantityInput.value = newQuantity))
        : change.decrease
        ? ((newQuantity -= quantityInput.step || 1),
          (quantityInput.value = newQuantity))
        : change.currentValue,
        quantityInput.max &&
          parseInt(quantityInput.value) > parseInt(quantityInput.max) &&
          ((newQuantity = quantityInput.max),
          (quantityInput.value = newQuantity),
          theme.showQuickPopup(
            theme.strings.cart_general_quantity_too_high.replace(
              "[QUANTITY]",
              quantityInput.max
            ),
            $(quantityInput)
          )),
        clearTimeout(this.adjustItemQuantityTimeout),
        (this.adjustItemQuantityTimeout = setTimeout(
          () => {
            var qtys = [];
            this.querySelectorAll(
              ".cart-item__quantity-input:not([disabled])"
            ).forEach((el) => {
              qtys.push(el.value),
                el.value != el.dataset.initialValue &&
                  el
                    .closest("[data-merge-list-item]")
                    .classList.add("merge-item-refreshing");
            }),
              fetch(theme.routes.cart_update_url, {
                method: "POST",
                body: JSON.stringify({ updates: qtys }),
                headers: { "Content-Type": "application/json" },
              }).then((response) => {
                if (!response.ok)
                  throw new Error(
                    "HTTP error! Status: ".concat(response.status)
                  );
                document.dispatchEvent(
                  new CustomEvent("theme:cartchanged", {
                    bubbles: !0,
                    cancelable: !1,
                  })
                );
              });
          },
          newQuantity === 0 ? 10 : 700
        ));
    }
  };
  window.customElements.define("cart-form", CartForm);
  var CCCarousel = class extends HTMLElement {
    constructor() {
      super(), theme.lazy.initScript(this, this.prepare.bind(this));
    }
    get() {
      return this.prepare(), this;
    }
    prepare() {
      if (!this.prepared) {
        if (
          ((this.prepared = !0),
          (this.scrollOuter = this.querySelector(".cc-carousel__scroll-outer")),
          (this.scrollArea = this.querySelector(".cc-carousel__scroll-area")),
          (this.prevButton = this.querySelector(".cc-carousel-button--prev")),
          (this.nextButton = this.querySelector(".cc-carousel-button--next")),
          (this.buttonContainer = this.querySelector(".cc-carousel-buttons")),
          (this.allowMouseDrag = this.hasAttribute("allow-mouse-drag")),
          (this.selectSingle = this.hasAttribute("select-single")),
          (this.loopPreferred = this.hasAttribute("loop")),
          (this.rebuildOnResize = this.hasAttribute("rebuild-on-resize")),
          (this.setItemClasses = this.hasAttribute("set-item-classes")),
          (this.ltr = !document.querySelector("html[dir=rtl]")),
          this.scrollArea.scrollTo({ top: 0, left: 0, behavior: "instant" }),
          this.rebuildOnResize)
        )
          try {
            (this.savedClientWidth = this.clientWidth),
              (this.resizeObserver = new ResizeObserver((entries) => {
                for (var entry of entries)
                  entry.contentBoxSize &&
                    this.clientWidth !== this.savedClientWidth &&
                    ((this.savedClientWidth = this.clientWidth),
                    (this.reInitTimeoutId = setTimeout(
                      this.reInit.bind(this),
                      250
                    )));
              })),
              this.resizeObserver.observe(this);
          } catch {}
        this.init.call(this);
      }
    }
    init() {
      (this.selectedItemIndex = 0),
        (this.flexDirection = getComputedStyle(this).getPropertyValue(
          "--carousel-direction"
        )),
        !(
          this.scrollArea.childElementCount === 0 ||
          this.flexDirection == "column" ||
          this.flexDirection == "none"
        ) &&
          (this.scrollArea.childElementCount === 1
            ? ((this.loop = !1),
              this.classList.add("cc-carousel--at-start"),
              this.classList.add("cc-carousel--at-end"),
              this.setItemClasses &&
                (this.scrollArea.firstElementChild.classList.add(
                  "cc-carousel__current-item"
                ),
                this.scrollArea.firstElementChild.classList.add(
                  "cc-carousel__visible-item"
                )),
              this.prevButton && (this.prevButton.disabled = !0),
              this.nextButton && (this.nextButton.disabled = !0))
            : ((this.loop = this.loopPreferred),
              this.scrollArea.addEventListener(
                "scroll",
                this.onScroll.bind(this)
              ),
              (this.scrollNextSearchOffset =
                this.scrollArea.firstElementChild.clientWidth / 8),
              this.prevButton &&
                ((this.boundPrev = this.prev.bind(this)),
                this.prevButton.addEventListener("click", this.boundPrev)),
              this.nextButton &&
                ((this.boundNext = this.next.bind(this)),
                this.nextButton.addEventListener("click", this.boundNext)),
              this.allowMouseDrag &&
                ((this.boundReleaseDrag = this.releaseDrag.bind(this)),
                (this.boundDrag = this.drag.bind(this)),
                (this.boundOnMouseDown = this.onMouseDown.bind(this)),
                this.scrollOuter.addEventListener(
                  "mousedown",
                  this.boundOnMouseDown
                )),
              this.whenStateSettled()));
    }
    reInit() {
      this.prevButton &&
        (this.prevButton.removeEventListener("click", this.boundPrev),
        (this.boundPrev = null)),
        this.nextButton &&
          (this.nextButton.removeEventListener("click", this.boundNext),
          (this.boundNext = null)),
        this.allowMouseDrag &&
          (this.scrollOuter.removeEventListener(
            "mousedown",
            this.boundOnMouseDown
          ),
          (this.boundOnMouseDown = null)),
        this.buttonContainer &&
          this.buttonContainer.classList.remove("cc-carousel-buttons--show");
      for (var item of this.scrollArea.children)
        item.classList.remove(
          "cc-carousel__current-item",
          "cc-carousel__visible-item"
        );
      this.init();
    }
    contentChanged() {
      this.reInit();
    }
    onScroll(evt) {
      clearTimeout(this.onScrollTimeoutId),
        (this.onScrollTimeoutId = setTimeout(() => {
          this.selectSingle &&
            !this.scrollingForVisibility &&
            this.selectFirstVisibleItem(),
            this.whenStateSettled(),
            (this.scrollingForVisibility = !1);
        }, 50));
    }
    onMouseDown(evt) {
      (this.dragLastX = evt.clientX),
        this.classList.add("cc-carousel--mousedown"),
        document.addEventListener("mousemove", this.boundDrag),
        document.addEventListener("mouseup", this.boundReleaseDrag);
    }
    itemOffsetStart(el) {
      return this.ltr
        ? el.offsetLeft
        : this.scrollArea.clientWidth - el.offsetLeft - el.clientWidth;
    }
    itemIsWithinScrollView(el, customScrollStart) {
      var scrollViewStart =
          typeof customScrollStart < "u"
            ? customScrollStart
            : Math.abs(this.scrollArea.scrollLeft),
        scrollViewEnd = scrollViewStart + this.scrollArea.clientWidth,
        elStart = this.itemOffsetStart(el) + 1,
        elEnd = elStart + el.clientWidth - 3;
      return elStart >= scrollViewStart && elEnd <= scrollViewEnd;
    }
    drag(evt) {
      evt.preventDefault(),
        this.inDrag ||
          (this.classList.add("cc-carousel--in-drag"), (this.inDrag = !0)),
        (this.scrollArea.scrollLeft =
          this.scrollArea.scrollLeft + (this.dragLastX - evt.clientX)),
        (this.dragLastX = evt.clientX);
    }
    releaseDrag(evt) {
      this.inDrag &&
        ((this.inDrag = !1),
        this.classList.remove("cc-carousel--in-drag"),
        document.removeEventListener("mouseup", this.boundReleaseDrag)),
        document.removeEventListener("mousemove", this.boundDrag),
        this.classList.remove("cc-carousel--mousedown");
    }
    prev() {
      var nextItem = null;
      if (this.selectSingle)
        nextItem = this.findCurrentItem().previousElementSibling;
      else {
        var virtualScrollLeft = Math.max(
            0,
            Math.abs(this.scrollArea.scrollLeft) - this.scrollArea.clientWidth
          ),
          firstElComputedStyle = getComputedStyle(
            this.scrollArea.firstElementChild
          );
        firstElComputedStyle.scrollMarginInlineStart &&
          (virtualScrollLeft += parseFloat(
            firstElComputedStyle.scrollMarginInlineStart
          ));
        for (var item of this.scrollArea.children)
          if (this.itemIsWithinScrollView(item, virtualScrollLeft)) {
            nextItem = item;
            break;
          }
      }
      this.loop && !nextItem && (nextItem = this.scrollArea.lastElementChild),
        nextItem && this.selectItem(nextItem);
    }
    next() {
      var nextItem = null;
      if (this.selectSingle)
        nextItem = this.findCurrentItem().nextElementSibling;
      else {
        var foundItemInScrollView = !1;
        for (var item of this.scrollArea.children)
          if (this.itemIsWithinScrollView(item)) foundItemInScrollView = !0;
          else if (foundItemInScrollView) {
            nextItem = item;
            break;
          }
      }
      this.loop && !nextItem && (nextItem = this.scrollArea.firstElementChild),
        nextItem && this.selectItem(nextItem);
    }
    findItemAfter(targetOffsetLeft) {
      for (var nextItem = null, i = 0; i < this.scrollArea.children.length; i++)
        if (
          this.itemOffsetStart(this.scrollArea.children[i]) > targetOffsetLeft
        ) {
          nextItem = this.scrollArea.children[i];
          break;
        }
      return nextItem || this.scrollArea.lastElementChild, nextItem;
    }
    findCurrentItem(forceFromPosition) {
      if (this.selectSingle && !forceFromPosition)
        return this.scrollArea.children[this.selectedItemIndex];
      var firstItemOffsetLeft = this.ltr
          ? this.scrollArea.firstElementChild.offsetLeft
          : 0,
        nextItemAfterX =
          Math.abs(this.scrollArea.scrollLeft) -
          this.scrollNextSearchOffset +
          firstItemOffsetLeft;
      return this.findItemAfter(nextItemAfterX);
    }
    selectItem(item) {
      if (this.selectSingle) {
        for (var i = 0, iEl = item; (iEl = iEl.previousElementSibling); ) i++;
        this.selectedItemIndex = i;
      }
      if (!this.itemIsWithinScrollView(item)) {
        var destinationScrollLeft =
          item.offsetLeft - this.scrollArea.firstElementChild.offsetLeft;
        (this.scrollingForVisibility = !0),
          this.scrollArea.scrollTo({
            top: 0,
            left: destinationScrollLeft,
            behavior: "smooth",
          });
      }
      this.whenStateSettled();
    }
    selectFirstVisibleItem() {
      this.selectItem(this.findCurrentItem(!0));
    }
    setTabindexAccessible(item, canAccess) {
      for (
        var items = item.querySelectorAll(
            "a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), *[tabindex]"
          ),
          i = 0;
        i < items.length;
        i++
      ) {
        var _item = items[i];
        typeof _item.dataset.ccCarouselPriorTabindex > "u" &&
          (_item.dataset.ccCarouselPriorTabindex = _item.tabIndex),
          canAccess
            ? _item.dataset.ccCarouselPriorTabindex &&
              _item.dataset.ccCarouselPriorTabindex !== "0"
              ? (_item.tabIndex = _item.dataset.ccCarouselPriorTabindex)
              : _item.removeAttribute("tabindex")
            : (_item.tabIndex = -1);
      }
    }
    whenStateSettled() {
      clearTimeout(this.whenStateSettledTimeoutId),
        (this.whenStateSettledTimeoutId = setTimeout(() => {
          var normalisedScrollLeft = Math.abs(
              Math.floor(this.scrollArea.scrollLeft)
            ),
            atStartOfScroll = normalisedScrollLeft <= 0,
            atEndOfScroll =
              normalisedScrollLeft + this.scrollArea.clientWidth + 2 >
              this.scrollArea.scrollWidth,
            currentItem = this.findCurrentItem();
          this.dispatchEvent(
            new CustomEvent("cc-carousel:selected", {
              bubbles: !0,
              cancelable: !1,
              detail: { currentItem },
            })
          );
          for (var item of this.scrollArea.children) {
            var itemIsVisible = this.itemIsWithinScrollView(item);
            this.setTabindexAccessible(item, itemIsVisible),
              this.setItemClasses &&
                (item.classList.toggle(
                  "cc-carousel__current-item",
                  item == currentItem
                ),
                item.classList.toggle(
                  "cc-carousel__visible-item",
                  itemIsVisible
                ));
          }
          if (
            (this.classList.toggle("cc-carousel--at-start", atStartOfScroll),
            this.classList.toggle("cc-carousel--at-end", atEndOfScroll),
            this.prevButton || this.nextButton)
          )
            if (this.selectSingle) {
              this.buttonContainer &&
                this.buttonContainer.classList.add("cc-carousel-buttons--show");
              var _currentItem = this.findCurrentItem();
              this.loop ||
                (this.prevButton &&
                  (_currentItem.previousElementSibling
                    ? this.prevButton.removeAttribute("disabled")
                    : (this.prevButton.disabled = !0)),
                this.nextButton &&
                  (_currentItem.nextElementSibling
                    ? this.nextButton.removeAttribute("disabled")
                    : (this.nextButton.disabled = !0)));
            } else
              atStartOfScroll && atEndOfScroll
                ? (this.buttonContainer &&
                    this.buttonContainer.classList.remove(
                      "cc-carousel-buttons--show"
                    ),
                  this.prevButton && (this.prevButton.disabled = !0),
                  this.nextButton && (this.nextButton.disabled = !0))
                : (this.buttonContainer &&
                    this.buttonContainer.classList.add(
                      "cc-carousel-buttons--show"
                    ),
                  this.prevButton &&
                    (this.loop || !atStartOfScroll
                      ? this.prevButton.removeAttribute("disabled")
                      : (this.prevButton.disabled = !0)),
                  this.nextButton &&
                    (this.loop || !atEndOfScroll
                      ? this.nextButton.removeAttribute("disabled")
                      : (this.nextButton.disabled = !0)));
        }, 20));
    }
  };
  window.customElements.define("cc-carousel", CCCarousel);
  var CCCartCrossSell = class extends HTMLElement {
    connectedCallback() {
      (this.productList = this.querySelector(".product-mini-list")),
        this.dataset.from &&
          fetch(this.dataset.from)
            .then((response) => {
              if (!response.ok)
                throw new Error("HTTP error! Status: ".concat(response.status));
              return response.text();
            })
            .then((response) => {
              var frag = document.createDocumentFragment(),
                newContent = document.createElement("div");
              frag.appendChild(newContent), (newContent.innerHTML = response);
              var pl = newContent.querySelector(".product-mini-list");
              if (pl) {
                this.productList.innerHTML = pl.innerHTML;
                var carousel = this.productList.closest("cc-carousel");
                carousel && carousel.get().contentChanged();
              } else this.classList.add("hidden");
            });
    }
  };
  window.customElements.define("cc-cart-cross-sell", CCCartCrossSell);
  var CCFetchedContent = class extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => {
          if (!response.ok)
            throw new Error("HTTP error! Status: ".concat(response.status));
          return response.text();
        })
        .then((response) => {
          var frag = document.createDocumentFragment(),
            fetchedContent = document.createElement("div");
          frag.appendChild(fetchedContent),
            (fetchedContent.innerHTML = response);
          var replacementContent = fetchedContent.querySelector(
            '[data-id="'.concat(CSS.escape(this.dataset.id), '"]')
          );
          replacementContent && (this.innerHTML = replacementContent.innerHTML);
        });
    }
  };
  window.customElements.define("cc-fetched-content", CCFetchedContent),
    (theme.LoadFilterer = function (section, baseUrl) {
      var alterLocation =
        arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
      (this.$container = section.$container),
        (this.namespace = section.namespace),
        (this.registerEventListener = section.registerEventListener),
        (this.baseUrl = baseUrl || location.pathname),
        (this.alterLocation = alterLocation),
        (this.functions = {
          ajaxLoadLink: function (evt) {
            evt.preventDefault(),
              this.functions.ajaxLoadUrl.call(
                this,
                $(evt.currentTarget).attr("href"),
                this.alterLocation
              );
          },
          ajaxLoadForm: function (evt) {
            evt.type === "submit" && evt.preventDefault();
            var queryVals = [];
            evt.currentTarget
              .querySelectorAll("input, select")
              .forEach((input) => {
                ((input.type !== "checkbox" && input.type !== "radio") ||
                  input.checked) &&
                  input.value !== "" &&
                  queryVals.push([input.name, encodeURIComponent(input.value)]);
              });
            var newUrl = this.baseUrl;
            queryVals.forEach((value) => {
              newUrl += "&".concat(value[0], "=").concat(value[1]);
            }),
              (newUrl = newUrl.replace("&", "?")),
              this.functions.ajaxLoadUrl.call(this, newUrl, this.alterLocation);
          },
          ajaxPopState: function (event) {
            this.functions.ajaxLoadUrl.call(this, document.location.href, !1);
          },
          ajaxLoadUrl: function (url, pushState) {
            if (pushState) {
              var fullUrl = url;
              fullUrl.slice(0, 1) === "/" &&
                (fullUrl =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  fullUrl),
                window.history.pushState({ path: fullUrl }, "", fullUrl);
            }
            this.$container[0].dataset.filterSectionId &&
              (url +=
                (url.indexOf("?") >= 0 ? "&" : "?") +
                "section_id=".concat(
                  this.$container[0].dataset.filterSectionId
                ));
            var refreshContainerSelector = "[data-ajax-container]",
              $ajaxContainers = this.$container.find(refreshContainerSelector);
            $ajaxContainers.addClass("ajax-loading"),
              this.currentAjaxLoadUrlFetch &&
                this.currentAjaxLoadUrlFetch.abort(),
              (this.currentAjaxLoadUrlFetch = $.get(
                url,
                function (data) {
                  (this.currentAjaxLoadUrlFetch = null),
                    document.activeElement &&
                      (this.activeElementId = document.activeElement.id);
                  var $newAjaxContainers = $(
                    "<div>".concat(data, "</div>")
                  ).find(refreshContainerSelector);
                  $newAjaxContainers.each(function () {
                    $ajaxContainers
                      .filter(
                        '[data-ajax-container="'.concat(
                          this.dataset.ajaxContainer,
                          '"]'
                        )
                      )
                      .html($(this).html());
                  });
                  var $componentHaver =
                    this.$container.closest("[data-components]");
                  if ($componentHaver.length) {
                    var components = $componentHaver
                      .data("components")
                      .split(",");
                    components.forEach(
                      function (component) {
                        $(document).trigger("cc:component:load", [
                          component,
                          $componentHaver[0],
                        ]);
                      }.bind(this)
                    );
                  }
                  if (
                    ($ajaxContainers.removeClass("ajax-loading"),
                    theme.initAnimateOnScroll(),
                    this.activeElementId)
                  ) {
                    var el = document.getElementById(this.activeElementId);
                    el && el.focus();
                  }
                  var scrollTo = this.$container[0].querySelector(
                    "[data-ajax-scroll-to]"
                  );
                  scrollTo && theme.scrollToRevealElement(scrollTo);
                }.bind(this)
              ));
          },
        }),
        this.$container.data("ajax-filtering")
          ? (this.$container.on(
              "click" + this.namespace,
              ".filter-group__applied-item, .filter-group__clear-link, .pagination a",
              this.functions.ajaxLoadLink.bind(this)
            ),
            this.$container.on(
              "change" + this.namespace + " submit" + this.namespace,
              "#CollectionFilterForm",
              theme.debounce(this.functions.ajaxLoadForm.bind(this), 700)
            ),
            this.registerEventListener(
              window,
              "popstate",
              this.functions.ajaxPopState.bind(this)
            ))
          : this.$container.on(
              "change" + this.namespace,
              "#CollectionFilterForm",
              function () {
                $(this).submit();
              }
            ),
        (this.destroy = function () {
          theme.destroyProductGallery(this.$container),
            this.$container.off(this.namespace),
            $(window).off(this.namespace),
            $(document).off(this.namespace);
        }.bind(this));
    }),
    (theme.buildGalleryViewer = function (config) {
      for (
        var galleryParent = config.galleryParent
            ? config.galleryParent
            : document.body,
          $allContainer = $(
            '<div class="gallery-viewer gallery-viewer--pre-reveal">'
          ),
          $zoomContainer = $(
            '<div class="gallery-viewer__zoom-container">'
          ).appendTo($allContainer),
          $thumbContainer = $('<div class="gallery-viewer__thumbs">').appendTo(
            $allContainer
          ),
          $controlsContainer = $(
            '<div class="gallery-viewer__controls">'
          ).appendTo($allContainer),
          $close = $(
            '<a class="gallery-viewer__button gallery-viewer__close" href="#">'
          )
            .html(config.close)
            .appendTo($controlsContainer),
          $right = $(
            '<a class="gallery-viewer__button gallery-viewer__prev" href="#">'
          )
            .html(config.prev)
            .appendTo($controlsContainer),
          $left = $(
            '<a class="gallery-viewer__button gallery-viewer__next" href="#">'
          )
            .html(config.next)
            .appendTo($controlsContainer),
          $currentZoomImage = null,
          wheelZoomMultiplier = -0.001,
          pinchZoomMultiplier = 0.003,
          touchPanModifier = 1,
          currentTransform = { panX: 0, panY: 0, zoom: 1 },
          i = 0;
        i < config.images.length;
        i++
      ) {
        var img = config.images[i];
        $('<a class="gallery-viewer__thumb" href="#">')
          .data("zoom-url", img.zoomUrl)
          .html(img.thumbTag)
          .appendTo($thumbContainer);
      }
      config.images.length === 1 &&
        $allContainer.addClass("gallery-viewer--single-image");
      var panZoomImageFromCoordinate = function (inputX, inputY) {
          var doPanX = $currentZoomImage.width() > $allContainer.width(),
            doPanY = $currentZoomImage.height() > $allContainer.height();
          if (doPanX || doPanY) {
            var midX = $allContainer.width() / 2,
              midY = $allContainer.height() / 2,
              offsetFromCentreX = inputX - midX,
              offsetFromCentreY = inputY - midY,
              finalOffsetX = 0,
              finalOffsetY = 0;
            if (doPanX) {
              var offsetMultiplierX =
                ($currentZoomImage.width() - $allContainer.width()) / 2 / midX;
              finalOffsetX = Math.round(-offsetFromCentreX * offsetMultiplierX);
            }
            if (doPanY) {
              var offsetMultiplierY =
                ($currentZoomImage.height() - $allContainer.height()) /
                2 /
                midY;
              finalOffsetY = Math.round(-offsetFromCentreY * offsetMultiplierY);
            }
            (currentTransform.panX = finalOffsetX),
              (currentTransform.panY = finalOffsetY),
              alterCurrentPanBy(0, 0),
              updateImagePosition();
          }
        },
        panZoomImageFromScreenCoordinate = function (screenX, screenY) {
          var containerBoundingRect = $allContainer[0].getBoundingClientRect(),
            containerLeft = containerBoundingRect.left,
            containerRight = containerBoundingRect.left + $allContainer.width(),
            containerTop = containerBoundingRect.top,
            containerBottom =
              containerBoundingRect.top + $allContainer.height();
          screenX >= containerLeft &&
            screenX <= containerRight &&
            screenY >= containerTop &&
            screenY <= containerBottom &&
            panZoomImageFromCoordinate(
              screenX - containerLeft,
              screenY - containerTop
            );
        },
        alterCurrentPanBy = function (x, y) {
          currentTransform.panX += x;
          var panXMax =
            ($currentZoomImage[0].naturalWidth * currentTransform.zoom -
              $allContainer.width()) /
            2;
          (panXMax = Math.max(panXMax, 0)),
            (currentTransform.panX = Math.min(currentTransform.panX, panXMax)),
            (currentTransform.panX = Math.max(currentTransform.panX, -panXMax)),
            (currentTransform.panY += y);
          var panYMax =
            ($currentZoomImage[0].naturalHeight * currentTransform.zoom -
              $allContainer.height()) /
            2;
          (panYMax = Math.max(panYMax, 0)),
            (currentTransform.panY = Math.min(currentTransform.panY, panYMax)),
            (currentTransform.panY = Math.max(currentTransform.panY, -panYMax)),
            updateImagePosition();
        },
        setCurrentTransform = function (panX, panY, zoom) {
          (currentTransform.panX = panX),
            (currentTransform.panY = panY),
            (currentTransform.zoom = zoom),
            alterCurrentTransformZoomBy(0);
        },
        alterCurrentTransformZoomBy = function (delta) {
          currentTransform.zoom += delta;
          var maxZoomX =
              $allContainer.width() / $currentZoomImage[0].naturalWidth,
            maxZoomY =
              $allContainer.height() / $currentZoomImage[0].naturalHeight;
          (currentTransform.zoom = Math.max(
            currentTransform.zoom,
            Math.min(maxZoomX, maxZoomY)
          )),
            (currentTransform.zoom = Math.min(currentTransform.zoom, 1)),
            alterCurrentPanBy(0, 0),
            updateImagePosition();
        },
        updateImagePosition = function () {
          $currentZoomImage.css(
            "transform",
            "translate3d("
              .concat(currentTransform.panX, "px, ")
              .concat(currentTransform.panY, "px, 0) scale(")
              .concat(currentTransform.zoom, ")")
          );
        };
      $allContainer.on(
        "click.galleryViewer select.galleryViewer",
        ".gallery-viewer__thumb",
        function (evt) {
          evt.preventDefault(),
            $(this)
              .addClass("gallery-viewer__thumb--active")
              .siblings(".gallery-viewer__thumb--active")
              .removeClass("gallery-viewer__thumb--active"),
            $zoomContainer.addClass("gallery-viewer__zoom-container--loading"),
            ($currentZoomImage = $(
              '<img class="gallery-viewer__zoom-image" alt="" style="visibility: hidden">'
            )),
            $currentZoomImage
              .on("load", function () {
                $(this)
                  .parent()
                  .removeClass("gallery-viewer__zoom-container--loading"),
                  $(this).off("load"),
                  $(this).css({
                    visibility: "",
                    top: $allContainer.height() / 2 - $(this).height() / 2,
                    left: $allContainer.width() / 2 - $(this).width() / 2,
                  }),
                  setCurrentTransform(0, 0, 0);
              })
              .attr("src", $(this).data("zoom-url")),
            $zoomContainer.html($currentZoomImage);
        }
      );
      var pinchTracking = { isTracking: !1, lastPinchDistance: 0 },
        touchTracking = { isTracking: !1, lastTouchX: 0, lastTouchY: 0 };
      $allContainer.on("touchend.galleryViewer", function (evt) {
        (pinchTracking.isTracking = !1), (touchTracking.isTracking = !1);
      }),
        $allContainer.on(
          "mousemove.galleryViewer touchmove.galleryViewer",
          function (evt) {
            if (
              (evt.preventDefault(),
              evt.type === "touchmove" && evt.touches.length > 0)
            ) {
              var touch1 = evt.touches[0];
              if (
                (touchTracking.isTracking
                  ? (alterCurrentPanBy(
                      (touch1.clientX - touchTracking.lastTouchX) *
                        touchPanModifier,
                      (touch1.clientY - touchTracking.lastTouchY) *
                        touchPanModifier
                    ),
                    (touchTracking.lastTouchX = touch1.clientX),
                    (touchTracking.lastTouchY = touch1.clientY))
                  : ((touchTracking.isTracking = !0),
                    (touchTracking.lastTouchX = touch1.clientX),
                    (touchTracking.lastTouchY = touch1.clientY)),
                evt.touches.length === 2)
              ) {
                var touch2 = evt.touches[1],
                  pinchDistance = Math.sqrt(
                    Math.pow(touch1.clientX - touch2.clientX, 2) +
                      Math.pow(touch1.clientY - touch2.clientY, 2)
                  );
                if (!pinchTracking.isTracking)
                  (pinchTracking.lastPinchDistance = pinchDistance),
                    (pinchTracking.isTracking = !0);
                else {
                  var pinchDelta =
                    pinchDistance - pinchTracking.lastPinchDistance;
                  alterCurrentTransformZoomBy(pinchDelta * pinchZoomMultiplier),
                    (pinchTracking.lastPinchDistance = pinchDistance);
                }
              } else pinchTracking.isTracking = !1;
            } else panZoomImageFromScreenCoordinate(evt.clientX, evt.clientY);
          }
        ),
        $allContainer.on("wheel.galleryViewer", function (evt) {
          evt.preventDefault(),
            evt.originalEvent.deltaY != 0 &&
              alterCurrentTransformZoomBy(
                evt.originalEvent.deltaY * wheelZoomMultiplier
              );
        }),
        $allContainer.on(
          "touchmove.galleryViewer",
          ".gallery-viewer__thumbs",
          function (evt) {
            evt.stopPropagation();
          }
        ),
        $allContainer.on(
          "click.galleryViewer",
          ".gallery-viewer__next",
          function (evt) {
            evt.preventDefault();
            var $next = $thumbContainer
              .find(".gallery-viewer__thumb--active")
              .next();
            $next.length === 0 &&
              ($next = $thumbContainer.find(".gallery-viewer__thumb:first")),
              $next.trigger("select");
          }
        ),
        $allContainer.on(
          "click.galleryViewer",
          ".gallery-viewer__prev",
          function (evt) {
            evt.preventDefault();
            var $prev = $thumbContainer
              .find(".gallery-viewer__thumb--active")
              .prev();
            $prev.length === 0 &&
              ($prev = $thumbContainer.find(".gallery-viewer__thumb:last")),
              $prev.trigger("select");
          }
        ),
        $allContainer.on(
          "click.galleryViewer",
          ".gallery-viewer__close",
          function (evt) {
            evt.preventDefault(), theme.galleryViewerFunctions.close();
          }
        ),
        document.addEventListener(
          "keyup",
          theme.galleryViewerFunctions.onDocumentKeyup
        ),
        $allContainer.on(
          "click.galleryViewer",
          ".gallery-viewer__zoom-container",
          function (evt) {
            evt.preventDefault(),
              currentTransform.zoom == 1
                ? ((currentTransform.zoom = 0), alterCurrentTransformZoomBy(0))
                : ((currentTransform.zoom = 1),
                  alterCurrentTransformZoomBy(0),
                  panZoomImageFromScreenCoordinate(evt.clientX, evt.clientY));
          }
        ),
        $("html").removeClass("gallery-viewer-open"),
        $(".gallery-viewer").remove(),
        $("html").addClass("gallery-viewer-open"),
        $allContainer.appendTo(galleryParent);
      var currentIndex = 0;
      config.currentImage &&
        config.images.forEach((img2, index) => {
          config.currentImage === img2.zoomUrl && (currentIndex = index);
        });
      var $focusThumb = $thumbContainer
        .find(".gallery-viewer__thumb:eq(" + currentIndex + ")")
        .trigger("select");
      config.images.length > 1 ? $focusThumb.focus() : $close.focus(),
        setTimeout(function () {
          $allContainer.removeClass("gallery-viewer--pre-reveal");
        }, 10);
    }),
    (theme.galleryViewerFunctions = {
      close: function () {
        var $galleryViewer = $(".gallery-viewer");
        $galleryViewer.off(".galleryViewer"),
          document.removeEventListener(
            "keyup",
            theme.galleryViewerFunctions.onDocumentKeyup
          ),
          $galleryViewer.addClass("gallery-viewer--transition-out");
        var transitionDelay = $galleryViewer.css("transition-duration");
        (transitionDelay =
          transitionDelay.indexOf("ms") > -1
            ? parseFloat(transitionDelay)
            : parseFloat(transitionDelay) * 1e3),
          setTimeout(function () {
            $galleryViewer.remove(),
              $("html").removeClass("gallery-viewer-open");
          }, transitionDelay);
      },
      onDocumentKeyup: function (evt) {
        switch (evt.key) {
          case "Escape":
            theme.galleryViewerFunctions.close();
            break;
          case "ArrowLeft":
            $(".gallery-viewer__prev").trigger("click");
            break;
          case "ArrowRight":
            $(".gallery-viewer__next").trigger("click");
            break;
        }
      },
    }),
    (theme.Navigation = {
      init: function (options) {
        if (options.nav.length != 0) {
          var $nav = options.nav,
            navHoverDelay = 0,
            $navLastOpenDropdown = $(),
            navOpenTimeoutId = -1,
            mobileDrawerFragment = options.mobileNavTemplate.content.cloneNode(
              !0
            ),
            $mobileDrawerFooter = $(
              '<div class="mobile-navigation-drawer__footer">'
            ).appendTo(mobileDrawerFragment.querySelector("div"));
          theme.suffixIds(mobileDrawerFragment.firstElementChild, "MobileNav"),
            document
              .getElementById("shopify-section-header")
              .insertAdjacentElement(
                "afterend",
                mobileDrawerFragment.firstElementChild
              );
          var $mobileDrawer = $(".mobile-navigation-drawer");
          $mobileDrawer.on(
            "click",
            ".navigation__tier-1 > .navigation__item > .navigation__children-toggle",
            function (evt) {
              evt.preventDefault(),
                $(this)
                  .parent()
                  .addClass("navigation__item--open")
                  .closest(".mobile-navigation-drawer")
                  .addClass("mobile-navigation-drawer--child-open")
                  .find(".mobile-nav-title")
                  .text($(this).siblings(".navigation__link").text()),
                $(this)
                  .siblings(".navigation__tier-2-container")
                  .css({
                    top:
                      Math.ceil(
                        $(".navigation__mobile-header:last").height() + 1
                      ) + "px",
                  }),
                this.closest(".mobile-navigation-drawer").scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "instant",
                });
            }
          ),
            $mobileDrawer.data("mobile-expand-with-entire-link") &&
              $mobileDrawer.on(
                "click",
                ".navigation__item--with-children > .navigation__link",
                function (evt) {
                  evt.preventDefault(),
                    $(this)
                      .siblings(".navigation__children-toggle")
                      .trigger("click");
                }
              ),
            $mobileDrawer.on("click", ".mobile-nav-back", function (evt) {
              evt.preventDefault(),
                $(this)
                  .closest(".mobile-navigation-drawer")
                  .removeClass("mobile-navigation-drawer--child-open")
                  .find(".navigation__tier-1 > .navigation__item--open")
                  .removeClass("navigation__item--open");
            }),
            $mobileDrawer.on(
              "click",
              ".navigation__tier-2 > .navigation__item > .navigation__children-toggle",
              function (evt) {
                evt.preventDefault();
                var doOpen = !$(this)
                  .parent()
                  .hasClass("navigation__item--open");
                if (doOpen) {
                  $(this).parent().addClass("navigation__item--open");
                  var $childContainer = $(this).siblings(
                    ".navigation__tier-3-container"
                  );
                  $childContainer.css(
                    "height",
                    $childContainer.children().outerHeight()
                  );
                } else
                  $(this).parent().removeClass("navigation__item--open"),
                    $(this)
                      .siblings(".navigation__tier-3-container")
                      .css("height", "");
              }
            ),
            setTimeout(() => theme.manualLazyload($nav[0]), 500),
            $nav.on(
              "mouseenter mouseleave",
              ".navigation__tier-1 > .navigation__item--with-children",
              function (evt, data) {
                var $dropdownContainer = $(this),
                  $navContainer = $(".header-cover");
                if (evt.type == "mouseenter") {
                  clearTimeout(navOpenTimeoutId),
                    clearTimeout($dropdownContainer.data("navCloseTimeoutId"));
                  var $openSiblings = $dropdownContainer.siblings(
                    ".navigation__item--show-children"
                  );
                  $openSiblings
                    .not($navLastOpenDropdown)
                    .removeClass("navigation__item--show-children"),
                    ($navLastOpenDropdown = $dropdownContainer);
                  var timeoutDelay =
                      $openSiblings.length == 0 ? 0 : navHoverDelay,
                    newNavOpenTimeoutId = setTimeout(function () {
                      theme.Navigation.alignPromos($dropdownContainer[0]),
                        $dropdownContainer
                          .addClass("navigation__item--show-children")
                          .siblings(".navigation__item--show-children")
                          .removeClass("navigation__item--show-children"),
                        $dropdownContainer
                          .closest(".section-header")
                          .addClass("section-header--nav-open"),
                        $navContainer.removeClass("indexpage-header");
                    }, timeoutDelay);
                  (navOpenTimeoutId = newNavOpenTimeoutId),
                    $dropdownContainer.data(
                      "navOpenTimeoutId",
                      newNavOpenTimeoutId
                    );
                } else
                  clearTimeout($dropdownContainer.data("navOpenTimeoutId")),
                    $dropdownContainer.data(
                      "navCloseTimeoutId",
                      setTimeout(function () {
                        $dropdownContainer.removeClass(
                          "navigation__item--show-children"
                        ),
                          $dropdownContainer
                            .closest(".section-header")
                            .removeClass("section-header--nav-open"),
                          $navContainer.addClass("indexpage-header");
                      }, navHoverDelay)
                    );
                $dropdownContainer
                  .children("[aria-expanded]")
                  .attr("aria-expanded", evt.type == "mouseenter");
              }
            );
          var touchHandler = function (evt) {
            if ($(window).width() > 767) {
              if (evt.type == "touchstart")
                $(this).data("touchstartedAt", evt.timeStamp);
              else if (evt.type == "touchend") {
                if (evt.timeStamp - $(this).data("touchstartedAt") < 1e3)
                  return (
                    $(this).data("touchOpenTriggeredAt", evt.timeStamp),
                    $(this).parent().hasClass("navigation__item--show-children")
                      ? $(this).parent().trigger("mouseleave")
                      : ($(
                          ".navigation:first .navigation__item--show-children"
                        ).trigger("mouseleave"),
                        $(this).parent().trigger("mouseenter")),
                    !1
                  );
              } else if (
                evt.type == "click" &&
                $(this).data("touchOpenTriggeredAt") &&
                evt.timeStamp - $(this).data("touchOpenTriggeredAt") < 1e3
              )
                return !1;
            }
          };
          $nav.delegateSimplePassiveEvent(
            "touchstart",
            ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
            touchHandler
          ),
            $nav.on(
              "touchend click",
              ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
              touchHandler
            );
          var keydownHandler = function (evt) {
            if (evt.which == 13) {
              var $parent = $(this).parent();
              return (
                $parent.trigger(
                  $parent.hasClass("navigation__item--show-children")
                    ? "mouseleave"
                    : "mouseenter"
                ),
                !1
              );
            }
          };
          $nav.on(
            "keydown",
            ".navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle",
            keydownHandler
          ),
            $nav.on(
              "click",
              '.navigation__link[href="#"][aria-haspopup="true"]',
              function () {
                return (
                  $(this)
                    .siblings(".navigation__children-toggle")
                    .trigger("click"),
                  !1
                );
              }
            );
        }
      },
      alignPromos: function (dropdown) {
        var promos = dropdown.querySelectorAll(
          ".navigation__columns--with-promos .menu-promotion"
        );
        if (promos.length > 1) {
          for (var tallest = 0, i = 0; i < promos.length; i++) {
            var promo = promos[i];
            promo.firstElementChild.classList.contains(
              "menu-promotion__link"
            ) && (promo = promo.firstElementChild);
            for (
              var promoInnerHeights = 0, j = 0;
              j < promo.childNodes.length;
              j++
            ) {
              var el = promo.childNodes[j];
              promoInnerHeights += el.offsetHeight;
              var cs = getComputedStyle(el);
              (promoInnerHeights +=
                parseFloat(cs.marginTop) + parseFloat(cs.marginBottom)),
                j === 0 && (promoInnerHeights -= parseFloat(cs.paddingBottom));
            }
            promoInnerHeights > tallest && (tallest = promoInnerHeights);
          }
          for (var _i = 0; _i < promos.length; _i++) {
            var _promo = promos[_i];
            _promo.firstElementChild.classList.contains(
              "menu-promotion__link"
            ) && (_promo = _promo.firstElementChild);
            for (
              var _promoInnerHeights = 0, _j = 0;
              _j < _promo.childNodes.length;
              _j++
            ) {
              var _el = _promo.childNodes[_j];
              _promoInnerHeights += _el.offsetHeight;
              var _cs = getComputedStyle(_el);
              (_promoInnerHeights +=
                parseFloat(_cs.marginTop) +
                parseFloat(_cs.marginBottom) -
                parseFloat(_cs.paddingTop)),
                _j === 0 &&
                  (_promoInnerHeights -= parseFloat(_cs.paddingBottom));
            }
            var toAdd = tallest - _promoInnerHeights;
            toAdd > 0 &&
              _promo
                .closest(".menu-promotion")
                .style.setProperty("--height-offset", toAdd + "px");
          }
        }
      },
      destroy: function ($nav) {
        $nav.off("click mouseenter mouseleave touchstart touchend keydown"),
          $(".mobile-navigation-drawer").off("click").remove();
      },
    });
  var CCProductBlock = class extends HTMLElement {
    constructor() {
      super(),
        (this.manualLoad = this.hasAttribute("manual-load")),
        this.manualLoad || theme.lazy.initScript(this, this.init.bind(this));
    }
    init() {
      (this.enableSwipe = this.hasAttribute("enable-swipe")),
        (this.images = this.querySelectorAll(".product-block__image")),
        (this.dots = this.querySelectorAll(".product-block__image-dot")),
        theme.manualLazyload(this),
        this.isDesktop()
          ? (setTimeout(() => {
              this.querySelectorAll(
                ".product-block__image--show-on-hover.product-block__image--inactivated"
              ).forEach((el) => {
                this.lazyloadImage(el);
              });
            }, 250),
            setTimeout(() => {
              this.querySelectorAll(
                ".product-block__image--show-on-hover + .product-block__image--inactivated"
              ).forEach((el) => {
                this.lazyloadImage(el);
              });
            }, 1e3))
          : setTimeout(() => {
              this.querySelectorAll(
                ".product-block__image--show-on-hover.product-block__image--inactivated"
              ).forEach((el) => {
                this.lazyloadImage(el);
              });
            }, 1e3),
        this.monitorImagePagination(),
        this.monitorSwatchSelection();
    }
    isDesktop() {
      return $(window).width() >= 768;
    }
    getImageAt(index) {
      return this.images[
        ((index % this.images.length) + this.images.length) % this.images.length
      ];
    }
    lazyloadImage(imageContainer) {
      if (
        imageContainer &&
        imageContainer.classList.contains("product-block__image--inactivated")
      ) {
        var template = imageContainer.querySelector("template");
        template.parentElement.appendChild(template.content),
          template.remove(),
          theme.buildBackgroundImage(
            imageContainer.querySelector(".js-background-image")
          ),
          imageContainer.classList.remove("product-block__image--inactivated");
      }
    }
    incrementActiveImage(increment) {
      this.setActiveImage(
        theme.elementIndex(
          this.querySelector(".product-block__image--active")
        ) + increment
      );
    }
    setActiveImage(index) {
      var newActive = this.getImageAt(index);
      this.lazyloadImage(newActive);
      for (var i = 0; i < this.images.length; i++)
        this.images[i].classList.remove("product-block__image--active");
      newActive.classList.add("product-block__image--active");
      for (var _i2 = 0; _i2 < this.images.length; _i2++)
        this.images[_i2].classList.remove(
          "product-block__image--show-on-hover"
        );
      var hoverImage = this.getImageAt(index + 1);
      hoverImage.classList.add("product-block__image--show-on-hover"),
        this.lazyloadImage(hoverImage);
      for (var _i3 = 0; _i3 < this.dots.length; _i3++)
        this.dots[_i3].classList.toggle(
          "product-block__image-dot--active",
          _i3 === index
        );
    }
    selectSwatch(evt, delegateTarget) {
      if (delegateTarget.dataset.media) {
        var index = theme.elementIndex(
          this.querySelector(
            '[data-media-id="' +
              delegateTarget.dataset.media +
              '"].product-block__image'
          )
        );
        this.setActiveImage(index);
      }
      delegateTarget.dataset.cardBg
        ? ((this.swatchCardPropertySet = !0),
          this.querySelector(".card-scheme").style.setProperty(
            "--bg",
            delegateTarget.dataset.cardBg
          ))
        : this.swatchCardPropertySet &&
          this.querySelector(".card-scheme").style.removeProperty("--bg");
      var optionName = delegateTarget.closest(".product-block-options").dataset
          .optionName,
        optionValue = delegateTarget.dataset.optionItem;
      this.querySelectorAll(".product-link, .quickbuy-toggle").forEach((el) => {
        var url = new URL(el.href),
          params = new URLSearchParams(url.search);
        params.set(optionName, optionValue),
          (el.href = "".concat(url.pathname, "?").concat(params)),
          (el.rel = "nofollow");
      });
    }
    monitorSwatchSelection() {
      this.querySelector(".product-block-options__item") &&
        (theme.addDelegateEventListener(
          this,
          "mouseover",
          ".product-block-options__item",
          this.selectSwatch.bind(this)
        ),
        theme.addDelegateEventListener(
          this,
          "click",
          ".product-block-options__item",
          this.selectSwatch.bind(this)
        ));
    }
    preloadAllImages() {
      for (var i = 0; i < this.images.length; i++)
        this.lazyloadImage(this.images[i]);
    }
    monitorImagePagination() {
      if (
        this.images.length > 1 &&
        (theme.addDelegateEventListener(
          this,
          "click",
          ".image-page-button",
          function (evt, delegateTarget) {
            this.incrementActiveImage(
              delegateTarget.classList.contains("image-page-button--next")
                ? 1
                : -1
            ),
              this.preloadAllImages(),
              evt.preventDefault(),
              evt.stopPropagation();
          }.bind(this)
        ),
        this.enableSwipe)
      ) {
        var imgCont = this.querySelector(".image-cont--with-secondary-image");
        imgCont.addEventListener(
          "touchstart",
          (evt) => {
            (theme.productBlockTouchTracking = !0),
              (theme.productBlockTouchStartX = evt.touches[0].clientX),
              (theme.productBlockTouchStartY = evt.touches[0].clientY);
            var nextImage = this.querySelector(
              ".product-block__image--active + .product-block__image--inactivated"
            );
            nextImage && this.lazyloadImage(nextImage);
          },
          { passive: !0 }
        ),
          imgCont.addEventListener(
            "touchmove",
            (evt) => {
              if (
                theme.productBlockTouchTracking &&
                Math.abs(
                  evt.touches[0].clientY - theme.productBlockTouchStartY
                ) < 30
              ) {
                var deltaX =
                  evt.touches[0].clientX - theme.productBlockTouchStartX;
                deltaX > 25
                  ? (this.incrementActiveImage(-1),
                    (theme.productBlockTouchTracking = !1),
                    setTimeout(() => this.preloadAllImages(), 500))
                  : deltaX < -25 &&
                    (this.incrementActiveImage(1),
                    (theme.productBlockTouchTracking = !1),
                    setTimeout(() => this.preloadAllImages(), 500));
              }
            },
            { passive: !0 }
          ),
          imgCont.addEventListener("touchend", (evt) => {
            theme.productBlockTouchTracking = !1;
          });
      }
    }
  };
  window.customElements.define("product-block", CCProductBlock),
    (theme.initProductGallery = function (container2) {
      var $gallery = $(".gallery", container2);
      if (!$gallery.hasClass("gallery-initialised")) {
        if (
          ($gallery.addClass("gallery-initialised"),
          $gallery.data("variant-image-grouping") &&
            $gallery.data("variant-image-grouping-option-index") !== "")
        ) {
          var productData = theme.OptionManager.getProductData(
              $gallery.closest(".product-detail").find(".product-form")
            ),
            groupingOptionIndex = $gallery.data(
              "variant-image-grouping-option-index"
            ),
            optionNameMediaMap = {};
          productData.media.forEach((media) => {
            productData.variants.forEach((variant) => {
              variant.featured_media &&
                variant.featured_media.id == media.id &&
                (optionNameMediaMap[variant.options[groupingOptionIndex]] ||
                  (optionNameMediaMap[variant.options[groupingOptionIndex]] =
                    media.id));
            });
          });
          var currentMediaOptionName = "";
          $gallery.find(".slide").each(function (index, item) {
            for (var optionName in optionNameMediaMap)
              $(item).data("media-id") == optionNameMediaMap[optionName] &&
                (currentMediaOptionName = optionName);
            $(item).attr("data-variant-image-group", currentMediaOptionName);
          }),
            (currentMediaOptionName = ""),
            $gallery.find(".thumbnail").each(function (index, item) {
              for (var optionName in optionNameMediaMap)
                $(item).data("media-id") == optionNameMediaMap[optionName] &&
                  (currentMediaOptionName = optionName);
              $(item).attr("data-variant-image-group", currentMediaOptionName);
            });
        }
        var $slideshow = $(".product-slideshow", container2),
          $controlArrow = $slideshow
            .siblings(".slideshow-controls")
            .find(".slideshow-controls__arrows");
        if ($slideshow.length) {
          var slickConfig = {
            autoplay: !1,
            fade: !1,
            infinite: !1,
            useTransform: !0,
            dots: !0,
            arrows: !1,
            waitForAnimate: !1,
            appendArrows: $controlArrow,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' +
              theme.strings.previous +
              '">' +
              theme.icons.chevronLeft +
              "</button>",
            nextArrow:
              '<button type="button" class="slick-next" aria-label="' +
              theme.strings.next +
              '">' +
              theme.icons.chevronRight +
              "</button>",
            mobileFirst: !0,
            customPaging: function (slider, i) {
              return "<button class='custom-line' type='button' data-role='none' role='button' tabindex='0'><svg xmlns='http://www.w3.org/2000/svg' width='40px' height='2px' viewBox='0 0 40 2' xml:space='preserve'><rect class='line-one' width='40' height='2' fill='#3974E5'></rect><rect class='line-two' width='40' height='2' fill='#A4A4A4'></rect></svg></button>";
            },
            rtl: !!document.querySelector("html[dir=rtl]"),
            responsive: [
              { breakpoint: 768, settings: { fade: !0, arrows: !0 } },
            ],
          };
          if ($(window).width() > 767) {
            let hoverFunction = function (e) {
              let x = Number(e.pageX),
                y = Number(e.pageY),
                slideshowLeft = Number($slideshow.offset().left),
                slideshowWidth = Number($slideshow.width()),
                slideshowLeftAreaStart = slideshowLeft,
                slideshowLeftAreaEnd = slideshowLeft + slideshowWidth * 0.4,
                slideshowRightAreaStart = slideshowLeft + slideshowWidth * 0.6,
                slideshowRightAreaEnd = slideshowLeft + slideshowWidth,
                slideshowTop = Number($slideshow.offset().top);
              var slideshowTopEnd = slideshowTop + Number($slideshow.height());
              x > slideshowLeftAreaStart &&
              x < slideshowLeftAreaEnd &&
              y > slideshowTop &&
              y < slideshowTopEnd
                ? $controlArrow.addClass("show-left").removeClass("show-right")
                : x > slideshowRightAreaStart &&
                  x < slideshowRightAreaEnd &&
                  y > slideshowTop &&
                  y < slideshowTopEnd
                ? $controlArrow.addClass("show-right").removeClass("show-left")
                : $controlArrow.removeClass("show-left show-right");
            };
            $(window.document.body).mousemove(hoverFunction);
          }
          if (
            ($slideshow.on(
              "beforeChange",
              function (evt, slick, current, next) {
                var mediaId = $(slick.$slides[next]).data("media-id");
                $(
                  $(this)
                    .closest(".gallery")
                    .find(
                      '.thumbnails:not(.hidden) .thumbnail[data-media-id="' +
                        mediaId +
                        '"]'
                    )
                ).trigger("selectFromSlick");
              }
            ),
            $slideshow.closest(
              ".gallery--layout-carousel-beside, .gallery--layout-carousel-under"
            ).length)
          )
            $slideshow.slick(slickConfig);
          else {
            var enforceMobileSlideshow = function () {
              $(window).width() < 768
                ? $slideshow.not(".slick-slider").each(function () {
                    $(this)
                      .find(".slide--inactive-option")
                      .removeClass("slide--inactive-option"),
                      $(this).slick(slickConfig),
                      $(this)
                        .closest(".product-detail")
                        .find(".original-selector")
                        .trigger("change");
                  })
                : $slideshow.filter(".slick-slider").each(function () {
                    $(this).slick("slickUnfilter").slick("unslick"),
                      $(this)
                        .closest(".product-detail")
                        .find(".original-selector")
                        .trigger("change");
                  });
            };
            enforceMobileSlideshow(),
              $(window).on(
                "debouncedresize.productGallery",
                enforceMobileSlideshow
              );
          }
          theme.ProductMedia.init($gallery, {
            onYoutubeInit: function (playerObj) {
              $slideshow.hasClass("slick-slider") &&
                theme.productGallerySlideshowTabFix(
                  $slideshow.slick("getSlick").$slides,
                  $slideshow.slick("getSlick").currentSlide
                );
            },
            onModelViewerInit: function (element) {
              $slideshow.hasClass("slick-slider") &&
                theme.productGallerySlideshowTabFix(
                  $slideshow.slick("getSlick").$slides,
                  $slideshow.slick("getSlick").currentSlide
                );
            },
            onVideoVisible: function (e) {
              $(window).width() >= 768 &&
                $(e.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "swipe", !1);
            },
            onModelViewerPlay: function (e) {
              $(e.target)
                .closest(".slick-slider")
                .slick("slickSetOption", "swipe", !1),
                $(e.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "accessibility", !1);
            },
            onModelViewerPause: function (e) {
              $(e.target)
                .closest(".slick-slider")
                .slick("slickSetOption", "swipe", !0),
                $(e.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "accessibility", !0);
            },
          }),
            $slideshow.hasClass("slick-slider") &&
              theme.productGallerySlideshowTabFix(
                $slideshow.slick("getSlick").$slides,
                $slideshow.slick("getSlick").currentSlide
              ),
            $slideshow.on("afterChange", function (evt, slick, current) {
              theme.pauseAllMedia(),
                $(window).width() >= 768 && slick.slickSetOption("swipe", !0),
                $(".product-media", slick.$slides[current]).trigger(
                  "mediaVisible"
                ),
                theme.productGallerySlideshowTabFix(slick.$slides, current);
            });
        }
        var $thumbnails = $(".thumbnails:not(.hidden)", container2);
        $thumbnails.length &&
          $(".gallery", container2).on(
            "click select selectFromSlick",
            ".thumbnail",
            function (e) {
              if (
                (e.preventDefault(),
                this.closest("cc-carousel").get().selectItem(this),
                e.type != "selectFromSlick")
              ) {
                var index = 0,
                  mediaId = $(this).data("media-id");
                $(this)
                  .parent()
                  .children(":visible")
                  .each(function (iter) {
                    if (((index = iter), $(this).data("media-id") == mediaId))
                      return !1;
                  });
                var _$slideshow = $(this)
                  .closest(".gallery")
                  .find(".slick-slider");
                if (_$slideshow.length) {
                  var slick = _$slideshow.slick("getSlick");
                  slick.currentSlide === index
                    ? $(this).trigger("selectFromSlick")
                    : _$slideshow.slick("slickGoTo", index);
                }
              } else
                $(this)
                  .addClass("selected")
                  .siblings(".selected")
                  .removeClass("selected");
            }
          );
      }
    }),
    (theme.destroyProductGallery = function (container2) {
      $(window).off(".productGallery");
      var $gallery = $(".gallery", container2).off(
        "click select selectFromSlick"
      );
      theme.ProductMedia.destroy($gallery),
        $(".slick-slider", container2)
          .slick("unslick")
          .off("init beforeChange afterChange");
    }),
    (theme.ProductMedia = new (function () {
      var _ = this;
      (_._setupShopifyXr = function () {
        if (!window.ShopifyXR) {
          document.addEventListener(
            "shopify_xr_initialized",
            _._setupShopifyXr.bind(this)
          );
          return;
        }
        window.ShopifyXR.addModels(JSON.parse($(this).html())),
          window.ShopifyXR.setupXRElements();
      }),
        (this.init = function (container2, callbacks) {
          var callbacks = callbacks || {},
            _container = container2;
          $(container2)
            .find(".product-media--video")
            .each(function (index) {
              var poster = this.querySelector(".product-media__poster");
              $(".product-media__video-play-btn", poster).on(
                "click",
                function () {
                  $(this)
                    .closest(".product-media--video")
                    .data("player")
                    .play();
                }
              );
              var playerObj = { container: this, poster };
              playerObj.play = function () {
                theme.pauseAllMedia(),
                  this.poster.classList.add("product-media__poster--hide"),
                  $(this).closest(".slick-slider").slick("setPosition"),
                  this.container
                    .querySelectorAll(".js-youtube")
                    .forEach((video) => {
                      video.contentWindow.postMessage(
                        '{"event":"command","func":"playVideo","args":""}',
                        "*"
                      );
                    }),
                  this.container
                    .querySelectorAll(".js-vimeo")
                    .forEach((video) => {
                      video.contentWindow.postMessage('{"method":"play"}', "*");
                    }),
                  this.container
                    .querySelectorAll("video")
                    .forEach((video) => video.play());
              }.bind(playerObj);
              var template = this.querySelector(
                ".product-media__video-template"
              );
              template &&
                (this.insertAdjacentHTML("beforeend", template.innerHTML),
                this.removeChild(template),
                (this.style.paddingBottom =
                  100 /
                    this.querySelector("video, iframe").getAttribute(
                      "aspect-ratio"
                    ) +
                  "%")),
                $(this)
                  .data("player", playerObj)
                  .addClass("product-media--video-loaded");
            }),
            $(container2).on(
              "mediaVisible",
              ".product-media--video-loaded, .product-media--model-loaded",
              function () {
                $(window).width() >= 768 && $(this).data("player").play(),
                  $(this).hasClass("product-media--model") &&
                    $(".view-in-space", _container).attr(
                      "data-shopify-model3d-id",
                      $(this).data("model-id")
                    );
              }
            ),
            callbacks.onVideoVisible &&
              $(container2).on(
                "mediaVisible",
                ".product-media--video-loaded",
                callbacks.onVideoVisible
              ),
            $("model-viewer", container2).each(function () {
              callbacks.onModelViewerPlay &&
                $(this).on(
                  "shopify_model_viewer_ui_toggle_play",
                  callbacks.onModelViewerPlay
                ),
                callbacks.onModelViewerPause &&
                  $(this).on(
                    "shopify_model_viewer_ui_toggle_pause",
                    callbacks.onModelViewerPause
                  );
            }),
            $(container2).on(
              "mediaVisible mediaVisibleInitial",
              ".product-media--model:not(.product-media--model-loaded)",
              function (e) {
                var element = $(this).find("model-viewer")[0],
                  autoplay = e.type != "mediaVisibleInitial";
                theme.loadStyleOnce(
                  "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"
                ),
                  window.Shopify.loadFeatures([
                    {
                      name: "model-viewer-ui",
                      version: "1.0",
                      onLoad: function () {
                        $(this).data(
                          "player",
                          new Shopify.ModelViewerUI(element)
                        ),
                          $(this).addClass("product-media--model-loaded"),
                          callbacks.onModelViewerInit &&
                            callbacks.onModelViewerInit(element),
                          autoplay && $(this).trigger("mediaVisible");
                      }.bind(this),
                    },
                  ]);
              }
            ),
            $(".model-json", container2).length &&
              window.Shopify.loadFeatures([
                {
                  name: "shopify-xr",
                  version: "1.0",
                  onLoad: _._setupShopifyXr.bind($(".model-json", container2)),
                },
              ]),
            $(document).on("shopify_xr_launch", function () {
              theme.pauseAllMedia({ videos: !0 });
            }),
            setTimeout(
              function () {
                $(".product-slideshow.slick-slider .product-media:first", this)
                  .filter(".product-media--model")
                  .trigger("mediaVisibleInitial"),
                  $(
                    ".product-slideshow:not(.slick-slider) .product-media--model",
                    this
                  ).trigger("mediaVisibleInitial");
              }.bind(container2),
              50
            );
        }),
        (this.destroy = function (container2) {
          $(document).off("shopify_xr_launch"),
            $(container2).off("mediaVisible mediaVisibleInitial"),
            $(".product-media--model-loaded", container2).each(function () {
              $(this).data("player").destroy();
            }),
            $(".product-media--video video", container2).off(
              "playing pause ended"
            ),
            $("model-viewer", container2).off(
              "shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause"
            );
        });
    })()),
    (theme.productGallerySlideshowTabFix = function (slides, current) {
      $(slides[current])
        .find(
          "a, input, button, select, iframe, video, model-viewer, [tabindex]"
        )
        .each(function () {
          typeof $(this).data("theme-slideshow-original-tabindex") < "u"
            ? $(this).data("theme-slideshow-original-tabindex") === !1
              ? $(this).removeAttr("tabindex")
              : $(this).attr(
                  "tabindex",
                  $(this).data("theme-slideshow-original-tabindex")
                )
            : $(this).removeAttr("tabindex");
        }),
        $(slides)
          .not(slides[current])
          .find(
            "a, input, button, select, iframe, video, model-viewer, [tabindex]"
          )
          .each(function () {
            typeof $(this).data("theme-slideshow-original-tabindex") > "u" &&
              ($(this).data(
                "theme-slideshow-original-tabindex",
                typeof $(this).attr("tabindex") < "u"
                  ? $(this).attr("tabindex")
                  : !1
              ),
              $(this).attr("tabindex", "-1"));
          });
    }),
    (theme.productData = {}),
    (theme.OptionManager = new (function () {
      var _ = this;
      (_._getVariantOptionElement = function (variant, $container) {
        return $container.find(
          'select[name="id"] option[value="' +
            (variant ? variant.id : "") +
            '"]'
        );
      }),
        (_.selectors = {
          container: ".product-detail",
          gallery: ".gallery",
          priceArea: ".price-area",
          variantIdInputs: '[name="id"]',
          purchaseForm: ".product-purchase-form",
          primaryVariantIdInput: '.product-purchase-form [name="id"]',
          submitButton: '.product-purchase-form button[type="submit"]',
          multiOption: ".option-selectors",
          customOption: ".custom-option",
          installmentsFormSuffix: "-installments",
        }),
        (_.strings = {
          buttonDefault: theme.strings.products_product_add_to_cart,
          buttonNoStock: theme.strings.products_variant_no_stock,
          buttonNoVariant: theme.strings.products_variant_non_existent,
        }),
        (_.getProductData = function ($form) {
          var productId = $form.data("product-id"),
            data = null;
          return (
            theme.productData[productId] ||
              (theme.productData[productId] = JSON.parse(
                document.querySelector(
                  'script[data-product-json="'.concat(productId, '"]')
                ).innerHTML
              )),
            (data = theme.productData[productId]),
            data ||
              console.log(
                "Product data missing (id: " + $form.data("product-id") + ")"
              ),
            data
          );
        }),
        (_.getVariantFromId = function ($productForm, id) {
          for (
            var variants = this.getProductData($productForm).variants, i = 0;
            i < variants.length;
            i++
          )
            if (variants[i].id == id) return variants[i];
          return { available: !1 };
        }),
        (_.getCurrentVariantData = function ($productForm) {
          return _.getVariantFromId(
            $productForm,
            $productForm.find(_.selectors.primaryVariantIdInput).val()
          );
        }),
        (_.getBaseUnit = function (variant) {
          return variant.unit_price_measurement.reference_value === 1
            ? variant.unit_price_measurement.reference_unit
            : variant.unit_price_measurement.reference_value +
                variant.unit_price_measurement.reference_unit;
        }),
        (_.addVariantUrlToHistory = function (variant) {
          if (variant) {
            var newurl =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              variant.id;
            window.history.replaceState({ path: newurl }, "", newurl);
          }
        }),
        (_.updateSku = function (variant, $container) {
          $container.find(".sku .sku__value").html(variant ? variant.sku : ""),
            $container
              .find(".sku")
              .toggleClass("sku--no-sku", !variant || !variant.sku);
        }),
        (_.updateBarcode = function (variant, $container) {
          $container
            .find(".barcode .barcode__value")
            .html(variant ? variant.barcode : ""),
            $container
              .find(".barcode")
              .toggleClass("barcode--no-barcode", !variant || !variant.barcode);
        }),
        (_.updateTransferNotice = function (variant, $container) {
          var transferData = _._getVariantOptionElement(
            variant,
            $container
          ).data("inventory-transfer");
          transferData
            ? $container
                .find(".product-inventory-transfer")
                .removeClass("product-inventory-transfer--none")
                .html(transferData)
            : $container
                .find(".product-inventory-transfer")
                .addClass("product-inventory-transfer--none")
                .empty();
        }),
        (_.updateVariantDeterminedVisibilityAreas = function (
          variant,
          $container
        ) {
          $container.find(".variant-visibility-area").each(function () {
            $(this).children(":not(script)").remove(),
              variant
                ? $(this).append(
                    $(this)
                      .children('script[data-variant-id="' + variant.id + '"]')
                      .html()
                  )
                : $(this).append(
                    $(this).children('script[data-variant-id=""]').html()
                  );
          });
        }),
        (_.updateBackorder = function (variant, $container) {
          var $backorder = $container.find(".backorder");
          if ($backorder.length)
            if (variant && variant.available)
              if (
                variant.inventory_management &&
                _._getVariantOptionElement(variant, $container).data("stock") ==
                  "out"
              ) {
                var productData = _.getProductData(
                  $backorder.closest(".product-form")
                );
                $backorder
                  .find(".backorder__variant")
                  .html(
                    productData.title +
                      (variant.title.indexOf("Default") >= 0
                        ? ""
                        : " - " + variant.title)
                  ),
                  $backorder.show();
              } else $backorder.hide();
            else $backorder.hide();
        }),
        (_._updateButtonText = function ($button, string, variant) {
          $button.each(function () {
            var newVal;
            (newVal = _.strings["button" + string]),
              newVal !== !1 &&
                ($(this).is("input")
                  ? $(this).val(newVal)
                  : $(this).html(newVal));
          });
        }),
        (_.updateButtons = function (variant, $container) {
          var $button = $container.find(_.selectors.submitButton);
          variant
            ? ($button.removeAttr("disabled"),
              variant.available == !0
                ? _._updateButtonText($button, "Default", variant)
                : _._updateButtonText($button, "NoStock", variant))
            : theme.getEmptyOptionSelectors($container).length
            ? ($button.removeAttr("disabled"),
              _._updateButtonText($button, "Default", variant))
            : ($button.attr("disabled", "disabled"),
              _._updateButtonText($button, "NoVariant", variant));
        }),
        (_.updateContainerStatusClasses = function (variant, $container) {
          $container.toggleClass("variant-status--not-selected", !variant),
            $container.toggleClass(
              "variant-status--unavailable",
              variant && !variant.available
            ),
            $container.toggleClass(
              "variant-status--backorder",
              variant &&
                variant.available &&
                variant.inventory_management &&
                _._getVariantOptionElement(variant, $container).data("stock") ==
                  "out"
            ),
            $container.toggleClass(
              "variant-status--on-sale",
              variant &&
                variant.available &&
                variant.compare_at_price > variant.price
            );
        }),
        (_.updateCardBG = function (variant, $container) {
          if (variant) {
            var bg = _._getVariantOptionElement(variant, $container).data(
              "card-bg"
            );
            if (bg) {
              $container[0]
                .querySelector(".gallery__inner")
                .style.setProperty("--bg", bg);
              return;
            }
          }
          $container[0]
            .querySelector(".gallery__inner")
            .style.removeProperty("--bg");
        }),
        (_.selectOptionFromURL = function (productUrl, $productForm) {
          var searchParams = null;
          productUrl && productUrl.indexOf("?") >= 0
            ? (searchParams = new URLSearchParams(productUrl.split("?")[1]))
            : productUrl !== !1 &&
              (searchParams = new URLSearchParams(location.search));
          var _loop3 = function (key2) {
            key2 == "variant"
              ? _.setVariant($productForm, searchParams.get(key2))
              : $productForm
                  .find(".option-selector")
                  .filter(function () {
                    return (
                      this.querySelector(".label").firstChild.textContent ===
                      key2
                    );
                  })
                  .each(function () {
                    var value = searchParams.get(key2);
                    this.dataset.selectorType == "dropdown"
                      ? this.querySelector(".cc-select").dispatchEvent(
                          new CustomEvent("selectOption", { detail: { value } })
                        )
                      : this.querySelectorAll(".opt-label__text").forEach(
                          (el) => {
                            if (el.innerText == value) {
                              var input = document.getElementById(
                                el.parentElement.getAttribute("for")
                              );
                              input &&
                                ((input.checked = !0),
                                input.dispatchEvent(
                                  new CustomEvent("change", {
                                    bubbles: !0,
                                    cancelable: !1,
                                  })
                                ));
                            }
                          }
                        );
                  });
          };
          for (var key of searchParams.keys()) _loop3(key);
        }),
        (_.setVariant = function ($productForm, id) {
          var variant = _.getVariantFromId($productForm, id);
          $productForm.find(".option-selector").each(function () {
            var value = variant.options[parseInt(this.dataset.optionIndex)];
            this.dataset.selectorType == "dropdown"
              ? this.querySelector(".cc-select").dispatchEvent(
                  new CustomEvent("selectOption", { detail: { value } })
                )
              : this.querySelectorAll(".opt-label__text").forEach((el) => {
                  if (el.innerText == value) {
                    var input = document.getElementById(
                      el.parentElement.getAttribute("for")
                    );
                    input &&
                      !input.checked &&
                      ((input.checked = !0),
                      input.dispatchEvent(
                        new CustomEvent("change", {
                          bubbles: !0,
                          cancelable: !1,
                        })
                      ));
                  }
                });
          });
        }),
        (_.initProductOptions = function ($productForm, productUrl) {
          if (!$productForm.hasClass("theme-init")) {
            var productData = _.getProductData($productForm);
            $productForm.addClass("theme-init"),
              $productForm
                .find(_.selectors.multiOption)
                .on("change.themeProductOptions", function () {
                  var selectedOptions = [];
                  $(this)
                    .find(".option-selector")
                    .each(function () {
                      $(this).data("selector-type") === "listed"
                        ? selectedOptions.push(
                            $(this).find(".js-option:checked").val()
                          )
                        : selectedOptions.push(
                            $(this)
                              .find('.js-option[aria-selected="true"]')
                              .data("value")
                          );
                    });
                  for (
                    var variant = !1, i = 0;
                    i < productData.variants.length;
                    i++
                  ) {
                    for (
                      var v = productData.variants[i], matchCount = 0, j = 0;
                      j < selectedOptions.length;
                      j++
                    )
                      v.options[j] == selectedOptions[j] && matchCount++;
                    if (matchCount == selectedOptions.length) {
                      variant = v;
                      break;
                    }
                  }
                  $productForm
                    .find(_.selectors.variantIdInputs)
                    .val(variant.id),
                    $productForm
                      .find(_.selectors.variantIdInputs)
                      .each(function () {
                        this.dispatchEvent(
                          new CustomEvent("change", {
                            bubbles: !0,
                            cancelable: !1,
                            detail: { variant, selectedOptions },
                          })
                        );
                      });
                }),
              $productForm
                .find(_.selectors.customOption)
                .each(function () {
                  var $input = $(this).find("input:first, textarea, select");
                  $('<input type="hidden">')
                    .attr({ name: $input.attr("name"), value: $input.val() })
                    .appendTo($productForm.find(_.selectors.purchaseForm));
                })
                .on("change.themeProductOptions", function () {
                  var $radios = $(this).find('input[type="radio"]'),
                    $checkbox = $(this).find('input[type="checkbox"]');
                  if ($radios.length)
                    $productForm
                      .find(_.selectors.purchaseForm + " input")
                      .filter(function () {
                        return this.name === $radios[0].name;
                      })
                      .val($radios.filter(":checked").val())
                      .trigger("change");
                  else if ($checkbox.length) {
                    var val = null;
                    $checkbox.is(":checked")
                      ? (val = $checkbox.val())
                      : (val = $checkbox.siblings('[type="hidden"]').val()),
                      $productForm
                        .find(_.selectors.purchaseForm + " input")
                        .filter(function () {
                          return this.name === $checkbox[0].name;
                        })
                        .val(val)
                        .trigger("change");
                  } else {
                    var $input = $(this).find("select, input, textarea");
                    $productForm
                      .find(_.selectors.purchaseForm + " input")
                      .filter(function () {
                        return this.name === $input.attr("name");
                      })
                      .val($input.val())
                      .trigger("change");
                  }
                }),
              $productForm
                .find(_.selectors.primaryVariantIdInput)
                .each(function () {
                  $(this).on(
                    "change.themeProductOptions firstrun.themeProductOptions",
                    function (e) {
                      if (!$(this).is("input[type=radio]:not(:checked)")) {
                        var variant = e.detail ? e.detail.variant : null;
                        if (!variant && variant !== !1)
                          for (var i = 0; i < productData.variants.length; i++)
                            productData.variants[i].id == $(this).val() &&
                              (variant = productData.variants[i]);
                        var $container = $(this).closest(_.selectors.container),
                          $addToCart = $container
                            .find(_.selectors.submitButton)
                            .filter("[data-add-to-cart-text]");
                        if (
                          ($addToCart.length &&
                            (_.strings.buttonDefault =
                              $addToCart.data("add-to-cart-text")),
                          _.updateButtons(variant, $container),
                          $(window).trigger("cc-variant-updated", {
                            variant,
                            product: productData,
                          }),
                          variant && variant.featured_media)
                        )
                          $container
                            .find(_.selectors.gallery)
                            .trigger("variantImageSelected", [
                              variant,
                              e.type === "firstrun",
                            ]);
                        else if (e.detail && e.detail.selectedOptions) {
                          var matchesRequired = e.detail.selectedOptions.filter(
                            (o) => o.length > 0
                          ).length;
                          if (matchesRequired > 0)
                            for (
                              var i = 0;
                              i < productData.variants.length;
                              i++
                            ) {
                              for (
                                var v = productData.variants[i],
                                  matchCount = 0,
                                  j = 0;
                                j < e.detail.selectedOptions.length;
                                j++
                              )
                                v.options[j] == e.detail.selectedOptions[j] &&
                                  matchCount++;
                              if (
                                matchCount == matchesRequired &&
                                v.featured_media
                              ) {
                                $container
                                  .find(_.selectors.gallery)
                                  .trigger("variantImageSelected", [
                                    v,
                                    e.type === "firstrun",
                                  ]);
                                break;
                              }
                            }
                        }
                        _.updateBarcode(variant, $container),
                          _.updateSku(variant, $container),
                          _.updateTransferNotice(variant, $container),
                          _.updateVariantDeterminedVisibilityAreas(
                            variant,
                            $container
                          ),
                          _.updateBackorder(variant, $container),
                          _.updateContainerStatusClasses(variant, $container),
                          _.updateCardBG(variant, $container),
                          $productForm.data("enable-history-state") &&
                            e.type == "change" &&
                            _.addVariantUrlToHistory(variant),
                          $productForm.trigger("variantChanged", [
                            variant,
                            productData,
                          ]);
                      }
                    }
                  ),
                    $(this).trigger("firstrun");
                }),
              theme.applyAjaxToProductForm($productForm),
              $productForm.closest(".quickbuy-modal").length === 0 &&
                _.selectOptionFromURL(productUrl, $productForm);
          }
        }),
        (_.unloadProductOptions = function ($productForm) {
          $productForm.removeClass("theme-init").each(function () {
            $(this).trigger("unloading").off(".themeProductOptions"),
              $(this).find(_.selectors.multiOption).off(".themeProductOptions"),
              $(this)
                .find(_.selectors.customOption)
                .off(".themeProductOptions"),
              theme.removeAjaxFromProductForm($productForm);
          });
        });
    })()),
    (theme.loadQuickbuy = function () {
      function loadComponents(componentContainer) {
        $(componentContainer)
          .closest("[data-components]")
          .each(function () {
            $(this)
              .data("components")
              .split(",")
              .forEach((component) => {
                $(document).trigger("cc:component:load", [
                  component,
                  componentContainer,
                ]);
              });
          }),
          $(document).trigger("cc:component:load", [
            "custom-select",
            ".quickbuy-modal",
          ]);
      }
      theme.settings.quickbuy_style == "button-quick-add" &&
        $(document).on("click", ".quick-add", (evt) => {
          evt.preventDefault(),
            evt.currentTarget.classList.add("btn--in-progress"),
            fetch(theme.routes.cart_add_url, {
              method: "POST",
              body: JSON.stringify({
                items: [
                  { id: evt.currentTarget.dataset.variantId, quantity: 1 },
                ],
              }),
              headers: { "Content-Type": "application/json" },
            })
              .then(
                (response) => (
                  evt.currentTarget.classList.remove("btn--in-progress"),
                  response.json()
                )
              )
              .then((response) => {
                !response.status || response.status === 200
                  ? (document.dispatchEvent(
                      new CustomEvent("theme:cartchanged", {
                        bubbles: !0,
                        cancelable: !1,
                      })
                    ),
                    theme.settings.cart_type == "drawer"
                      ? document.dispatchEvent(
                          new CustomEvent("theme:open-cart-drawer", {
                            bubbles: !0,
                            cancelable: !1,
                          })
                        )
                      : theme.showQuickPopup(
                          theme.strings.products_product_added_to_cart,
                          evt.currentTarget
                        ))
                  : response.description &&
                    theme.showQuickPopup(
                      response.description,
                      $(evt.currentTarget)
                    );
              });
        }),
        $(document).on("click", ".quickbuy-toggle", function () {
          var productUrl = $(this).attr("href");
          document.dispatchEvent(
            new CustomEvent("theme:close-cart-drawer", {
              bubbles: !0,
              cancelable: !1,
            })
          ),
            $(".quickbuy-modal.cc-popup--visible").each(function () {
              $(this).data("cc-popup").close();
            });
          var $block = $(this).closest(".product-block, .product-mini-block"),
            $quickbuyCont = $block.find(".quickbuy-modal"),
            qbId = "Quickbuy-" + $block.data("product-id"),
            qbCont = document.getElementById(qbId);
          if (qbCont) $quickbuyCont = $(qbCont);
          else {
            (qbCont = document
              .getElementById("ModalTemplate")
              .content.cloneNode(!0)),
              (qbCont.firstElementChild.id = qbId),
              document.body.appendChild(qbCont),
              (qbCont = document.getElementById(qbId)),
              ($quickbuyCont = $(qbCont));
            var popup = new ccPopup($(qbCont), qbId);
            qbCont
              .querySelector(".cc-popup-close")
              .addEventListener("click", () => {
                theme.pauseAllMedia(), popup.close();
              }),
              qbCont
                .querySelector(".cc-popup-background")
                .addEventListener("click", () => {
                  theme.pauseAllMedia(), popup.close();
                }),
              $quickbuyCont.data("cc-popup", popup);
          }
          return (
            $quickbuyCont.data("cc-popup").open(),
            $quickbuyCont.hasClass("quickbuy-loaded")
              ? setTimeout(() => {
                  theme.OptionManager.selectOptionFromURL(
                    productUrl,
                    $quickbuyCont.find(".product-form")
                  );
                }, 40)
              : ($quickbuyCont.addClass("quickbuy-loaded"),
                $.get(productUrl, function (response) {
                  var $newDetail = $("<div>" + response + "</div>").find(
                    ".quickbuy-content"
                  );
                  $newDetail.find(".read-more").attr("href", productUrl),
                    $newDetail
                      .find(".detail .title")
                      .wrapInner($("<a>").attr("href", productUrl)),
                    $newDetail.find(".not-in-quickbuy").remove(),
                    $newDetail
                      .find(".only-in-quickbuy")
                      .removeClass("only-in-quickbuy"),
                    $newDetail
                      .find(".off-card-container")
                      .removeClass("off-card-container"),
                    $newDetail.find(".store-availability-container").remove(),
                    $newDetail
                      .find('[data-enable-history-state="true"]')
                      .attr("data-enable-history-state", "false"),
                    $newDetail
                      .find(".gallery .thumbnails")
                      .addClass("hidden-on-desktop"),
                    [
                      "gallery--layout-carousel-beside",
                      "gallery--layout-carousel-under",
                      "gallery--layout-columns-2",
                      "gallery--layout-collage-1",
                      "gallery--layout-collage-2",
                    ].forEach((cl) => {
                      $newDetail
                        .find("." + cl)
                        .removeClass(cl)
                        .addClass("gallery--layout-columns-1");
                    }),
                    $newDetail
                      .find(".product-form")
                      .toggleClass(
                        "sticky-content-container",
                        theme.settings.qb_enable_sticky_cols
                      ),
                    $quickbuyCont.attr(
                      "data-components",
                      $newDetail
                        .closest("[data-components]")
                        .attr("data-components")
                    ),
                    $quickbuyCont.find(".loading-spinner").remove(),
                    $quickbuyCont.find(".cc-popup-content").append($newDetail),
                    theme.suffixIds($quickbuyCont[0], qbId),
                    $newDetail
                      .find(".detail .title")
                      .attr("id", qbId + "-Title"),
                    $quickbuyCont
                      .find(".cc-popup-modal")
                      .attr("aria-labelledby", qbId + "-Title"),
                    theme.initProductGallery($quickbuyCont),
                    $quickbuyCont
                      .find(".product-form")
                      .trigger("load-product-form", { productUrl }),
                    loadComponents($quickbuyCont),
                    theme.initAnimateOnScroll(),
                    theme.OptionManager.selectOptionFromURL(
                      productUrl,
                      $quickbuyCont.find(".product-form")
                    );
                }).fail(function () {
                  $quickbuyCont.removeClass("quickbuy-loaded");
                })),
            !1
          );
        });
    }),
    $(function () {
      $(document).on("click", ".sharing a", function (e) {
        var $parent = $(this).parent();
        if ($parent.hasClass("twitter")) {
          e.preventDefault();
          var url = $(this).attr("href"),
            width = 575,
            height = 450,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Twitter", opts);
        } else if ($parent.hasClass("facebook")) {
          e.preventDefault();
          var url = $(this).attr("href"),
            width = 626,
            height = 256,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Facebook", opts);
        } else if ($parent.hasClass("pinterest")) {
          e.preventDefault();
          var url = $(this).attr("href"),
            width = 700,
            height = 550,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Pinterest", opts);
        } else if ($parent.hasClass("google")) {
          e.preventDefault();
          var url = $(this).attr("href"),
            width = 550,
            height = 450,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Google+", opts);
        }
      });
    });
  var CCShippingCalculator = class extends HTMLElement {
    constructor() {
      super();
      var loaded = 0;
      this.getAttribute("scripts")
        .split(" ")
        .forEach((url) => {
          theme.loadScriptOnce(url, () => {
            loaded++,
              loaded === 3 &&
                (jQuery(".get-rates").off("click"),
                Shopify.Cart.ShippingCalculator.show({
                  submitButton: this.getAttribute("submit-text"),
                  submitButtonDisabled: this.getAttribute(
                    "submit-disabled-text"
                  ),
                  customerIsLoggedIn: this.hasAttribute("logged-in"),
                  moneyFormat: this.getAttribute("money-format"),
                }));
          });
        });
    }
  };
  window.customElements.define("shipping-calculator", CCShippingCalculator);
  var TermsAgreement = class extends HTMLElement {
    connectedCallback() {
      this.delegatedEvent = theme.addDelegateEventListener(
        document,
        "click",
        '.cart-form [name="checkout"], .additional-checkout-buttons input, a[href*="/checkout"]',
        this.handleFormSubmittingEvent.bind(this)
      );
    }
    disconnectedCallback() {
      document.removeEventListener("click", this.delegatedEvent);
    }
    handleFormSubmittingEvent(evt) {
      this.querySelector("input:checked") ||
        (evt.preventDefault(),
        theme.showQuickPopup(
          theme.strings.cart_terms_confirmation,
          $(evt.target)
        ));
    }
  };
  window.customElements.define("terms-agreement", TermsAgreement),
    (theme.AnnouncementBarSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.container = container2),
          $(".disclosure", container2).each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          }),
          (this.announcements = container2.querySelectorAll(".announcement")),
          this.announcements.length > 1 &&
            ((this.currentAnnouncement = 0),
            container2
              .querySelector(".announcement-bar__middle")
              .addEventListener(
                "focusin",
                this.functions.pauseAnnouncements.bind(this)
              ),
            container2
              .querySelector(".announcement-bar__middle")
              .addEventListener(
                "focusout",
                this.functions.playAnnouncements.bind(this)
              ),
            container2
              .querySelector(".announcement-button--previous")
              .addEventListener(
                "click",
                this.functions.previousAnnouncement.bind(this)
              ),
            container2
              .querySelector(".announcement-button--next")
              .addEventListener(
                "click",
                this.functions.nextAnnouncement.bind(this)
              ),
            (this.observer = new IntersectionObserver(
              this.functions.handleIntersect.bind(this)
            )),
            this.observer.observe(this.container));
      }),
        (this.functions = {
          handleIntersect: function (entries) {
            entries.forEach((entry) => {
              entry.target == this.container &&
                (entry.isIntersecting
                  ? this.functions.playAnnouncements.call(this)
                  : this.functions.pauseAnnouncements.call(this));
            });
          },
          playAnnouncements: function () {
            clearInterval(this.announcementInterval),
              (this.announcementInterval = setInterval(() => {
                this.functions.setCurrentAnnouncement.call(
                  this,
                  this.currentAnnouncement + 1
                );
              }, 5e3));
          },
          pauseAnnouncements: function () {
            this.announcementInterval &&
              clearInterval(this.announcementInterval);
          },
          setCurrentAnnouncement: function (newIndex) {
            (this.currentAnnouncement =
              (newIndex + this.announcements.length) %
              this.announcements.length),
              this.announcements.forEach((el, index) => {
                index !== this.currentAnnouncement
                  ? el.classList.add("announcement--inactive")
                  : (el.classList.remove("announcement--inactive"),
                    typeof el.dataset.bg < "u" &&
                      this.container.style.setProperty(
                        "--announcement-background",
                        el.dataset.bg
                      ),
                    typeof el.dataset.text < "u" &&
                      (this.container.style.setProperty(
                        "--announcement-text",
                        el.dataset.text
                      ),
                      this.container.style.setProperty(
                        "--link-underline",
                        el.dataset.underline
                      )));
              });
          },
          previousAnnouncement: function () {
            this.functions.setCurrentAnnouncement.call(
              this,
              this.currentAnnouncement - 1
            );
          },
          nextAnnouncement: function () {
            this.functions.setCurrentAnnouncement.call(
              this,
              this.currentAnnouncement + 1
            );
          },
        }),
        (this.onSectionUnload = function (container2) {
          clearInterval(this.announcementInterval),
            $(".disclosure", container2).each(function () {
              $(this).data("disclosure").unload();
            }),
            this.observer && this.observer.disconnect();
        }),
        (this.onBlockSelect = function (block) {
          var index = Array.prototype.indexOf.call(
            block.parentElement.children,
            block
          );
          this.functions.pauseAnnouncements.call(this),
            this.functions.setCurrentAnnouncement.call(this, index);
        }),
        (this.onBlockDeselect = function (block) {
          this.functions.playAnnouncements.call(this);
        });
    })()),
    (theme.BlogTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$container = $(container2));
        var popup = new ccPopup(
          $(".filter-modal", container2),
          this.namespace + "Filter"
        );
        $(".filter-modal .cc-popup-close", container2).on("click", () =>
          popup.close()
        ),
          $(".filter-modal .cc-popup-background", container2).on("click", () =>
            popup.close()
          ),
          this.$container.on(
            "click" + this.namespace,
            "[data-toggle-filters]",
            function (evt) {
              return popup.open(), !1;
            }
          );
      }),
        (this.onSectionUnload = function (container2) {
          this.$container.off(this.namespace), $(document).off(this.namespace);
        });
    })()),
    (theme.CollectionTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$container = $(container2)),
          (this.filterer = new theme.LoadFilterer(this));
        var popup = new ccPopup(
          $(".filter-modal", container2),
          this.namespace + "Filter"
        );
        $(".filter-modal .cc-popup-close", container2).on("click", () =>
          popup.close()
        ),
          $(".filter-modal .cc-popup-background", container2).on("click", () =>
            popup.close()
          ),
          this.$container.on(
            "click" + this.namespace,
            "[data-toggle-filters]",
            function (evt) {
              return popup.open(), !1;
            }
          );
      }),
        (this.onSectionUnload = function (container2) {
          this.filterer.destroy(),
            $(".slick-slider", container2).slick("unslick").off("init"),
            this.$container.off(this.namespace),
            $(window).off(this.namespace);
        });
    })()),
    (theme.CustomRowSection = new (function () {
      (this.onSectionLoad = function (container2) {
        theme.VideoManager.onSectionLoad(container2);
      }),
        (this.onSectionUnload = function (container2) {
          theme.VideoManager.onSectionUnload(container2);
        });
    })()),
    (theme.FeaturedProductSection = new (function () {
      (this.onSectionLoad = function (container2) {
        theme.initProductGallery(container2),
          $(".product-form", container2).trigger("load-product-form");
      }),
        (this.onSectionUnload = function (container2) {
          theme.destroyProductGallery(container2),
            $(".product-form", container2).trigger("unload-product-form"),
            $(".slideshow", container2).slick("unslick");
        });
    })()),
    (theme.FooterSection = new (function () {
      (this.onSectionLoad = function (container2) {
        theme.signup($(container2).find(".section-footer__newsletter"), {
          inputCls: ".signup-emailinput",
          submitCls: ".signup-emailsubmit",
          msgCls: ".signup-message",
        }),
          $(".disclosure", container2).each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          });
      }),
        (this.onSectionUnload = function (container2) {
          $(".disclosure", container2).each(function () {
            $(this).data("disclosure").unload();
          });
        });
    })()),
    (theme.GallerySection = new (function () {
      (this.onSectionLoad = function (container2) {
        var $carouselGallery = $(".gallery--mobile-carousel", container2);
        if ($carouselGallery.length) {
          var assessCarouselFunction = function () {
            var isCarousel = $carouselGallery.hasClass("slick-slider"),
              shouldShowCarousel = $(window).width() < 768;
            if (isCarousel && !shouldShowCarousel) {
              $carouselGallery.slick("unslick").off("init"),
                $carouselGallery
                  .find("a, .gallery__item")
                  .removeAttr("tabindex")
                  .removeAttr("role");
              var rowLimit = $carouselGallery.data("grid"),
                $currentRow = null;
              $carouselGallery.find(".gallery__item").each(function (index) {
                index % rowLimit === 0 &&
                  ($currentRow = $('<div class="gallery__row">').appendTo(
                    $carouselGallery
                  )),
                  $(this).appendTo($currentRow);
              });
            } else
              !isCarousel &&
                shouldShowCarousel &&
                ($carouselGallery
                  .find(".gallery__item")
                  .appendTo($carouselGallery),
                $carouselGallery.find(".gallery__row").remove(),
                $carouselGallery.slick({
                  autoplay: !1,
                  fade: !1,
                  infinite: !0,
                  useTransform: !0,
                  arrows: !1,
                  dots: !0,
                  customPaging: function (slider, i) {
                    return '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve"><circle class="circle-one" cx="15" cy="15" r="13" /><circle class="circle-two" cx="15" cy="15" r="13" /></svg></button>';
                  },
                  rtl: !!document.querySelector("html[dir=rtl]"),
                }));
          };
          assessCarouselFunction(),
            $(window).on(
              "debouncedresize.themeSection" + container2.id,
              assessCarouselFunction
            );
        }
        $(".overlay-text__title, .overlay-text__rte", container2).each(
          function () {
            theme.avoidUnecessaryOrphans(this);
          }
        );
      }),
        (this.onSectionUnload = function (container2) {
          $(window).off(".themeSection" + container2.id),
            $(".slick-slider", container2).each(function () {
              $(this).slick("unslick").off("init");
            });
        }),
        (this.onBlockSelect = function (block) {
          var blockSlideIndex = $(block).data("slick-index");
          $(block)
            .closest(".slick-slider")
            .each(function () {
              $(this).slick("slickGoTo", blockSlideIndex);
            });
        });
    })()),
    (theme.HeaderSection = new (function () {
      (this.onSectionLoad = function (container) {
        (this.$container = $(container)),
          theme.Navigation.init({
            nav: $(".navigation", container),
            mobileNavTemplate: container.querySelector(
              ".mobile-navigation-drawer-template"
            ),
          }),
          theme.inlineNavigationCheck
            ? (theme.inlineNavigationCheck(),
              $(window).on(
                "debouncedresize.headerSection",
                theme.inlineNavigationCheck
              ))
            : document.querySelector("#InlineNavigationCheckScript") &&
              eval(
                document.querySelector("#InlineNavigationCheckScript").innerHTML
              ),
          (this.section = document.querySelector(".section-header")),
          this.functions.setSticky.call(this),
          this.functions.setHeaderHeightProperty.call(this),
          this.functions.setScrollClass.call(this),
          $(window).on(
            "scroll.headerSection",
            this.functions.afterScroll.bind(this)
          ),
          $(window).on(
            "debouncedresize.headerSection",
            this.functions.afterResize.bind(this)
          ),
          $(".disclosure", container).each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          }),
          $(".mobile-navigation-drawer .disclosure").each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          }),
          theme.settings.cart_type == "drawer" &&
            document.querySelector(".cart-drawer") &&
            $(container).on("click", ".cart-link", (evt) => {
              evt.preventDefault(),
                document.dispatchEvent(
                  new CustomEvent("theme:open-cart-drawer", {
                    bubbles: !0,
                    cancelable: !1,
                  })
                );
            }),
          $(document).on("theme:cartchanged.headerSection", function () {
            $.getJSON(location.origin + "?sections=header", function (data) {});
          }),
          Shopify.designMode &&
            $("body").hasClass("reveal-mobile-nav") &&
            theme.openMobileNav();
      }),
        (this.onSectionUnload = function (container2) {
          $(container2).off(".headerSection"),
            $(document).off(".headerSection"),
            $(window).off(".headerSection"),
            $(".disclosure", container2).each(function () {
              $(this).data("disclosure").unload();
            }),
            $(".mobile-navigation-drawer .disclosure").each(function () {
              $(this).data("disclosure").unload();
            }),
            theme.Navigation.destroy($(".navigation", container2));
        }),
        (this.onBlockSelect = function (container2) {
          $(container2).closest(".navigation__item").trigger("mouseenter");
        }),
        (this.onBlockDeselect = function (container2) {
          $(container2).closest(".navigation__item").trigger("mouseleave");
        }),
        (this.functions = {
          afterScroll: function afterScroll() {
            this.functions.setScrollClass.call(this);
          },
          afterResize: function afterResize() {
            this.functions.setSticky.call(this),
              this.functions.setHeaderHeightProperty.call(this);
          },
          setSticky: function setSticky() {
            this.isSticky =
              getComputedStyle(this.section).position === "sticky" ||
              getComputedStyle(this.section).position === "-webkit-sticky";
          },
          setHeaderHeightProperty: function setHeaderHeightProperty() {
            var headerHeight = 0,
              stickyHeaderHeight = 0;
            this.section &&
              ((headerHeight = Math.ceil(this.section.clientHeight)),
              this.isSticky && (stickyHeaderHeight = headerHeight)),
              theme.enqueueStyleUpdate(() => {
                document.documentElement.style.setProperty(
                  "--theme-header-height",
                  headerHeight + "px"
                ),
                  document.documentElement.style.setProperty(
                    "--theme-sticky-header-height",
                    stickyHeaderHeight + "px"
                  );
              });
          },
          setScrollClass: function setScrollClass() {
            var p = getComputedStyle(
                document.querySelector(".section-header")
              ).position,
              ab = document.querySelector(".section-announcement-bar"),
              t = ab ? ab.offsetTop + ab.clientHeight : 0;
            theme.enqueueStyleUpdate(() => {
              document.body.classList.toggle(
                "floating-header",
                p === "sticky" && window.scrollY > t
              );
            });
          },
          openSearch: function openSearch() {
            document.querySelector(".header-search-content")
              ? document
                  .querySelector(".header-search-content")
                  .classList.remove("hidden")
              : ($("#content").prepend(
                  this.$container.find(".header-search-template").html()
                ),
                theme.Sections.sectionLoad(
                  document.querySelector(
                    '.header-search-content [data-section-type="search-template"]'
                  )
                ),
                document
                  .querySelector(".main-search__close")
                  .addEventListener(
                    "click",
                    this.functions.closeSearch.bind(this)
                  ),
                fetch(theme.routes.search_url)
                  .then((response) => {
                    if (!response.ok)
                      throw new Error(
                        "HTTP error! Status: ".concat(response.status)
                      );
                    return response.text();
                  })
                  .then((response) => {
                    var $parsed = $("<div>".concat(response, "</div>"));
                    $(
                      '.header-search-content [data-section-type="search-template"]'
                    )
                      .attr(
                        "data-filter-section-id",
                        $parsed
                          .find('[data-section-type="search-template"]')
                          .data("filter-section-id")
                      )
                      .attr(
                        "data-search-while-typing",
                        $parsed
                          .find('[data-section-type="search-template"]')
                          .data("search-while-typing")
                      ),
                      $(".header-search-content .before-search-content").html(
                        $parsed.find(".before-search-content").html()
                      ),
                      theme.initAnimateOnScroll();
                  })),
              document
                .querySelector(".main-container")
                .classList.add("main-container--temp-hidden"),
              setTimeout(() => {
                document
                  .querySelector(".header-search-content .main-search__input")
                  .focus(),
                  setTimeout(
                    () =>
                      theme.scrollToRevealElement(
                        document.querySelector(".header-search-content")
                      ),
                    50
                  );
              }, 50);
          },
          closeSearch: function closeSearch() {
            document
              .querySelector(".header-search-content")
              .classList.add("hidden"),
              document
                .querySelector(".main-container")
                .classList.remove("main-container--temp-hidden"),
              document.querySelectorAll(".show-search-link").forEach((el) => {
                el.offsetParent && el.focus();
              });
          },
        });
    })()),
    (theme.ImageWithTextOverlaySection = new (function () {
      var _ = this;
      (_.checkForHeaderHeightSubtraction = function () {
        $(
          ".section-image-with-text-overlay .height--full-minus-header-height"
        ).each(function () {
          var height =
            $(window).height() -
            document.querySelector(".section-header").clientHeight;
          $(".background-image, .placeholder-image", this).height(height);
        });
      }),
        (this.onSectionLoad = function (container2) {
          $(".height--full", container2).each(function () {
            $(this).closest(".section-image-with-text-overlay").index() == 0 &&
              ($(this).addClass("height--full-minus-header-height"),
              _.checkForHeaderHeightSubtraction(),
              $(window)
                .off("debouncedresize.imageWithTextOverlaySection")
                .on(
                  "debouncedresize.imageWithTextOverlaySection",
                  _.checkForHeaderHeightSubtraction
                ));
          }),
            $(".overlay-text__title, .overlay-text__rte", container2).each(
              function () {
                theme.avoidUnecessaryOrphans(this);
              }
            );
        }),
        (this.onSectionUnload = function (container2) {
          $(window).off(".imageWithTextOverlaySection");
        });
    })()),
    (theme.ProductTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        $("[data-store-availability-container]", container2).length &&
          (this.storeAvailability = new theme.StoreAvailability(
            $("[data-store-availability-container]", container2)[0]
          )),
          theme.initProductGallery(container2),
          $(".product-form", container2).trigger("load-product-form"),
          $(".theme-product-reviews", container2).on("click", "a", function () {
            return (
              $("html,body").animate(
                { scrollTop: $($(this).attr("href")).offset().top },
                1e3
              ),
              !1
            );
          });
        var $wrapper = $(".coupon-content"),
          timer = null;
        if ($wrapper && $wrapper.length > 0) {
          $("#coupon_doubt").click(function () {
            var popup_id = $(this).parent().data("popup_element_id");
            if (popup_id) {
              var clickEvent = new Event("click"),
                eventTarget = document.getElementById(popup_id);
              eventTarget && eventTarget.dispatchEvent(clickEvent);
            }
          });
          try {
            new ClipboardJS(".coupon-copybtn");
          } catch (e) {
            console.error(e);
          }
          $wrapper.delegate(".coupon-copybtn", "click", function () {
            var $this = $(this),
              copyText = $this.data("copy"),
              copiedText = $this.data("copied");
            $this.text(copiedText),
              clearTimeout(timer),
              (timer = setTimeout(function () {
                $this.text(copyText);
              }, 2e3));
          });
        }
      }),
        (this.onSectionUnload = function (container2) {
          theme.destroyProductGallery(container2),
            $(".product-form", container2).trigger("unload-product-form"),
            $(".theme-product-reviews", container2).off("click"),
            this.storeAvailability && this.storeAvailability.onSectionUnload();
        });
    })()),
    (theme.SearchTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$container = $(container2)),
          (this.container = this.$container[0]),
          (this.termsInput = this.container.querySelector(
            ".main-search__input"
          )),
          (this.filterer = new theme.LoadFilterer(
            this,
            theme.routes.search_url,
            this.container.dataset.alterLocation === "true"
          ));
        var popup = new ccPopup(
          $(".filter-modal", container2),
          this.namespace + "Filter"
        );
        $(".filter-modal .cc-popup-close", container2).on("click", () =>
          popup.close()
        ),
          $(".filter-modal .cc-popup-background", container2).on("click", () =>
            popup.close()
          ),
          this.$container.on(
            "click" + this.namespace,
            "[data-toggle-filters]",
            function (evt) {
              return popup.open(), !1;
            }
          ),
          this.container.dataset.searchWhileTyping == "true" &&
            (this.termsInput
              .closest("form")
              .addEventListener("submit", (evt) => {
                evt.preventDefault(), document.activeElement.blur();
              }),
            this.termsInput.addEventListener(
              "change",
              this.functions.onTermsChange.bind(this)
            ),
            this.termsInput.addEventListener(
              "keyup",
              this.functions.onTermsChange.bind(this)
            ),
            this.termsInput.addEventListener(
              "paste",
              this.functions.onTermsChange.bind(this)
            ),
            this.functions.setTermsClasses.call(this)),
          this.container
            .querySelector(".main-search__button--clear")
            .addEventListener(
              "click",
              this.functions.onClearTermsClick.bind(this)
            );
      }),
        (this.functions = {
          onTermsChange: function () {
            var filterQueryEl = this.container.querySelector(
              '#CollectionFilterForm [name="q"]'
            );
            filterQueryEl.value != this.termsInput.value &&
              (this.container
                .querySelector(".filters-adjacent")
                .classList.add("ajax-loading"),
              (filterQueryEl.value = this.termsInput.value),
              filterQueryEl.dispatchEvent(
                new CustomEvent("change", { bubbles: !0 })
              )),
              this.functions.setTermsClasses.call(this);
          },
          setTermsClasses: function () {
            this.termsInput
              .closest(".main-search")
              .classList.toggle(
                "main-search--terms-entered",
                this.termsInput.value.length > 0
              );
          },
          onClearTermsClick: function (evt) {
            evt.preventDefault(),
              evt.stopPropagation(),
              (this.termsInput.value = ""),
              this.termsInput.dispatchEvent(
                new CustomEvent("change", { bubbles: !0 })
              );
          },
        }),
        (this.onSectionUnload = function () {
          this.filterer.destroy(), this.$container.off(this.namespace);
        });
    })()),
    (theme.SlideshowSection = new (function () {
      var _ = this;
      const leftArrow = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none">
        <path d="M10.2559 19.9998L5.08496 14.7498M1.74512 10.909L10.2552 2" stroke="white" stroke-width="2.25" stroke-linecap="round"/>
      </svg>`;
      const rightArrow = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none">
        <path d="M1.74511 19.9998L6.91601 14.7498M10.2559 10.909L1.74578 2" stroke="white" stroke-width="2.25" stroke-linecap="round"/>
      </svg>`;
      (_.checkForHeaderHeightSubtraction = function () {
        $(".section-slideshow .height--full-minus-header-height").each(
          function () {
            var height =
              $(window).height() -
              document.querySelector(".section-header").clientHeight;
            $(".background-image, .placeholder-image", this).height(height);
          }
        );
      }),
        (this.onSectionLoad = function (container2) {
          $(".slideshow", container2).each(function () {
            var slideshowSpeed =
                $(this).data("transition") === "instant" ? 0 : 800,
              autoplaySpeed = $(this).data("autoplay-speed") * 1e3;
            $(this).find(".height--full").length &&
              $(this).closest(".section-slideshow").index() == 0 &&
              ($(this).addClass("height--full-minus-header-height"),
              _.checkForHeaderHeightSubtraction(),
              $(window)
                .off("debouncedresize.slideshowSection")
                .on(
                  "debouncedresize.slideshowSection",
                  _.checkForHeaderHeightSubtraction
                )),
              $(this)
                .slick({
                  autoplay: $(this).data("autoplay"),
                  fade: $(this).data("transition") !== "slide",
                  speed: slideshowSpeed,
                  autoplaySpeed,
                  arrows: $(this).data("navigation") === "arrows",
                  dots: true,
                  pauseOnHover: !1,
                  infinite: !0,
                  useTransform: !0,
                  appendArrows: $(this).siblings(".slideshow-controls"),
                  prevArrow:
                    '<button type="button" class="slick-prev slick-arrow" aria-label="' +
                    theme.strings.previous +
                    '">' +
                    leftArrow +
                    "</button>",
                  nextArrow:
                    '<button type="button" class="slick-next slick-arrow" aria-label="' +
                    theme.strings.next +
                    '">' +
                    rightArrow +
                    "</button>",
                  customPaging: function (slider, i) {
                    return "<button class='custom-line' type='button' data-role='none' role='button' tabindex='0'><svg xmlns='http://www.w3.org/2000/svg' width='40px' height='2px' viewBox='0 0 40 2' xml:space='preserve'><rect class='line-one' width='40' height='2' fill='#3974E5'></rect><rect class='line-two' width='40' height='2' fill='#A4A4A4'></rect></svg></button>";
                  },
                  rtl: !!document.querySelector("html[dir=rtl]"),
                  responsive: [{ breakpoint: 768, settings: {} }],
                })
                .on(
                  "beforeChange",
                  function (event, slick, currentSlide, nextSlide) {
                    if (
                      $(this).data("transition") === "slide_fade" ||
                      $(this).data("transition") === "zoom"
                    ) {
                      var $outgoingSlide = $(slick.$slides.get(currentSlide));
                      $outgoingSlide.addClass("slick--leaving");
                    }
                  }
                )
                .on("afterChange", function (event, slick) {
                  $(slick.$slides)
                    .filter(".slick--leaving")
                    .removeClass("slick--leaving");
                });
          }),
            $(".overlay-text__title, .overlay-text__rte", container2).each(
              function () {
                theme.avoidUnecessaryOrphans(this);
              }
            );
        }),
        (this.onSectionUnload = function (container2) {
          $(".slick-slider", container2).slick("unslick").off("init"),
            $(window).off(".slideshowSection");
        }),
        (this.onBlockSelect = function (container2) {
          $(container2)
            .closest(".slick-slider")
            .slick("slickGoTo", $(container2).data("slick-index"))
            .slick("slickPause");
        }),
        (this.onBlockDeselect = function (container2) {
          $(container2).closest(".slick-slider").slick("slickPlay");
        });
    })()),
    (theme.TestimonialsSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.carousel = $(".cc-carousel", container2)[0]),
          this.carousel.prepare(),
          (this.presentedTextContainer = $(container2)[0].querySelector(
            ".testimonial-list__presented-text"
          )),
          this.presentedTextContainer &&
            (this.registerEventListener(
              this.carousel,
              "cc-carousel:selected",
              (evt) =>
                this.functions.setPresentedText.call(
                  this,
                  evt.detail.currentItem
                )
            ),
            $(".testimonial__image", container2).each((index, element) => {
              this.registerEventListener(element, "click", (evt) => {
                evt.currentTarget
                  .closest("cc-carousel")
                  .get()
                  .selectItem(evt.currentTarget.closest(".testimonial"));
              });
            }),
            (this.autoplay = $(".testimonial-list", container2).data(
              "autoplay"
            )),
            this.autoplay &&
              ((this.autoplaySpeed = $(".testimonial-list", container2).data(
                "autoplay-speed"
              )),
              this.functions.startAutoplay.call(this),
              this.registerEventListener(
                $(container2)[0],
                "mouseenter",
                (evt) => this.functions.stopAutoplay.call(this)
              ),
              this.registerEventListener(
                $(container2)[0],
                "mouseleave",
                (evt) => {
                  this.blockSelected || this.functions.startAutoplay.call(this);
                }
              )));
      }),
        (this.functions = {
          setPresentedText: function (testimonialEl) {
            this.presentedTextContainer.classList.remove(
              "testimonial-list__presented-text--reveal"
            ),
              clearTimeout(this.setPresentedTextTimeout1Id),
              clearTimeout(this.setPresentedTextTimeout2Id),
              (this.setPresentedTextTimeout1Id = setTimeout(() => {
                (this.presentedTextContainer.querySelector(
                  ".testimonial__text"
                ).innerHTML =
                  testimonialEl.querySelector(".testimonial__text").innerHTML),
                  (this.setPresentedTextTimeout2Id = setTimeout(
                    () =>
                      this.presentedTextContainer.classList.add(
                        "testimonial-list__presented-text--reveal"
                      ),
                    50
                  ));
              }, parseFloat(getComputedStyle(this.presentedTextContainer).getPropertyValue("--hide-duration")) * 1e3));
          },
          startAutoplay: function () {
            clearInterval(this.autoplayIntervalId),
              (this.autoplayIntervalId = setInterval(() => {
                this.carousel.next();
              }, this.autoplaySpeed));
          },
          stopAutoplay: function () {
            clearInterval(this.autoplayIntervalId);
          },
        }),
        (this.onSectionUnload = function (container2) {
          this.presentedTextContainer && this.functions.stopAutoplay.call(this);
        }),
        (this.onBlockSelect = function (block) {
          this.presentedTextContainer &&
            ((this.blockSelected = !0), this.functions.stopAutoplay.call(this)),
            this.carousel.get().selectItem(block);
        }),
        (this.onBlockDeselect = function (block) {
          this.presentedTextContainer &&
            (this.functions.startAutoplay.call(this),
            (this.blockSelected = !1));
        });
    })()),
    (theme.CartDrawerSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.container = container2),
          (this.namespace = theme.namespaceFromSection(container2)),
          (this.popup = new ccPopup(
            $(".cc-popup", container2),
            this.namespace
          )),
          (this.boundOpen = () => this.popup.open()),
          document.addEventListener("theme:open-cart-drawer", this.boundOpen),
          (this.boundClose = () => this.popup.close()),
          document.addEventListener("theme:close-cart-drawer", this.boundClose),
          container2
            .querySelector(".cc-popup-close")
            .addEventListener("click", this.boundClose),
          container2
            .querySelector(".cc-popup-background")
            .addEventListener("click", this.boundClose);
      }),
        (this.onSectionSelect = () => {
          document.dispatchEvent(
            new CustomEvent("theme:open-cart-drawer", {
              bubbles: !0,
              cancelable: !1,
            })
          );
        }),
        (this.onSectionDeselect = () => {
          document.dispatchEvent(
            new CustomEvent("theme:close-cart-drawer", {
              bubbles: !0,
              cancelable: !1,
            })
          );
        }),
        (this.onSectionUnload = function (container2) {
          document.removeEventListener(
            "theme:open-cart-drawer",
            this.boundOpen
          ),
            document.removeEventListener(
              "theme:close-cart-drawer",
              this.boundClose
            );
        });
    })()),
    (theme.ScrollingBannerSection = new (function () {
      this.onSectionLoad = function (target) {
        document.fonts.ready.then(() =>
          target.querySelector(".marquee").classList.add("marquee--animate")
        ),
          target.querySelectorAll('img[loading="lazy"]').forEach((el) => {
            el.loading = "eager";
          });
      };
    })()),
    (theme.MediaWithTextSection = new (function () {
      (this.onSectionLoad = function (container2) {
        theme.VideoManager.onSectionLoad.call(this, container2),
          $(".majortitle", container2).each(function () {
            theme.avoidUnecessaryOrphans(this);
          });
      }),
        (this.onSectionUnload = function (container2) {
          theme.VideoManager.onSectionUnload.call(this, container2);
        });
    })()),
    (theme.TowrowPictureIntroduction = new (function () {
      this.onSectionLoad = function (container2) {
        $(container2).delegate(
          ".tworow-pic-content-image-title",
          "click",
          function () {
            var $item = $(".tworow-pic-content-imageout");
            $(window).width() < 768 &&
              ($item = $(this).parents(".tworow-pic-content-imageout")),
              $item.toggleClass("expanded");
          }
        );
      };
    })()),
    (theme.Specs = new (function () {
      $(".section-specs-item-title").on("click", function () {
        var specsItem = $(this).parents(".section-specs-item");
        $(specsItem).toggleClass("expanded");
      });
    })()),
    (theme.NewsletterSection = new (function () {
      this.onSectionLoad = function (container2) {
        theme.signup($(container2).find(".snippets-signup"));
      };
    })()),
    (theme.SlideshowMultiSection = new (function () {
      var _ = this;
      this.onSectionLoad = function (container2) {
        var setArrowPostion = function () {
          var $container = $(this),
            img_height = $container.find(".height--adapt").height();
          $container
            .find(".cc-carousel-buttons--overlay-top")
            .css({ top: img_height / 2, transform: "translateY(-50%)" });
        }.bind(container2);
        setArrowPostion(),
          $(window).on(
            "debouncedresize.slideshowMultiSection",
            setArrowPostion
          );
      };
    })()),
    $(function ($2) {
      var $2 = $2;
      if (
        ($2(document).on("keyup.themeTabCheck", function (evt) {
          evt.keyCode === 9 &&
            ($2("body").addClass("tab-used"),
            $2(document).off("keyup.themeTabCheck"));
        }),
        $2(document).on("click", "a[data-toggle-target]", function (e) {
          e.preventDefault();
          var $toggler = $2(this),
            $target = $2($2(this).data("toggle-target")),
            $transCont = $target.find(".toggle-target-container"),
            doCollapse = !$target.hasClass("toggle-target--hidden"),
            transitionDuration =
              $target.css("transition-duration").indexOf("ms") >= 0
                ? parseInt($target.css("transition-duration"))
                : parseFloat($target.css("transition-duration")) * 1e3;
          $target.hasClass("toggle-target--in-transition") ||
            (doCollapse
              ? ($toggler.addClass("toggle-target-toggler--is-hidden"),
                $target
                  .addClass(
                    "toggle-target--in-transition toggle-target--hiding"
                  )
                  .css({ height: $transCont.outerHeight() + "px", opacity: 1 }),
                setTimeout(function () {
                  $target.css({ height: 0, opacity: 0 }),
                    setTimeout(function () {
                      $target
                        .addClass("toggle-target--hidden")
                        .removeClass(
                          "toggle-target--in-transition toggle-target--hiding"
                        ),
                        $target.css({ height: "", opacity: "" });
                    }, transitionDuration);
                }, 10))
              : ($toggler.removeClass("toggle-target-toggler--is-hidden"),
                $target
                  .addClass(
                    "toggle-target--in-transition toggle-target--revealing"
                  )
                  .css({ height: 0, opacity: 0, display: "block" }),
                setTimeout(function () {
                  $target.css({
                    height: $transCont.outerHeight() + "px",
                    opacity: 1,
                  }),
                    setTimeout(function () {
                      $target.removeClass(
                        "toggle-target--hidden toggle-target--in-transition toggle-target--revealing"
                      ),
                        $target.css({ height: "", opacity: "", display: "" });
                    }, transitionDuration);
                }, 10)));
        }),
        $2(document).on("change", "select.navdrop", function () {
          window.location = $2(this).val();
        }),
        $2(document).on("click", ".mobile-nav-toggle", function (e) {
          e.preventDefault(),
            $2("body").hasClass("reveal-mobile-nav")
              ? $2("body").removeClass(
                  "reveal-mobile-nav reveal-mobile-nav--revealed"
                )
              : theme.openMobileNav();
        }),
        (theme.openMobileNav = function () {
          $2("body").addClass("reveal-mobile-nav"),
            $2(".mobile-navigation-drawer .disclosure").each(function () {
              var $list = $2(".disclosure-list", this),
                listHeight = 0;
              $list.children().each(function () {
                listHeight += $2(this).height();
              }),
                $2(".disclosure-list", this).css("height", listHeight + "px");
            }),
            theme.manualLazyload(
              document.querySelector(".mobile-navigation-drawer")
            ),
            document
              .querySelectorAll(".mobile-navigation-drawer product-block")
              .forEach((el) => el.init());
          var de = $2(
              ".mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__link:first"
            ).css("transition-delay"),
            du = $2(
              ".mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__link:first"
            ).css("transition-duration"),
            delayS =
              parseFloat(de.split(",")[0]) + parseFloat(du.split(",")[0]);
          setTimeout(function () {
            $2("body").addClass("reveal-mobile-nav--revealed");
          }, delayS * 1e3);
        }),
        $2(
          '<a href="#" class="page-shade" aria-label="' +
            theme.strings.general_navigation_menu_toggle_aria_label +
            '"></a>'
        )
          .on("click", function () {
            return $2("body").removeClass("reveal-mobile-nav"), !1;
          })
          .appendTo("body"),
        theme.settings.quickbuy_style != "off" && theme.loadQuickbuy(),
        $2(document).on(
          "load-product-form",
          ".product-form",
          function (e, data) {
            if ($2(this).data("product-id") !== "") {
              var $productFormContainer = $2(this),
                $productDetail = $2(this).closest(".product-detail");
              $2(this).on("variantChanged", function (evt, variant, product) {
                var $labelCont = $productDetail.find(".product-label-list");
                $labelCont.find(".product-label-container").remove(),
                  variant
                    ? $labelCont.append(
                        $2(
                          "#variant-label-"
                            .concat(product.id, "-")
                            .concat(variant.id)
                        ).html()
                      )
                    : $labelCont.append(
                        $2("#variant-label-".concat(product.id, "-none")).html()
                      ),
                  variant &&
                    $productDetail
                      .find(".dynamic-payment-button-template")
                      .each(function () {
                        $2(this).after($2(this).html()).remove(),
                          Shopify.PaymentButton && Shopify.PaymentButton.init();
                      });
              });
              var $iconOptionContainers = $productDetail.find(
                ".option-selector--swatch"
              );
              $iconOptionContainers.length &&
                $2(
                  "body.swatch-style-icon_circle, body.swatch-style-icon_square"
                ).length &&
                ($iconOptionContainers
                  .find(".label")
                  .append('<span class="label__value">'),
                $2(this).on("variantChanged", function (evt, variant) {
                  $iconOptionContainers.each(function () {
                    var optionIndex = $2(this).data("option-index");
                    if (variant) {
                      var optionValue = variant.options[optionIndex];
                      $2(this).find(".label__value").text(optionValue);
                    } else {
                      var selectedOption =
                        this.querySelector(".opt-btn:checked");
                      selectedOption &&
                        $2(this)
                          .find(".label__value")
                          .text(selectedOption.value);
                    }
                  });
                }));
              var $availabilityDependentOptions = $productDetail.find(
                '.option-selectors[data-disable-unavailable="true"]'
              );
              $availabilityDependentOptions.length &&
                $2(this).on("variantChanged", function (evt, variant) {
                  var _this2 = this,
                    productData = theme.OptionManager.getProductData($2(this)),
                    optionStatusMap = [],
                    currentSelectedOptionValues = [];
                  $2(
                    '.option-selectors[data-disable-unavailable="true"] .option-selector',
                    this
                  ).each(function (index) {
                    var checkedInput = $2(this).find("input:checked"),
                      selectedOption = $2(this).find(
                        '.cc-select__option[aria-selected="true"]'
                      ),
                      value = checkedInput.length
                        ? checkedInput.val()
                        : selectedOption
                        ? selectedOption.data("value")
                        : null;
                    currentSelectedOptionValues.push(value);
                  });
                  for (
                    var optionIndex = 0;
                    optionIndex < productData.options.length;
                    optionIndex++
                  ) {
                    for (
                      var optionName = productData.options[optionIndex],
                        values = {},
                        i = 0;
                      i < productData.variants.length;
                      i++
                    ) {
                      var v = productData.variants[i];
                      values[v.options[optionIndex]] ||
                        (values[v.options[optionIndex]] = !1);
                    }
                    optionStatusMap.push({ name: optionName, values });
                  }
                  for (
                    var _loop4 = function (_optionIndex2) {
                        for (
                          var optionName2 = productData.options[_optionIndex2],
                            fixedOptions = [],
                            _i5 = 0;
                          _i5 < currentSelectedOptionValues.length &&
                          _i5 < _optionIndex2;
                          _i5++
                        )
                          fixedOptions.push(currentSelectedOptionValues[_i5]);
                        Object.keys(
                          optionStatusMap[_optionIndex2].values
                        ).forEach((optionValue2) => {
                          var fixedOptionsForValue = fixedOptions.map((x) => x);
                          fixedOptionsForValue.push(optionValue2);
                          for (
                            var availableVariantExists = !1, _i6 = 0;
                            _i6 < productData.variants.length;
                            _i6++
                          ) {
                            for (
                              var _v = productData.variants[_i6],
                                variantComplies = !0,
                                j = 0;
                              j < fixedOptionsForValue.length;
                              j++
                            )
                              fixedOptionsForValue[j] &&
                                fixedOptionsForValue[j] != _v.options[j] &&
                                (variantComplies = !1);
                            variantComplies &&
                              _v.available &&
                              (availableVariantExists = !0);
                          }
                          optionStatusMap[_optionIndex2].values[optionValue2] =
                            availableVariantExists;
                        });
                      },
                      _optionIndex = 0;
                    _optionIndex < productData.options.length;
                    _optionIndex++
                  )
                    _loop4(_optionIndex);
                  for (var _i4 = 0; _i4 < optionStatusMap.length; _i4++) {
                    var _loop5 = function (optionValue2) {
                      $2(
                        '.option-selector[data-selector-type="listed"][data-option-index="'.concat(
                          _i4,
                          '"] .opt-btn'
                        ),
                        _this2
                      )
                        .filter(function () {
                          return this.value === optionValue2;
                        })
                        .toggleClass(
                          "is-unavailable",
                          !optionStatusMap[_i4].values[optionValue2]
                        ),
                        $2(
                          '.option-selector[data-selector-type="dropdown"][data-option-index="'.concat(
                            _i4,
                            '"] .cc-select__option'
                          ),
                          _this2
                        )
                          .filter(function () {
                            return this.dataset.value === optionValue2;
                          })
                          .toggleClass(
                            "is-unavailable",
                            !optionStatusMap[_i4].values[optionValue2]
                          );
                    };
                    for (var optionValue in optionStatusMap[_i4].values)
                      _loop5(optionValue);
                  }
                }),
                $productFormContainer.on(
                  "change",
                  ".option-selector",
                  function () {
                    $productFormContainer.hasClass(
                      "product-form--validation-started"
                    ) && theme.validateProductForm($productFormContainer);
                  }
                ),
                theme.OptionManager.initProductOptions(
                  $2(this),
                  data && data.productUrl ? data.productUrl : null
                );
            }
          }
        ),
        $2(document).on("unload-product-form", ".product-form", function () {
          $2(this).off("variantChanged change"),
            theme.OptionManager.unloadProductOptions($2(this));
        }),
        $2(document).on(
          "variantImageSelected",
          ".gallery",
          function (e, data, isFirstRun) {
            var $gallery = $2(this),
              $galleryCollageContainer = $gallery
                .filter(
                  ".gallery--layout-columns-1, .gallery--layout-columns-2, .gallery--layout-collage-1, .gallery--layout-collage-2"
                )
                .find(".product-slideshow:not(.slick-slider)"),
              collageGroupedImagesChanged = !1,
              $slideshow = null;
            if (
              $gallery.attr("data-variant-image-grouping-option-index") !== ""
            ) {
              var pivotOptionIndex = $gallery.attr(
                  "data-variant-image-grouping-option-index"
                ),
                selectedGroupOption = data.options[pivotOptionIndex],
                $thumbnails = $gallery.find(".thumbnails");
              if (
                (($slideshow = $gallery.find(".slideshow")),
                $slideshow.hasClass("slick-slider"))
              ) {
                var currentIsVisible = !!$slideshow.find(
                  '.slide[data-media-id="'.concat(data.featured_media.id, '"]')
                ).length;
                $slideshow
                  .slick("slickUnfilter")
                  .slick(
                    "slickFilter",
                    '.slide[data-media-id="'
                      .concat(
                        data.featured_media.id,
                        '"], [data-variant-image-group="'
                      )
                      .concat(
                        selectedGroupOption
                          .replace('"', "&quot;")
                          .replace(/<>/g, ""),
                        '"]'
                      )
                  ),
                  $slideshow.find(".slide").css({
                    position: "",
                    left: "",
                    top: "",
                    zIndex: "",
                    opacity: "",
                  }),
                  currentIsVisible ||
                    ($slideshow.slick("slickGoTo", 0, !0),
                    $slideshow.slick(
                      "slickGoTo",
                      $slideshow
                        .find(
                          '.slide[data-media-id="'.concat(
                            data.featured_media.id,
                            '"]'
                          )
                        )
                        .data("slick-index"),
                      !0
                    ));
              }
              if ($thumbnails.hasClass("owl-carousel")) {
                var $hiddenThumbnails = $gallery.find(".hidden-thumbnails");
                $hiddenThumbnails.length ||
                  ($hiddenThumbnails = $2(
                    '<div class="hidden-thumbnails hidden">'
                  ).insertAfter($thumbnails)),
                  $thumbnails
                    .find(".thumbnail")
                    .show()
                    .each(function () {
                      $2(this).attr("data-variant-image-group") !=
                        selectedGroupOption &&
                        $2(this).attr("data-media-id") !=
                          data.featured_media.id &&
                        $2(this).appendTo($hiddenThumbnails);
                    }),
                  $hiddenThumbnails.find(".thumbnail").each(function () {
                    ($2(this).attr("data-variant-image-group") ==
                      selectedGroupOption ||
                      $2(this).attr("data-media-id") ==
                        data.featured_media.id) &&
                      $2(this).show().appendTo($thumbnails);
                  });
              } else
                $thumbnails.find(".thumbnail").each(function () {
                  $2(this).attr("data-variant-image-group") ==
                    selectedGroupOption ||
                  $2(this).attr("data-media-id") == data.featured_media.id
                    ? $2(this).show()
                    : $2(this).hide();
                });
              $galleryCollageContainer.length &&
                ($galleryCollageContainer.find(".slide").each(function () {
                  $2(this).attr("data-variant-image-group") ==
                    selectedGroupOption ||
                  $2(this).attr("data-media-id") == data.featured_media.id
                    ? ($2(this).hasClass("slide--inactive-option") &&
                        (collageGroupedImagesChanged = !0),
                      $2(this).removeClass("slide--inactive-option"))
                    : ($2(this).hasClass("slide--inactive-option") ||
                        (collageGroupedImagesChanged = !0),
                      $2(this).addClass("slide--inactive-option"));
                }),
                $galleryCollageContainer
                  .find(".slide--inactive-option")
                  .appendTo($galleryCollageContainer));
            }
            if (
              ($gallery
                .find(
                  '.thumbnails a[data-media-id="' +
                    data.featured_media.id +
                    '"]:first'
                )
                .trigger("select"),
              $galleryCollageContainer.length)
            ) {
              var $active = $gallery.find(
                '.slide[data-media-id="' + data.featured_media.id + '"]:first'
              );
              if ($active.length)
                if (isFirstRun && !collageGroupedImagesChanged) {
                  var isFeaturedProduct =
                    $gallery.closest(".featured-product").length;
                  isFeaturedProduct || theme.scrollToRevealElement($active[0]);
                } else
                  collageGroupedImagesChanged
                    ? ($gallery
                        .find(".slide--was-highlighted")
                        .removeClass("slide--was-highlighted"),
                      $active.addClass("slide--was-highlighted"))
                    : $active.hasClass("slide--was-highlighted") ||
                      (clearTimeout(theme.variantImageFadeTimeout),
                      $gallery
                        .find(".slide--highlight-on")
                        .removeClass("slide--highlight-on"),
                      $gallery
                        .find(".slide--highlight-off")
                        .removeClass("slide--highlight-off"),
                      $gallery
                        .find(".slide--was-highlighted")
                        .removeClass("slide--was-highlighted"),
                      $active
                        .addClass("slide--highlight-on slide--was-highlighted")
                        .siblings()
                        .addClass("slide--highlight-off"),
                      (theme.variantImageFadeTimeout = setTimeout(function () {
                        $gallery
                          .find(".slide--highlight-on")
                          .removeClass("slide--highlight-on"),
                          $gallery
                            .find(".slide--highlight-off")
                            .removeClass("slide--highlight-off");
                      }, 1200)),
                      theme.scrollToRevealElement($active[0]));
            }
          }
        ),
        $2(document).on(
          "click",
          ".product-detail .gallery .main-image a.show-gallery",
          function (event) {
            event.preventDefault(), event.stopPropagation();
            var images = [],
              $imgs = $2(this)
                .closest(".product-slideshow")
                .find(".slide:not(.slide--inactive-option) .show-gallery"),
              clickedHref = $2(this).attr("href");
            if ($imgs.length)
              $imgs.each(function () {
                var $imgThumb = $2(".inline-image", this).clone();
                images.push({
                  thumbTag: $imgThumb,
                  zoomUrl: $2(this).attr("href"),
                });
              });
            else {
              var $img = $2(".inline-image", this).clone();
              images.push({ thumbTag: $img, zoomUrl: $2(this).attr("href") });
            }
            var galleryConfig = {
                images,
                currentImage: clickedHref,
                prev: theme.icons.chevronLeft,
                next: theme.icons.chevronRight,
                close: theme.icons.close,
              },
              qbCont = this.closest(".quickbuy-modal");
            qbCont &&
              (galleryConfig.galleryParent =
                qbCont.querySelector(".cc-popup-modal")),
              theme.buildGalleryViewer(galleryConfig);
            var galleryEl = $2(this).closest(".gallery")[0];
            for (var value of galleryEl.classList.entries())
              if (
                value[1].indexOf("card-scheme-vars--") === 0 &&
                value[1] !== "card-scheme-vars--none"
              ) {
                var gv = document.querySelector(".gallery-viewer");
                gv.classList.add("gallery-viewer--card-scheme", value[1]);
                var customBg = getComputedStyle(
                  galleryEl.querySelector(".gallery__inner")
                ).getPropertyValue("--bg");
                customBg && gv.style.setProperty("--bg", customBg);
              }
            return !1;
          }
        ),
        $2("a.show-gallery").click(function (event) {
          event.preventDefault();
        }),
        $2("#template label").each(function () {
          var $sibinputs = $2(this).siblings(
            'input:not([type="submit"]), textarea'
          );
          $sibinputs.length == 1 &&
            $sibinputs.attr("id").length > 0 &&
            $2(this).attr("for", $sibinputs.attr("id"));
        }),
        $2(document).on(
          "click",
          ".quantity-wrapper [data-quantity]",
          function () {
            var adj = $2(this).data("quantity") == "up" ? 1 : -1,
              $qty = $2(this)
                .closest(".quantity-wrapper")
                .find("[name=quantity]");
            return (
              $qty.attr("step") && (adj *= parseInt($qty.attr("step"))),
              $qty
                .val(Math.max(1, parseInt($qty.val()) + adj))
                .trigger("change"),
              !1
            );
          }
        ),
        $2(".responsive-table").on(
          "click",
          ".responsive-table__cell-head",
          function () {
            if ($2(window).width() < 768)
              return $2(this).closest("tr").toggleClass("expanded"), !1;
          }
        ),
        typeof cc < "u" && cc.sections)
      )
        for (var sectionKey in cc.sections) {
          var ccSection = cc.sections[sectionKey];
          if (ccSection.name === "video") {
            var t = ccSection.section.onSectionLoad;
            ccSection.section.onSectionLoad = function (container2) {
              $2(".overlay-text__title, .overlay-text__rte", container2).each(
                function () {
                  theme.avoidUnecessaryOrphans(this);
                }
              ),
                t.call(this, container2);
            };
          }
        }
      $2(window).on("debouncedresize", theme.lazy.updateImgSizes),
        theme.Sections.init(),
        theme.Sections.register("header", theme.HeaderSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "announcement-bar",
          theme.AnnouncementBarSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register("footer", theme.FooterSection),
        theme.Sections.register("cart-drawer", theme.CartDrawerSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register("slideshow", theme.SlideshowSection),
        theme.Sections.register("gallery", theme.GallerySection),
        theme.Sections.register("testimonials", theme.TestimonialsSection),
        theme.Sections.register(
          "image-with-text-overlay",
          theme.ImageWithTextOverlaySection
        ),
        theme.Sections.register("map", theme.MapSection),
        theme.Sections.register("background-video", theme.VideoManager, {
          deferredLoadViewportExcess: 800,
        }),
        theme.Sections.register("custom-row", theme.CustomRowSection),
        theme.Sections.register(
          "featured-product",
          theme.FeaturedProductSection
        ),
        theme.Sections.register("main-product", theme.ProductTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "collection-template",
          theme.CollectionTemplateSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register(
          "search-template",
          theme.SearchTemplateSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register("blog-template", theme.BlogTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register("cart-template", new (function () {})()),
        theme.Sections.register("contact", new (function () {})()),
        theme.Sections.register(
          "scrolling-banner",
          theme.ScrollingBannerSection
        ),
        theme.Sections.register("media-with-text", theme.MediaWithTextSection, {
          deferredLoadViewportExcess: 800,
        }),
        theme.Sections.register(
          "towrow-picture-introduction",
          theme.TowrowPictureIntroduction,
          { deferredLoad: !1 }
        ),
        theme.Sections.register("specs", theme.Specs, { deferredLoad: !1 }),
        theme.Sections.register("slideshowmulti", theme.SlideshowMultiSection),
        theme.Sections.register("newsletter", theme.NewsletterSection),
        theme.Sections.register("parameter", theme.ParameterSection),
        theme.Sections.register(
          "product-notes-detail",
          theme.ProductNotesDetail
        ),
        theme.Sections.register("horizon-ultra", theme.HorizonUltraSection),
        theme.Sections.register("header-button", theme.HeaderButtonSection),
        theme.Sections.register("image-slideshow", theme.ImageSlideshowSection),
        theme.Sections.register(
          "mousewheel-carousel",
          theme.MouseWheelCarouselSection
        ),
        theme.Sections.register(
          "comment-slideshow",
          theme.CommentSlideshowSection
        ),
        theme.Sections.register("image-with-link", theme.ImageWithLinkSection),
        theme.Sections.register(
          "image-with-count",
          theme.ImageWithCountSection
        ),
        theme.Sections.register("subscribe-item", theme.SubscribeItemSection),
        theme.Sections.register("score-card", theme.ScoreCardSection),
        theme.Sections.register(
          "black-friday-code",
          theme.BlackFridayCodeSection
        ),
        theme.Sections.register("timeline", theme.TimelineSection),
        theme.Sections.register("signup-dialog", theme.SignupDialogSection),
        theme.Sections.register("image-with-snow", theme.ImageWithSnowSection),
        theme.Sections.register("text-with-color", theme.TextWithColorSection),
        theme.Sections.register(
          "slideshow-product",
          theme.SlideshowProductSection
        ),
        theme.Sections.register("contact-us", theme.ContactUsSection),
        theme.Sections.register("bussiness-email", theme.BussinessEmailSection),
        theme.Sections.register("video-banner", theme.VideoBannerSection),
        theme.Sections.register(
          "text-with-border",
          theme.TextWithBorderSection
        ),
        theme.Sections.register("partnership", theme.PartnershipSection),
        theme.Sections.register("slideshow-media", theme.SlideshowMediaSection),
        theme.Sections.register(
          "slideshow-awards",
          theme.SlideshowAwardsSection
        ),
        theme.Sections.register(
          "slideshow-milestones",
          theme.SlideshowMilestonesSection
        ),
        theme.Sections.register("facts", theme.FactsSection),
        theme.Sections.register("page-guide", theme.PageGuideSection),
        theme.Sections.register("cancel-order", theme.CancelOrderSection),
        theme.Sections.register("modify-delivery", theme.ModifyDeliverySection),
        theme.Sections.register("warranty-claim", theme.WarrantyClaimSection),
        theme.Sections.register("return-order", theme.ReturnOrderSection),
        theme.Sections.register("price-match", theme.PriceMatchSection),
        theme.Sections.register("product-compare", theme.ProductCompareSection),
        theme.Sections.register("shopping-guide", theme.ShoppingGuideSection),
        theme.Sections.register(
          "projector-calculator",
          theme.ProjectorCalculatorSection
        ),
        theme.Sections.register(
          "vertical-fold-text",
          theme.VerticalFoldTextSection
        ),
        theme.Sections.register(
          "short-video-carousel",
          theme.ShortVideoCarouselSection
        ),
        theme.Sections.register("mogo3pro", theme.Mogo3proSection),
        theme.Sections.register("blog-index", theme.BlogIndexSection),
        theme.Sections.register(
          "sale-navigation-bar",
          theme.SaleNavigationBarSection
        ),
        theme.Sections.register(
          "discount-code-bar",
          theme.DiscountCodebarSection
        );
    }),
    $(function ($2) {
      cc.sections.length
        ? cc.sections.forEach((section) => {
            try {
              var data = {};
              typeof section.deferredLoad < "u" &&
                (data.deferredLoad = section.deferredLoad),
                typeof section.deferredLoadViewportExcess < "u" &&
                  (data.deferredLoadViewportExcess =
                    section.deferredLoadViewportExcess),
                theme.Sections.register(section.name, section.section, data);
            } catch (err) {
              console.error(
                "Unable to register section ".concat(section.name, "."),
                err
              );
            }
          })
        : console.warn("Barry: No common sections have been registered.");
    });
  const navigationItem = $(".navigation--desktop .navigation__item");
  navigationItem.each(function () {
    console.log($(this).find(".navigation__link"));
    if (
      ["Support", "Ayuda", "サポート"].includes(
        $(this).find(".navigation__link").html()
      )
    ) {
      $(this).addClass("navigation__item_support");
    }
  });
})(theme.jQuery);
//# sourceMappingURL=/s/files/1/0262/9838/4432/t/37/assets/theme.js.map?v=1734073958
